import React, { useContext, useState, useEffect } from 'react';
import HeaderForm from './headerform';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import GetAppIcon from '@mui/icons-material/GetApp';
import FormGroup from '@mui/material/FormGroup';
import CircularProgress from '@mui/material/CircularProgress';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import newlogos from '../assets/img/logo-new-jsry.png';
import athleimg from '../assets/img/athltics-img.png';
import infoimg from '../assets/img/information.png'
// import { Tooltip } from 'react-tooltip';
import Chip from '@mui/material/Chip';
import pamphlet1 from '../assets/img/pamphlet1.pdf';
import Physician from '../assets/img/Physician_Clearance_form.pdf';
import Evaluation from '../assets/img/Physician_Form_Evaluation_form.pdf';
import pamphlet2 from '../assets/img/pamphlet2.pdf';
import Factsheet from '../assets/img/opiod_use_misuse_factsheet1.pdf';
import PPEMedical from '../assets/img/PPEMedicalEligibilityForm.pdf';
import axios from 'axios';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
// import Button from '@mui/material/Button';
// import Tooltip from '@mui/material/Tooltip';
import Autocomplete from '@mui/material/Autocomplete';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import InfoIcon from '@mui/icons-material/Info';

import {
  Navigate,
  Link,
  NavLink,
  useNavigate,
  useParams
} from "react-router-dom";
import { AppContext } from '../context';
import { holdUser } from "../features/userdataSlice";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

// modal code start

import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import CloseIcon from "@mui/icons-material/Close";
// import { Link, useNavigate } from "react-router-dom";
// import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import DialogContent from '@mui/material/DialogContent';
import Applicationstatus from './applicationstatus';
import Timer from './Timer';
import secureLocalStorage from "react-secure-storage";


// modal code end

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}


function sentenceCase(str) {
  if ((str === null) || (str === ''))
    return false;
  else
    str = str.toString();

  return str.replace(/\w\S*/g,
    function (txt) {
      return txt.charAt(0).toUpperCase() +
        txt.substr(1).toLowerCase();
    });
}
function userExists(arr, form_id) {
  return arr.some(function (el) {
    return el.form_id === form_id;
  });
}
function pdfExists(arr, document) {
  return arr.some(function (el) {
    return el.document === document;
  });
}

function formatDate(date, format = null) {
  const myArray = date.split("-");
  var d = new Date(date);
  var month = myArray[1];
  var day = myArray[2];
  var year = myArray[0];
  var daten = month + '/' + day + '/' + year;
  // if (month.length < 2) month = '0' + month;
  // if (day.length < 2) day = '0' + day;

  // if (format && format == 'Y-m-d') return [month, day, year].join('-');
  // else return [month, day, year].join('-');
  return daten;
}
function ageCalculator(dob) {
  var userinput = dob;
  var dob = new Date(userinput);
  if (userinput == null || userinput == '') {
    document.getElementById("message").innerHTML = "**Choose a date Please!";
    return false;
  } else {

    //calculate month difference from current date in time  
    var month_diff = Date.now() - dob.getTime();

    //convert the calculated difference in date format  
    var age_dt = new Date(month_diff);

    //extract year from date      
    var year = age_dt.getUTCFullYear();

    //now calculate the age of the user  
    var age = Math.abs(year - 1970);

    //display the calculated age  
    return age;
  }
}
function Forms() {
  const [expanded, setExpanded] = React.useState(false);
  const [ipuser, setIpuser] = useState(null);
  const handleChange = (panel) => (event, isExpanded) => {
    console.log(isExpanded);
    console.log(panel);
    setExpanded(isExpanded ? panel : false);
  };

  const [expandednew, setExpandednew] = React.useState(false);

  const handleChangenew = (panel) => (event, isExpanded) => {
    setExpandednew(isExpanded ? panel : false);
    // if(panel!='panel4f'){
    //   setExpandednew(isExpanded ? panel : false);
    // }else{

    //   if(isExpanded==false && panel=='panel4f'){
    //     setExpandednew( false);
    //   }else{
    //     if(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 4) == true){
    //       setExpandednew(isExpanded ? panel : false);
    //     }else{
    //       setOpenLogaccspecial(true);
    //       setCheckprfspecial(false);
    //     }
    //   }

    // }


  };
  const [openLogaccspecial, setOpenLogaccspecial] = React.useState(false);
  const [valueaccspecial, setAalueaccspecial] = React.useState('');
  const handleOpenLogaccbspecial = () => setOpenLogaccspecial(true);
  const handleCloselogaccbspecial = () => setOpenLogaccspecial(false);
  const [inputValue, setInputValue] = useState('');  // Control the input value
  const [inputLoadValue, setInputLoadValue] = useState(false);  // Control the input value

  const [locations, setLocations] = React.useState(false);
  const [openseleauto, setOpenseleauto] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [mainsearchValue, setmainSearchValue] = useState('');


  const handleAutocompleteChange = (value) => {
    console.log(value);
    if (value != null) {
      setmainSearchValue(value.location_id);
      setCheckdiss(true);
    } else {
      setmainSearchValue('');
      setCheckdiss(false);
    }
    setInputLoadValue(true);
    setSearchValue(value);
  }

  const handleAutocompleteChangenew = () => {
    setmainSearchValue('');
    setCheckdiss(false);
    setInputLoadValue(true);
    setSearchValue(null);
  }

  const [checkprfspecial, setCheckprfspecial] = React.useState(false);
  const handleChangecheckprspecial = (event) => {
    setExpandednew('panel4f');
    setOpenLogaccspecial(false);
    if (checkprfspecial == false) {
      setCheckprfspecial(true);
    } else if (checkprfspecial == true) {
      setCheckprfspecial(false);
    }
  }

  const handleEditspecial = (val) => {

    setExpandednew('panel4f');
    setCheckprfspecial(false);
    setOpenLogaccspecial(false);
  }

  const [openLog, setOpenLog] = React.useState(false);
  const handleOpenLog = () => setOpenLog(true);
  const handleCloselog = () => setOpenLog(false);


  const [opencheckLog, setOpencheckLog] = React.useState(false);
  const handleOpenCheckLog = () => setOpencheckLog(true);
  const handleCloseChecklog = () => setOpencheckLog(false);


  const [checkprf, setCheckprf] = React.useState(false);
  const [formDate, setformDate] = useState("");
  const [allstudentlisdata, setAllstudentlisdata] = useState([]);

  const { storage } = useContext(AppContext);

  const [showOrder, setShowOrder] = useState(false);
  const [userData, setuserData] = useState('');
  const dispatch = useDispatch();
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loader, setLoader] = useState(false);
  const { dispatchStorageEvent } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [datefir, setDatefir] = useState('');
  const [datesec, setDatesec] = useState('');
  const [dateth, setDateth] = useState('');
  const [datefor, setDatefor] = useState('');

  const [datefif, setDatefif] = useState('');
  const [datesix, setDatesix] = useState('');
  const [dateseven, setDateseven] = useState('');
  const [dateeight, setDateeight] = useState('');
  const [isTimerComplete, setIsTimerComplete] = useState(false);
  const [openAllDownload, setOpenAllDownload] = useState(false);
  const phoneValidChars = /^[+\d\s()-]*$/;

  const Axios = axios.create({
    baseURL: storage[0].backEndUrl
    // baseURL: process.env.REACT_APP_ENV_URL
  });
  let navigate = useNavigate();

  const handleTimerComplete = () => {
    setIsTimerComplete(true);
  }

  var firstform_default = {
    consent: '',

    consent_error: false,

    parent_signature: '',

    parent_signature_error: false,
    parent_name: '',

    parent_name_error: false,
    student_signature: '',

    student_signature_error: false,
    student_name: '',

    student_name_error: false,

    address: '',

    address_error: false,


    primary: '',

    primary_error: false,

    relationship_primary: '',

    relationship_primary_error: false,
    secondary: '',

    secondary_error: false,

    relationship_secondary: '',

    relationship_secondary_error: false,
    physican_name: '',

    physican_name_error: false,
    physican_phone: '',

    physican_phone_error: false,
    physican_address: '',

    physican_address_error: false,
    no_physican: false,

    no_physican_error: false,


  };
  const handleChangecheckpr = (event) => {
    if (checkprf == false) {
      setCheckprf(true);
    } else if (checkprf == true) {
      setCheckprf(false);
    }
  }

  const [firstformInfo, setFirstforminInfo] = useState(firstform_default);
  const handleChangeFirst = (event) => {
    var user_temp = { ...firstformInfo };
    setSuccessMsgFirst('');
    setErrorMsgFirst('');
    user_temp.consent_error = false;
    user_temp.parent_signature_error = false;
    user_temp.parent_name_error = false;
    user_temp.student_signature_error = false;
    user_temp.student_name_error = false;
    user_temp.address_error = false;
    user_temp.primary_error = false;
    user_temp.relationship_primary_error = false;
    user_temp.secondary_error = false;
    user_temp.relationship_secondary_error = false;
    user_temp.physican_name_error = false;
    user_temp.physican_phone_error = false;
    user_temp.physican_address_error = false;
    user_temp.no_physican_error = false;


    if (event.target.name == "consent") {
      user_temp.consent = event.target.value;

    }
    if (event.target.name == "parent_signature") {
      user_temp.parent_signature = event.target.value;

    }


    if (event.target.name == "parent_name") {
      user_temp.parent_name = event.target.value;

    }
    if (event.target.name == "student_signature") {
      user_temp.student_signature = event.target.value;

    }
    if (event.target.name == "student_name") {
      user_temp.student_name = event.target.value;

    }
    if (event.target.name == "address") {
      user_temp.address = event.target.value;

    }
    if (event.target.name == "primary") {
      if (event.target.value == '' || phoneValidChars.test(event.target.value)) {
        user_temp.primary = event.target.value;
      }

    }
    if (event.target.name == "relationship_primary") {
      user_temp.relationship_primary = event.target.value;

    }
    if (event.target.name == "secondary") {
      if (event.target.value == '' || phoneValidChars.test(event.target.value)) {
        user_temp.secondary = event.target.value;
      }

    }
    if (event.target.name == "relationship_secondary") {
      user_temp.relationship_secondary = event.target.value;

    }

    if (event.target.name == "physican_name") {
      user_temp.physican_name = event.target.value;

    }
    if (event.target.name == "physican_phone") {
      if (event.target.value == '' || phoneValidChars.test(event.target.value)) {
        user_temp.physican_phone = event.target.value;
      }

    }
    if (event.target.name == "physican_address") {
      user_temp.physican_address = event.target.value;

    }

    if (event.target.name == "no_physican") {

      if (user_temp.no_physican == true) {
        user_temp.no_physican = false;

      } else if (user_temp.no_physican == false) {
        user_temp.no_physican = true;

      }

    }

    console.log(user_temp.no_physican);

    secureLocalStorage.setItem("alldatafirstform", JSON.stringify(user_temp));

    secureLocalStorage.setItem("oldstudid", (userData.stuid));
    setFirstforminInfo(user_temp);





  }

  var secondform_default = {
    parent: '',

    parent_error: false,

    sports: '',

    sports_error: false,
    covid_diagnose: '',

    covid_diagnose_error: false,
    covid_symptomatic: '',

    covid_symptomatic_error: false,
    covid_hospitalized: '',

    covid_hospitalized_error: false,

    covid_household: '',

    covid_household_error: false,


    parent_signature: '',

    parent_signature_error: false,




  };

  const [secondformInfo, setSecondforminInfo] = useState(secondform_default);

  const handleChangeSecond = (event) => {
    var user_temp = { ...secondformInfo };
    setSuccessMsgSecond('');
    setErrorMsgSecond('');
    user_temp.parent_error = false;
    user_temp.sports_error = false;
    user_temp.covid_diagnose_error = false;
    user_temp.covid_symptomatic_error = false;
    user_temp.covid_hospitalized_error = false;
    user_temp.covid_household_error = false;
    user_temp.parent_signature_error = false;



    if (event.target.name == "parent") {
      if (event.target.value == '' || phoneValidChars.test(event.target.value)) {
        user_temp.parent = event.target.value;
      }

    }
    if (event.target.name == "sports") {
      user_temp.sports = event.target.value;

    }


    if (event.target.name == "covid_diagnose") {
      user_temp.covid_diagnose = event.target.value;

    }
    if (event.target.name == "covid_symptomatic") {
      user_temp.covid_symptomatic = event.target.value;

    }
    if (event.target.name == "covid_hospitalized") {
      user_temp.covid_hospitalized = event.target.value;

    }
    if (event.target.name == "covid_household") {
      user_temp.covid_household = event.target.value;

    }
    if (event.target.name == "parent_signature") {
      user_temp.parent_signature = event.target.value;

    }




    secureLocalStorage.setItem("alldatasecondform", JSON.stringify(user_temp));

    secureLocalStorage.setItem("oldstudid", (userData.stuid));
    setSecondforminInfo(user_temp);





  }



  var tenform_default = {
    athlete_signature: '',

    athlete_signature_error: false,
    athlete_name: '',

    athlete_name_error: false,
    parent_signature: '',

    parent_signature_error: false,

    parent_name: '',

    parent_name_error: false,


  }
  const [tenformInfo, setTenforminInfo] = useState(tenform_default);


  const handleChangeTen = (event) => {
    var user_temp = { ...tenformInfo };
    setSuccessMsgTen('');
    setErrorMsgTen('');
    user_temp.athlete_signature_error = false;
    user_temp.athlete_name_error = false;
    user_temp.parent_signature_error = false;
    user_temp.parent_name_error = false;


    if (event.target.name == "athlete_signature") {
      user_temp.athlete_signature = event.target.value;

    }
    if (event.target.name == "athlete_name") {
      user_temp.athlete_name = event.target.value;

    }
    if (event.target.name == "parent_signature") {
      user_temp.parent_signature = event.target.value;

    }
    if (event.target.name == "parent_name") {
      user_temp.parent_name = event.target.value;

    }

    secureLocalStorage.setItem("alldatatenform", JSON.stringify(user_temp));

    secureLocalStorage.setItem("oldstudid", (userData.stuid));
    setTenforminInfo(user_temp);





  }

  var ninethform_default = {
    athlete_signature: '',

    athlete_signature_error: false,

    parent_signature: '',

    parent_signature_error: false,



  }




  const [nineformInfo, setNineforminInfo] = useState(ninethform_default);


  const handleChangeNine = (event) => {
    var user_temp = { ...nineformInfo };

    setSuccessMsgNine('');
    setErrorMsgNine('');
    user_temp.athlete_signature_error = false;

    user_temp.parent_signature_error = false;



    if (event.target.name == "athlete_signature") {
      user_temp.athlete_signature = event.target.value;

    }

    if (event.target.name == "parent_signature") {
      user_temp.parent_signature = event.target.value;

    }

    secureLocalStorage.setItem("alldatanineform", JSON.stringify(user_temp));

    secureLocalStorage.setItem("oldstudid", (userData.stuid));
    setNineforminInfo(user_temp);





  }


  var eightthform_default = {
    school_district: '',

    school_district_error: false,
    athlete_signature: '',

    athlete_signature_error: false,

    parent_signature: '',

    parent_signature_error: false,



  }




  const [eightformInfo, setEightforminInfo] = useState(eightthform_default);


  const handleChangeEight = (event) => {
    var user_temp = { ...eightformInfo };
    setSuccessMsgEight('');
    setErrorMsgEight('');
    user_temp.school_district_error = false;

    user_temp.athlete_signature_error = false;

    user_temp.parent_signature_error = false;

    if (event.target.name == "school_district") {
      user_temp.school_district = event.target.value;

    }

    if (event.target.name == "athlete_signature") {
      user_temp.athlete_signature = event.target.value;

    }

    if (event.target.name == "parent_signature") {
      user_temp.parent_signature = event.target.value;

    }

    secureLocalStorage.setItem("alldataeightform", JSON.stringify(user_temp));

    secureLocalStorage.setItem("oldstudid", (userData.stuid));
    setEightforminInfo(user_temp);





  }
  var seventhform_default = {
    school_district: '',

    school_district_error: false,
    athlete_signature: '',

    athlete_signature_error: false,

    parent_signature: '',

    parent_signature_error: false,



  }




  const [sevenformInfo, setSevenforminInfo] = useState(seventhform_default);


  const handleChangeSeven = (event) => {
    var user_temp = { ...sevenformInfo };
    setSuccessMsgSeven('');
    setErrorMsgSeven('');
    user_temp.school_district_error = false;

    user_temp.athlete_signature_error = false;

    user_temp.parent_signature_error = false;

    if (event.target.name == "school_district") {
      user_temp.school_district = event.target.value;

    }

    if (event.target.name == "athlete_signature") {
      user_temp.athlete_signature = event.target.value;

    }

    if (event.target.name == "parent_signature") {
      user_temp.parent_signature = event.target.value;

    }

    secureLocalStorage.setItem("alldatasevenform", JSON.stringify(user_temp));

    secureLocalStorage.setItem("oldstudid", (userData.stuid));
    setSevenforminInfo(user_temp);





  }

  var sixform_default = {
    athlete_signature: '',

    athlete_signature_error: false,
    athlete_name: '',

    athlete_name_error: false,
    parent_signature: '',

    parent_signature_error: false,

    parent_name: '',

    parent_name_error: false,


  }
  const [sixformInfo, setSixforminInfo] = useState(sixform_default);


  const handleChangeSix = (event) => {
    var user_temp = { ...sixformInfo };
    setSuccessMsgSix('');
    setErrorMsgSix('');
    user_temp.athlete_signature_error = false;
    user_temp.athlete_name_error = false;
    user_temp.parent_signature_error = false;
    user_temp.parent_name_error = false;


    if (event.target.name == "athlete_signature") {
      user_temp.athlete_signature = event.target.value;

    }
    if (event.target.name == "athlete_name") {
      user_temp.athlete_name = event.target.value;

    }
    if (event.target.name == "parent_signature") {
      user_temp.parent_signature = event.target.value;

    }
    if (event.target.name == "parent_name") {
      user_temp.parent_name = event.target.value;

    }

    secureLocalStorage.setItem("alldatasixform", JSON.stringify(user_temp));

    secureLocalStorage.setItem("oldstudid", (userData.stuid));
    setSixforminInfo(user_temp);





  }


  React.useEffect(() => {

    if (document.body.classList.contains('body_bg')) {
      document.body.classList.remove('body');

    }
    document.body.classList.add('body_bg');
    axios.get("https://ipinfo.io/json")
      .then(res => {

        setIpuser(res.data.ip);



      }).catch(err => {

      })


    var userid = secureLocalStorage.getItem('userlogin');;
    var userdata = JSON.parse(secureLocalStorage.getItem('userdata'));

    // console.log(JSON.parse(secureLocalStorage.getItem('userdata')));
    if (userid == null || userdata == null || userdata == undefined) {


      navigate(`/`);

    } else {
      var res = JSON.parse(secureLocalStorage.getItem('userdata'));
      setLocations((secureLocalStorage.getItem('allloactions')));
      // console.log((secureLocalStorage.getItem('allloactions')));
      var olduserd = secureLocalStorage.getItem('oldstudid');;
      console.log(olduserd);
      if (olduserd == res.stuid) {
        console.log(olduserd);

        console.log(JSON.parse(secureLocalStorage.getItem('alldatafirstform')));
        if (JSON.parse(secureLocalStorage.getItem('alldatafirstform')) != null && JSON.parse(secureLocalStorage.getItem('alldatafirstform')) != undefined) {
          setFirstforminInfo(JSON.parse(secureLocalStorage.getItem('alldatafirstform')));
        }
        if (JSON.parse(secureLocalStorage.getItem('alldatasecondform')) != null && JSON.parse(secureLocalStorage.getItem('alldatasecondform')) != undefined) {
          setSecondforminInfo(JSON.parse(secureLocalStorage.getItem('alldatasecondform')));
        }


        if (JSON.parse(secureLocalStorage.getItem('alldatatenform')) != null && JSON.parse(secureLocalStorage.getItem('alldatatenform')) != undefined) {
          setTenforminInfo(JSON.parse(secureLocalStorage.getItem('alldatatenform')));
        }


        if (JSON.parse(secureLocalStorage.getItem('alldatanineform')) != null && JSON.parse(secureLocalStorage.getItem('alldatanineform')) != undefined) {
          setNineforminInfo(JSON.parse(secureLocalStorage.getItem('alldatanineform')));
        }

        if (JSON.parse(secureLocalStorage.getItem('alldataeightform')) != null && JSON.parse(secureLocalStorage.getItem('alldataeightform')) != undefined) {
          setEightforminInfo(JSON.parse(secureLocalStorage.getItem('alldataeightform')));
        }

        if (JSON.parse(secureLocalStorage.getItem('alldatathirdform')) != null && JSON.parse(secureLocalStorage.getItem('alldatathirdform')) != undefined) {
          setThirdforminInfo(JSON.parse(secureLocalStorage.getItem('alldatathirdform')));
        }

        if (JSON.parse(secureLocalStorage.getItem('alldatasevenform')) != null && JSON.parse(secureLocalStorage.getItem('alldatasevenform')) != undefined) {
          setSevenforminInfo(JSON.parse(secureLocalStorage.getItem('alldatasevenform')));
        }
        if (JSON.parse(secureLocalStorage.getItem('alldatafifthform')) != null && JSON.parse(secureLocalStorage.getItem('alldatafifthform')) != undefined) {
          setFifthforminInfo(JSON.parse(secureLocalStorage.getItem('alldatafifthform')));
        }

        if (JSON.parse(secureLocalStorage.getItem('alldataforthform')) != null && JSON.parse(secureLocalStorage.getItem('alldataforthform')) != undefined) {
          setForthforminInfo(JSON.parse(secureLocalStorage.getItem('alldataforthform')));
        }

        if (JSON.parse(secureLocalStorage.getItem('alldatasixform')) != null && JSON.parse(secureLocalStorage.getItem('alldatasixform')) != undefined) {
          setSixforminInfo(JSON.parse(secureLocalStorage.getItem('alldatasixform')));
        }
      }



      if (JSON.parse(secureLocalStorage.getItem('studenentformdata')) != null && JSON.parse(secureLocalStorage.getItem('studenentformdata')) != undefined) {
        setAllstudentlisdata(JSON.parse(secureLocalStorage.getItem('studenentformdata')));
      }
      res.student_name = (sentenceCase(res.student_name));
      res.last_name = (sentenceCase(res.last_name));
      setuserData(res);

      // setuserData(JSON.parse(secureLocalStorage.getItem('userdata')));

    }

    console.log('allstudentlisdata', JSON.parse(secureLocalStorage.getItem('studenentformdata')))

    var date = new Date();



    let day = date.getDate().toString().padStart(2, "0");
    let month = (date.getMonth() + 1).toString().padStart(2, "0");
    let year = date.getFullYear().toString();
    let fromDate = `${day}-${month}-${year}`;
    let fDate = `${month}/${day}/${year}`;
    setDatefir(month.charAt(0));
    setDatesec(month.charAt(1));

    setDateth(day.charAt(0));
    setDatefor(day.charAt(1));
    setDatefif(year.charAt(0));
    setDatesix(year.charAt(1));
    setDateseven(year.charAt(2));
    setDateeight(year.charAt(3));

    setformDate(fDate);
  }, []);
  const [opendischolllog, setOpendischolllog] = React.useState(false);

  const handleOpendischolllog = () => setOpendischolllog(true);
  const handleClosedischolllog = () => {
    setOpendischolllog(false);
    setCheckdiss(false);
    setInputLoadValue(false);
  };
  const [checkdiss, setCheckdiss] = React.useState(false);

  const [submitch, setSubmitch] = React.useState('');



  const [successMsgFirst, setSuccessMsgFirst] = useState('');
  const [errorMsgFirst, setErrorMsgFirst] = useState('');

  const [parentLoaderFirst, setparentLoaderFirst] = useState(false);

  const handleSubmitFirst = (event) => {
 
    setSuccessMsgFirst('');
    setErrorMsgFirst('');
    var user_temp = { ...firstformInfo };
    user_temp.consent_error = false;
    user_temp.parent_signature_error = false;
    user_temp.parent_name_error = false;
    user_temp.student_signature_error = false;
    user_temp.student_name_error = false;
    user_temp.address_error = false;
    user_temp.primary_error = false;
    user_temp.relationship_primary_error = false;
    user_temp.secondary_error = false;
    user_temp.relationship_secondary_error = false;
    user_temp.physican_name_error = false;
    user_temp.physican_phone_error = false;
    user_temp.physican_address_error = false;
    user_temp.no_physican_error = false;


    if (user_temp.consent == '') {
      user_temp.consent_error = true;
      setFirstforminInfo(user_temp);
      setErrorMsgFirst('Please enter consent name'); return false;
    }

    if (user_temp.parent_signature == '') {
      user_temp.parent_signature_error = true;
      setFirstforminInfo(user_temp);

      setErrorMsgFirst('Please enter parent/guardian signature!'); return false;
    }
    if (user_temp.parent_name == '') {
      user_temp.parent_name_error = true;
      setFirstforminInfo(user_temp);
      setErrorMsgFirst('Please enter parent/guardian print name!'); return false;
    }

    if (user_temp.student_signature == '') {
      user_temp.student_signature_error = true;
      setFirstforminInfo(user_temp);
      setErrorMsgFirst('Please enter student signature!'); return false;
    }

    if (user_temp.student_name == '') {
      user_temp.student_name_error = true;
      setFirstforminInfo(user_temp);
      setErrorMsgFirst('Please enter student print name!'); return false;
    }

    if (user_temp.address == '') {
      user_temp.address_error = true;
      setFirstforminInfo(user_temp);
      setErrorMsgFirst('Please enter student address!'); return false;
    }

    if (user_temp.primary == '') {
      user_temp.primary_error = true;
      setFirstforminInfo(user_temp);

      setErrorMsgFirst('Please enter emergency details!'); return false;
    }


    if (user_temp.relationship_primary == '') {
      user_temp.relationship_primary_error = true;
      setFirstforminInfo(user_temp);
      setErrorMsgFirst('Please enter emergency details!'); return false;
    }


    if (user_temp.secondary == '') {
      user_temp.secondary_error = true;
      setFirstforminInfo(user_temp);
      setErrorMsgFirst('Please enter emergency details!'); return false;
    }

    if (user_temp.relationship_secondary == '') {
      user_temp.relationship_secondary_error = true;
      setFirstforminInfo(user_temp);
      setErrorMsgFirst('Please enter emergency details!'); return false;
    }

    if ((user_temp.physican_address == ''

      && user_temp.physican_phone == ''
      && user_temp.physican_name
    )) {
      console.log(user_temp.physican_address);
      console.log(user_temp.physican_name);

      console.log(user_temp.physican_phone);

      user_temp.no_physican_error = true;
      setFirstforminInfo(user_temp); return false;
    }
    if (user_temp.physican_name == '' && user_temp.no_physican == false) {
      user_temp.physican_name_error = true;
      setFirstforminInfo(user_temp);
      setErrorMsgFirst('Please enter physician name!'); return false;
    }

    if (user_temp.physican_phone == '' && user_temp.no_physican == false) {
      user_temp.physican_phone_error = true;
      setFirstforminInfo(user_temp);
      setErrorMsgFirst('Please enter physician phone number!'); return false;
    }

    if (user_temp.physican_address == '' && user_temp.no_physican == false) {
      user_temp.physican_address_error = true;
      setFirstforminInfo(user_temp);
      setErrorMsgFirst('Please enter  physician address:!'); return false;
    }

    if (userData != null && userData.locat_up == "0" && (checkdiss == false)) {
      setSubmitch('first');
      var resultnew = locations.map(function (el) {
        var o = Object.assign({}, el);
        if (userData.location_at_id == o.location_id) {
          setmainSearchValue(o.location_id);
          setInputValue(o);
          setCheckdiss(true);
          setSearchValue(o);


          setTimeout(function () {
            setOpendischolllog(true);
          }, 500);

          return false;

        }


        //return o;
      });

      return false;
    } else {
      setOpendischolllog(false);
    }


    setparentLoaderFirst(true);
    setOpenLog(true);
    Axios.post(`/pdf_form_submit`, { studid: userData.stuid, id: 1, formdata: user_temp, ip_address: ipuser, newlocation: mainsearchValue })
      .then(res => {
        console.log(res.data);

        if (res.data.status == true) {

          secureLocalStorage.setItem("userdata", JSON.stringify(res.data.studentdetalis));

          var arrst = [];
          var docnew = {};
          var resultnew = res.data.studentdata.map(function (el) {
            var o = Object.assign({}, el);
            if (o.form_id == 1) {
              docnew = o;

            }


            //return o;
          });
          console.log(docnew);
          console.log(allstudentlisdata);
          if (allstudentlisdata.length > 0) {
            arrst.push(docnew);
            var resultk = allstudentlisdata.map(function (el) {
              var ou = Object.assign({}, el);

              if (ou.form_id != 1) {


                arrst.push(ou);
              } else {

              }

              console.log(allstudentlisdata);
              console.log(ou);

              return ou;
            });
          } else {
            arrst.push(docnew);
          }

          console.log(arrst);
          setAllstudentlisdata(arrst);
          secureLocalStorage.setItem("studenentformdata", JSON.stringify(arrst));


          // secureLocalStorage.setItem("studenentformdata", JSON.stringify(res.data.studentdata));
          // setAllstudentlisdata(res.data.studentdata);
          setparentLoaderFirst(false);
          setSuccessMsgFirst('Form Submitted Successfully');
          setTimeout(function () {
            setSuccessMsgFirst('');
            setErrorMsgFirst('');
            setOpenLog(false);
          }, 1000);

        }
        else {

          setErrorMsgFirst(res.data.data);
          setparentLoaderFirst(false);
        }

      })
      .catch(error => {
        setErrorMsgFirst('Network Connection Problem, please try again!');
        setparentLoaderFirst(false);

      });

  }


  const [successMsgSecond, setSuccessMsgSecond] = useState('');
  const [errorMsgSecond, setErrorMsgSecond] = useState('');

  const [parentLoaderSecond, setparentLoaderSecond] = useState(false);

  const handleSubmitSecond = (event) => {

    setSuccessMsgSecond('');
    setErrorMsgSecond('');
    var user_temp = { ...secondformInfo };
    user_temp.parent_error = false;
    user_temp.sports_error = false;
    user_temp.covid_diagnose_error = false;
    user_temp.covid_symptomatic_error = false;
    user_temp.covid_hospitalized_error = false;
    user_temp.covid_household_error = false;
    user_temp.parent_signature_error = false;


    if (user_temp.parent == '') {
      user_temp.parent_error = true;
      setSecondforminInfo(user_temp);
      setErrorMsgSecond('Please enter parent/guardian Cell'); return false;
    }

    if (user_temp.sports == '') {
      user_temp.sports_error = true;
      setSecondforminInfo(user_temp);

      setErrorMsgSecond('Please enter sports name!'); return false;
    }
    if (user_temp.covid_diagnose == '') {
      user_temp.covid_diagnose_error = true;
      setSecondforminInfo(user_temp);
      setErrorMsgSecond('Please select has your son/daughter been diagnosed with coronavirus (COVID-19)?!'); return false;
    }

    if (user_temp.covid_symptomatic == '') {
      user_temp.covid_symptomatic_error = true;
      setSecondforminInfo(user_temp);
      setErrorMsgSecond('Please select if diagnosed with coronavirus (COVID-19), was your son/daughter symptomatic?!'); return false;
    }

    if (user_temp.covid_hospitalized == '') {
      user_temp.covid_hospitalized_error = true;
      setSecondforminInfo(user_temp);
      setErrorMsgSecond('Please select if diagnosed with coronavirus (COVID-19), was your son/daughter hospitalized?!'); return false;
    }

    if (user_temp.covid_household == '') {
      user_temp.covid_household_error = true;
      setSecondforminInfo(user_temp);
      setErrorMsgSecond("Please select has any member of the student-athlete's household been diagnosed with Coronavirus (COVID-19)?!"); return false;
    }

    if (user_temp.parent_signature == '') {
      user_temp.parent_signature_error = true;
      setSecondforminInfo(user_temp);

      setErrorMsgSecond('Please enter signature of parent/guardian!'); return false;
    }

    if (userData != null && userData.locat_up == "0" && (checkdiss == false)) {
      setSubmitch('second');
      var resultnew = locations.map(function (el) {
        var o = Object.assign({}, el);
        if (userData.location_at_id == o.location_id) {
          setmainSearchValue(o.location_id);
          setInputValue(o);
           setCheckdiss(true);
          setSearchValue(o);
          setTimeout(function () {
            setOpendischolllog(true);
          }, 500);
          return false;

        }


        //return o;
      });

      return false;
    } else {
      setOpendischolllog(false);
    }


    setOpenLog(true);
    setparentLoaderSecond(true);

    Axios.post(`/pdf_form_submit`, { studid: userData.stuid, id: 2, formdata: user_temp, ip_address: ipuser, newlocation: mainsearchValue })
      .then(res => {
        console.log(res.data);

        if (res.data.status == true) {
          secureLocalStorage.setItem("userdata", JSON.stringify(res.data.studentdetalis));

          console.log(res.data.data);
          var arrst = [];
          var docnew = {};
          var resultnew = res.data.studentdata.map(function (el) {
            var o = Object.assign({}, el);
            if (o.form_id == 2) {
              docnew = o;

            }


            //return o;
          });
          console.log(docnew);
          console.log(allstudentlisdata);
          if (allstudentlisdata.length > 0) {
            arrst.push(docnew);
            var resultk = allstudentlisdata.map(function (el) {
              var ou = Object.assign({}, el);

              if (ou.form_id != 2) {


                arrst.push(ou);
              } else {

              }

              console.log(allstudentlisdata);
              console.log(ou);

              return ou;
            });
          } else {
            arrst.push(docnew);
          }

          console.log(arrst);
          setAllstudentlisdata(arrst);
          secureLocalStorage.setItem("studenentformdata", JSON.stringify(arrst));

          // storage[0].userdata = res.data.data;
          // secureLocalStorage.setItem("studenentformdata", JSON.stringify(res.data.studentdata));
          // setAllstudentlisdata(res.data.studentdata);
          setparentLoaderSecond(false);
          setSuccessMsgSecond('Form Submitted Successfully');
          setOpenLog(false);
          setTimeout(function () {

            setSuccessMsgSecond('');
            setErrorMsgSecond('');

          }, 1000);

        }
        else {

          setErrorMsgSecond(res.data.data);
          setparentLoaderSecond(false);
        }

      })
      .catch(error => {
        setErrorMsgSecond('Network Connection Problem, please try again!');
        setparentLoaderSecond(false);

      });

  }

  const [successMsgTen, setSuccessMsgTen] = useState('');
  const [errorMsgTen, setErrorMsgTen] = useState('');

  const [parentLoaderTen, setparentLoaderTen] = useState(false);

  const handleSubmitTen = (event) => {

    setSuccessMsgTen('');
    setErrorMsgTen('');
    var user_temp = { ...tenformInfo };
    user_temp.athlete_signature_error = false;
    user_temp.athlete_name_error = false;
    user_temp.parent_signature_error = false;
    user_temp.parent_name_error = false;


    if (user_temp.athlete_signature == '') {
      user_temp.athlete_signature_error = true;
      setTenforminInfo(user_temp);
      setErrorMsgTen('Please enter signature of student-athlete'); return false;
    }

    if (user_temp.athlete_name == '') {
      user_temp.athlete_name_error = true;
      setTenforminInfo(user_temp);

      setErrorMsgTen("Please enter print student-athlete's name!"); return false;
    }
    if (user_temp.parent_signature == '') {
      user_temp.parent_signature_error = true;
      setTenforminInfo(user_temp);
      setErrorMsgTen('Please signature of parent/guardian'); return false;
    }

    if (user_temp.parent_name == '') {
      user_temp.parent_name_error = true;
      setTenforminInfo(user_temp);
      setErrorMsgTen("Please enter print parent/guardian's name"); return false;
    }



    if (userData != null && userData.locat_up == "0" && (checkdiss == false)) {
      setSubmitch('ten');
      console.log(userData.locat_up);
      console.log(locations);
      var resultnew = locations.map(function (el) {
        var o = Object.assign({}, el);
        if (userData.location_at_id == o.location_id) {
          setmainSearchValue(o.location_id);
          setInputValue(o);
         

 setCheckdiss(true);
          setSearchValue(o);
         setTimeout(function () {
            setOpendischolllog(true);
          }, 500);
          return false;

        }


        //return o;
      });

      return false;
    } else {
      setOpendischolllog(false);
    }

    setparentLoaderTen(true);
    setOpenLog(true);
    Axios.post(`/pdf_form_submit`, { studid: userData.stuid, id: 10, formdata: user_temp, ip_address: ipuser, newlocation: mainsearchValue })
      .then(res => {
        console.log(res.data);

        if (res.data.status == true) {
          secureLocalStorage.setItem("userdata", JSON.stringify(res.data.studentdetalis));

          console.log(res.data.data);

          var arrst = [];
          var docnew = {};
          var resultnew = res.data.studentdata.map(function (el) {
            var o = Object.assign({}, el);
            if (o.form_id == 10) {
              docnew = o;

            }


            //return o;
          });
          console.log(docnew);
          console.log(allstudentlisdata);
          if (allstudentlisdata.length > 0) {
            arrst.push(docnew);
            var resultk = allstudentlisdata.map(function (el) {
              var ou = Object.assign({}, el);

              if (ou.form_id != 10) {


                arrst.push(ou);
              } else {

              }

              console.log(allstudentlisdata);
              console.log(ou);

              return ou;
            });
          } else {
            arrst.push(docnew);
          }

          console.log(arrst);
          setAllstudentlisdata(arrst);
          secureLocalStorage.setItem("studenentformdata", JSON.stringify(arrst));

          // storage[0].userdata = res.data.data;
          // secureLocalStorage.setItem("studenentformdata", JSON.stringify(res.data.studentdata));
          // setAllstudentlisdata(res.data.studentdata);
          setparentLoaderTen(false);
          setSuccessMsgTen('Form Submitted Successfully');
          setOpenLog(false);
          setTimeout(function () {
            setOpenLog(false);
            setSuccessMsgTen('');
            setErrorMsgTen('');

          }, 1000);

        }
        else {

          setErrorMsgTen(res.data.data);
          setparentLoaderTen(false);
        }

      })
      .catch(error => {
        setErrorMsgTen('Network Connection Problem, please try again!');
        setparentLoaderTen(false);

      });

  }

  const [successMsgNine, setSuccessMsgNine] = useState('');
  const [errorMsgNine, setErrorMsgNine] = useState('');

  const [parentLoaderNine, setparentLoaderNine] = useState(false);

  const handleSubmitNine = (event) => {

    setSuccessMsgNine('');
    setErrorMsgNine('');
    var user_temp = { ...nineformInfo };
    user_temp.athlete_signature_error = false;

    user_temp.parent_signature_error = false;



    if (user_temp.athlete_signature == '') {
      user_temp.athlete_signature_error = true;
      setNineforminInfo(user_temp);
      setErrorMsgNine('Please enter signature of student-athlete'); return false;
    }


    if (user_temp.parent_signature == '') {
      user_temp.parent_signature_error = true;
      setNineforminInfo(user_temp);
      setErrorMsgNine('Please signature of parent/guardian'); return false;
    }


    if (userData != null && userData.locat_up == "0" && (checkdiss == false)) {
      setSubmitch('nine');
      var resultnew = locations.map(function (el) {
        var o = Object.assign({}, el);
        if (userData.location_at_id == o.location_id) {
          setmainSearchValue(o.location_id);
          setInputValue(o);
   

 setCheckdiss(true);
          setSearchValue(o);
         setTimeout(function () {
            setOpendischolllog(true);
          }, 500);
          return false;

        }


        //return o;
      });

      return false;
    } else {
      setOpendischolllog(false);
    }

    setparentLoaderNine(true);
    setOpenLog(true);
    Axios.post(`/pdf_form_submit`, { studid: userData.stuid, id: 9, formdata: user_temp, ip_address: ipuser, newlocation: mainsearchValue })
      .then(res => {
        console.log(res.data);

        if (res.data.status == true) {
          secureLocalStorage.setItem("userdata", JSON.stringify(res.data.studentdetalis));

          console.log(res.data.data);
          var arrst = [];
          var docnew = {};
          var resultnew = res.data.studentdata.map(function (el) {
            var o = Object.assign({}, el);
            if (o.form_id == 9) {
              docnew = o;

            }


            //return o;
          });
          console.log(docnew);
          console.log(allstudentlisdata);
          if (allstudentlisdata.length > 0) {
            arrst.push(docnew);
            var resultk = allstudentlisdata.map(function (el) {
              var ou = Object.assign({}, el);

              if (ou.form_id != 9) {


                arrst.push(ou);
              } else {

              }

              console.log(allstudentlisdata);
              console.log(ou);

              return ou;
            });
          } else {
            arrst.push(docnew);
          }

          console.log(arrst);
          setAllstudentlisdata(arrst);
          secureLocalStorage.setItem("studenentformdata", JSON.stringify(arrst));

          // storage[0].userdata = res.data.data;
          // secureLocalStorage.setItem("studenentformdata", JSON.stringify(res.data.studentdata));
          // setAllstudentlisdata(res.data.studentdata);
          setparentLoaderNine(false);
          setSuccessMsgNine('Form Submitted Successfully');
          setOpenLog(false);
          setTimeout(function () {
            setOpenLog(false);
            setSuccessMsgNine('');
            setErrorMsgNine('');

          }, 1000);

        }
        else {

          setErrorMsgNine(res.data.data);
          setparentLoaderNine(false);
        }

      })
      .catch(error => {
        setErrorMsgNine('Network Connection Problem, please try again!');
        setparentLoaderNine(false);

      });

  }


  const [successMsgEight, setSuccessMsgEight] = useState('');
  const [errorMsgEight, setErrorMsgEight] = useState('');

  const [parentLoaderEight, setparentLoaderEight] = useState(false);

  const handleSubmitEight = (event) => {

    setSuccessMsgEight('');
    setErrorMsgEight('');
    var user_temp = { ...eightformInfo };
    user_temp.school_district_error = false;

    user_temp.athlete_signature_error = false;

    user_temp.parent_signature_error = false;
    if (user_temp.school_district == '') {
      user_temp.school_district_error = true;
      setEightforminInfo(user_temp);
      setErrorMsgEight('Please enter name of school district'); return false;
    }


    if (user_temp.athlete_signature == '') {
      user_temp.athlete_signature_error = true;
      setEightforminInfo(user_temp);
      setErrorMsgEight('Please enter signature of student-athlete'); return false;
    }


    if (user_temp.parent_signature == '') {
      user_temp.parent_signature_error = true;
      setEightforminInfo(user_temp);
      setErrorMsgEight('Please signature of parent/guardian'); return false;
    }




    if (userData != null && userData.locat_up == "0" && (checkdiss == false)) {
      setSubmitch('eieght');
      var resultnew = locations.map(function (el) {
        var o = Object.assign({}, el);
        if (userData.location_at_id == o.location_id) {
          setmainSearchValue(o.location_id);
          setInputValue(o);
       

 setCheckdiss(true);
          setSearchValue(o);
         setTimeout(function () {
            setOpendischolllog(true);
          }, 500);
          return false;

        }


        //return o;
      });

      return false;
    } else {
      setOpendischolllog(false);
    }
    setparentLoaderEight(true);
    setOpenLog(true);
    Axios.post(`/pdf_form_submit`, { studid: userData.stuid, id: 8, formdata: user_temp, ip_address: ipuser, newlocation: mainsearchValue })
      .then(res => {
        console.log(res.data);

        if (res.data.status == true) {
          secureLocalStorage.setItem("userdata", JSON.stringify(res.data.studentdetalis));

          var arrst = [];
          var docnew = {};
          var resultnew = res.data.studentdata.map(function (el) {
            var o = Object.assign({}, el);
            if (o.form_id == 8) {
              docnew = o;

            }


            //return o;
          });
          console.log(docnew);
          console.log(allstudentlisdata);
          if (allstudentlisdata.length > 0) {
            arrst.push(docnew);
            var resultk = allstudentlisdata.map(function (el) {
              var ou = Object.assign({}, el);

              if (ou.form_id != 8) {


                arrst.push(ou);
              } else {

              }

              console.log(allstudentlisdata);
              console.log(ou);

              return ou;
            });
          } else {
            arrst.push(docnew);
          }

          console.log(arrst);
          setAllstudentlisdata(arrst);
          secureLocalStorage.setItem("studenentformdata", JSON.stringify(arrst));

          // console.log(res.data.data);
          // storage[0].userdata = res.data.data;
          // secureLocalStorage.setItem("studenentformdata", JSON.stringify(res.data.studentdata));
          // setAllstudentlisdata(res.data.studentdata);
          setparentLoaderEight(false);
          setSuccessMsgEight('Form Submitted Successfully');
          setOpenLog(false);
          setTimeout(function () {
            setOpenLog(false);
            setSuccessMsgEight('');
            setErrorMsgEight('');

          }, 1000);

        }
        else {

          setErrorMsgEight(res.data.data);
          setparentLoaderEight(false);
        }

      })
      .catch(error => {
        setErrorMsgEight('Network Connection Problem, please try again!');
        setparentLoaderEight(false);

      });

  }

  const [successMsgSeven, setSuccessMsgSeven] = useState('');
  const [errorMsgSeven, setErrorMsgSeven] = useState('');

  const [parentLoaderSeven, setparentLoaderSeven] = useState(false);

  const handleSubmitSeven = (event) => {

    setSuccessMsgSeven('');
    setErrorMsgSeven('');
    var user_temp = { ...sevenformInfo };
    user_temp.school_district_error = false;

    user_temp.athlete_signature_error = false;

    user_temp.parent_signature_error = false;
    if (user_temp.school_district == '') {
      user_temp.school_district_error = true;
      setSevenforminInfo(user_temp);
      setErrorMsgSeven('Please enter name of school district'); return false;
    }


    if (user_temp.athlete_signature == '') {
      user_temp.athlete_signature_error = true;
      setSevenforminInfo(user_temp);
      setErrorMsgSeven('Please enter signature of student-athlete'); return false;
    }


    if (user_temp.parent_signature == '') {
      user_temp.parent_signature_error = true;
      setSevenforminInfo(user_temp);
      setErrorMsgSeven('Please signature of parent/guardian'); return false;
    }


    if (userData != null && userData.locat_up == "0" && (checkdiss == false)) {
      setSubmitch('seven');
      var resultnew = locations.map(function (el) {
        var o = Object.assign({}, el);
        if (userData.location_at_id == o.location_id) {
          setmainSearchValue(o.location_id);
          setInputValue(o);
         

 setCheckdiss(true);
          setSearchValue(o);
         setTimeout(function () {
            setOpendischolllog(true);
          }, 500);
          return false;

        }


        //return o;
      });

      return false;
    } else {
      setOpendischolllog(false);
    }


    setparentLoaderSeven(true);
    setOpenLog(true);
    Axios.post(`/pdf_form_submit`, { studid: userData.stuid, id: 7, formdata: user_temp, ip_address: ipuser, newlocation: mainsearchValue })
      .then(res => {
        console.log(res.data);

        if (res.data.status == true) {
          secureLocalStorage.setItem("userdata", JSON.stringify(res.data.studentdetalis));

          console.log(res.data.data);
          var arrst = [];
          var docnew = {};
          var resultnew = res.data.studentdata.map(function (el) {
            var o = Object.assign({}, el);
            if (o.form_id == 7) {
              docnew = o;

            }


            //return o;
          });
          console.log(docnew);
          console.log(allstudentlisdata);
          if (allstudentlisdata.length > 0) {
            arrst.push(docnew);
            var resultk = allstudentlisdata.map(function (el) {
              var ou = Object.assign({}, el);

              if (ou.form_id != 7) {


                arrst.push(ou);
              } else {

              }

              console.log(allstudentlisdata);
              console.log(ou);

              return ou;
            });
          } else {
            arrst.push(docnew);
          }

          console.log(arrst);
          setAllstudentlisdata(arrst);
          secureLocalStorage.setItem("studenentformdata", JSON.stringify(arrst));

          // storage[0].userdata = res.data.data;
          // secureLocalStorage.setItem("studenentformdata", JSON.stringify(res.data.studentdata));
          // setAllstudentlisdata(res.data.studentdata);
          setparentLoaderSeven(false);
          setSuccessMsgSeven('Form Submitted Successfully');
          setOpenLog(false);
          setTimeout(function () {
            setOpenLog(false);
            setSuccessMsgSeven('');
            setErrorMsgSeven('');

          }, 1000);

        }
        else {

          setErrorMsgSeven(res.data.data);
          setparentLoaderSeven(false);
        }

      })
      .catch(error => {
        setErrorMsgSeven('Network Connection Problem, please try again!');
        setparentLoaderSeven(false);

      });

  }

  const [successMsgSix, setSuccessMsgSix] = useState('');
  const [errorMsgSix, setErrorMsgSix] = useState('');

  const [parentLoaderSix, setparentLoaderSix] = useState(false);

  const handleSubmitSix = (event) => {

    setSuccessMsgSix('');
    setErrorMsgSix('');
    var user_temp = { ...sixformInfo };
    user_temp.athlete_signature_error = false;
    user_temp.athlete_name_error = false;
    user_temp.parent_signature_error = false;
    user_temp.parent_name_error = false;
    if (user_temp.athlete_signature == '') {
      user_temp.athlete_signature_error = true;
      setSixforminInfo(user_temp);
      setErrorMsgSix('Please enter signature of student-athlete'); return false;
    }

    if (user_temp.athlete_name == '') {
      user_temp.athlete_name_error = true;
      setSixforminInfo(user_temp);

      setErrorMsgSix("Please enter print student-athlete's name!"); return false;
    }
    if (user_temp.parent_signature == '') {
      user_temp.parent_signature_error = true;
      setSixforminInfo(user_temp);
      setErrorMsgSix('Please signature of parent/guardian'); return false;
    }

    if (user_temp.parent_name == '') {
      user_temp.parent_name_error = true;
      setSixforminInfo(user_temp);
      setErrorMsgSix("Please enter print parent/guardian's name"); return false;
    }


    if (userData != null && userData.locat_up == "0" && (checkdiss == false)) {
      setSubmitch('six');
      var resultnew = locations.map(function (el) {
        var o = Object.assign({}, el);
        if (userData.location_at_id == o.location_id) {
          setmainSearchValue(o.location_id);
          setInputValue(o);
          

 setCheckdiss(true);
          setSearchValue(o);
         setTimeout(function () {
            setOpendischolllog(true);
          }, 500);
          return false;

        }


        //return o;
      });

      return false;
    } else {
      setOpendischolllog(false);
    }
    setparentLoaderSix(true);
    setOpenLog(true);
    Axios.post(`/pdf_form_submit`, { studid: userData.stuid, id: 6, formdata: user_temp, ip_address: ipuser, newlocation: mainsearchValue })
      .then(res => {
        console.log(res.data);

        if (res.data.status == true) {
          secureLocalStorage.setItem("userdata", JSON.stringify(res.data.studentdetalis));
          console.log(res.data.data);
          var arrst = [];
          var docnew = {};
          var resultnew = res.data.studentdata.map(function (el) {
            var o = Object.assign({}, el);
            if (o.form_id == 6) {
              docnew = o;

            }


            //return o;
          });
          console.log(docnew);
          console.log(allstudentlisdata);
          if (allstudentlisdata.length > 0) {
            arrst.push(docnew);
            var resultk = allstudentlisdata.map(function (el) {
              var ou = Object.assign({}, el);

              if (ou.form_id != 6) {


                arrst.push(ou);
              } else {

              }

              console.log(allstudentlisdata);
              console.log(ou);

              return ou;
            });
          } else {
            arrst.push(docnew);
          }

          console.log(arrst);
          setAllstudentlisdata(arrst);
          secureLocalStorage.setItem("studenentformdata", JSON.stringify(arrst));

          // storage[0].userdata = res.data.data;
          // secureLocalStorage.setItem("studenentformdata", JSON.stringify(res.data.studentdata));
          // setAllstudentlisdata(res.data.studentdata);
          setparentLoaderSix(false);
          setSuccessMsgSix('Form Submitted Successfully');
          setOpenLog(false);
          setTimeout(function () {
            setOpenLog(false);
            setSuccessMsgSix('');
            setErrorMsgSix('');

          }, 1000);

        }
        else {

          setErrorMsgSix(res.data.data);
          setparentLoaderSix(false);
        }

      })
      .catch(error => {
        setErrorMsgSix('Network Connection Problem, please try again!');
        setparentLoaderSix(false);

      });

  }

  var thirdform_default = {
    datefir: '',

    datefir_error: false,
    datesec: '',


    dateth: '',


    datefor: '',


    datefif: '',


    datesix: '',


    dateseven: '',


    dateeight: '',


    sports: '',

    sports_error: false,
    supplemnets: '',

    supplemnets_error: false,
    allergies: '',

    allergies_error: false,
    allergies_data: '',

    allergies_data_error: false,

    restricted: '',

    restricted_error: false,

    explain_restricted: '',

    explain_restricted_error: false,



    medical: '',

    medical_error: false,

    medical_data: '',

    medical_data_error: false,



    other: '',

    other_error: false,


    explain: '',

    explain_error: false,

    hospital: '',

    hospital_error: false,


    explain_hospital: '',

    explain_hospital_error: false,
    surgery: '',

    surgery_error: false,



    explain_surgery: '',

    explain_surgery_error: false,


    exercise: '',

    exercise_error: false,

    explain_exercise: '',

    explain_exercise_error: false,




    chest: '',

    chest_error: false,

    explain_chest: '',

    explain_chest_error: false,



    irregular: '',

    irregular_error: false,

    explain_irregular: '',

    explain_irregular_error: false,

    heart_problem: '',

    heart_problem_error: false,

    explain_heart_problem: '',

    explain_heart_problem_error: false,



    heart_problem_data: '',

    heart_problem_data_error: false,

    heart_problem_data_other: '',

    heart_problem_data_other_error: false,

    heart_doctor: '',

    heart_doctor_error: false,

    explain_heart_doctor: '',

    explain_heart_doctor_error: false,


    lightheaded: '',

    lightheaded_error: false,

    explain_lightheaded: '',

    explain_lightheaded_error: false,




    seizure: '',

    seizure_error: false,

    explain_seizure: '',

    explain_seizure_error: false,



    breath: '',

    breath_error: false,

    explain_breath: '',

    explain_breath_error: false,

    death_syndrome: '',

    death_syndrome_error: false,

    explain_death_syndrome: '',

    explain_death_syndrome_error: false,



    hypertrophic: '',

    hypertrophic_error: false,

    explain_hypertrophic: '',

    explain_hypertrophic_error: false,



    pacemaker: '',

    pacemaker_error: false,

    explain_pacemaker: '',

    explain_pacemaker_error: false,

    unexplained_seizures: '',

    unexplained_seizures_error: false,

    explain_unexplained_seizures: '',

    explain_unexplained_seizures_error: false,



    practice: '',

    practice_error: false,

    explain_practice: '',

    explain_practice_error: false,



    dislocated: '',

    dislocated_error: false,

    explain_dislocated: '',

    explain_dislocated_error: false,



    injections: '',

    injections_error: false,

    explain_injections: '',

    explain_injections_error: false,

    stress: '',

    stress_error: false,

    explain_stress: '',

    explain_stress_error: false,




    instability: '',

    instability_error: false,

    explain_instability: '',

    explain_instability_error: false,

    orthotics: '',

    orthotics_error: false,

    explain_orthotics: '',

    explain_orthotics_error: false,



    joint_injury: '',

    joint_injury_error: false,

    explain_joint_injury: '',

    explain_joint_injury_error: false,


    swollen: '',

    swollen_error: false,

    explain_swollen: '',

    explain_swollen_error: false,



    arthritis: '',

    arthritis_error: false,

    explain_arthritis: '',

    explain_arthritis_error: false,


    breathing_exercise: '',

    breathing_exercise_error: false,

    explain_breathing_exercise: '',

    explain_breathing_exercise_error: false,


    asthma_medicine: '',

    asthma_medicine_error: false,

    explain_asthma_medicine: '',

    explain_asthma_medicine_error: false,



    asthma_family: '',

    asthma_family_error: false,

    explain_asthma_family: '',

    explain_asthma_family_error: false,


    kidney: '',

    kidney_error: false,

    explain_kidney: '',

    explain_kidney_error: false,


    hernia: '',

    hernia_error: false,

    explain_hernia: '',

    explain_hernia_error: false,


    mononucleosis: '',

    mononucleosis_error: false,

    explain_mononucleosis: '',

    explain_mononucleosis_error: false,


    pressure_sores: '',

    pressure_sores_error: false,

    explain_pressure_sores: '',

    explain_pressure_sores_error: false,


    mrsa: '',

    mrsa_error: false,

    explain_mrsa: '',

    explain_mrsa_error: false,



    head_injury: '',

    head_injury_error: false,

    explain_head_injury: '',

    explain_head_injury_error: false,



    memory_problems: '',

    memory_problems_error: false,

    explain_memory_problems: '',

    explain_memory_problems_error: false,


    seizure_disorder: '',

    seizure_disorder_error: false,

    explain_seizure_disorder: '',

    explain_seizure_disorder_error: false,


    headaches_exercise: '',

    headaches_exercise_error: false,

    explain_headaches_exercise: '',

    explain_headaches_exercise_error: false,

    numbness: '',

    numbness_error: false,

    explain_numbness: '',

    explain_numbness_error: false,


    arms: '',

    arms_error: false,

    explain_arms: '',

    explain_arms_error: false,


    heal: '',

    heal_error: false,

    explain_heal: '',

    explain_heal_error: false,


    cramps: '',

    cramps_error: false,

    explain_cramps: '',

    explain_cramps_error: false,


    sickle: '',

    sickle_error: false,

    explain_sickle: '',

    explain_sickle_error: false,


    vision: '',

    vision_error: false,

    explain_vision: '',

    explain_vision_error: false,




    eye_injuries: '',

    eye_injuries_error: false,

    explain_eye_injuries: '',

    explain_eye_injuries_error: false,


    contact_lenses: '',

    contact_lenses_error: false,

    explain_contact_lenses: '',

    explain_contact_lenses_error: false,




    face_shield: '',

    face_shield_error: false,

    explain_face_shield: '',

    explain_face_shield_error: false,




    weight: '',

    weight_error: false,

    explain_weight: '',

    explain_weight_error: false,


    lose_weight: '',

    lose_weight_error: false,

    explain_lose_weight: '',

    explain_lose_weight_error: false,



    foods: '',

    foods_error: false,

    explain_foods: '',

    explain_foods_error: false,


    eating_disorder: '',

    eating_disorder_error: false,

    explain_eating_disorder: '',

    explain_eating_disorder_error: false,

    doctor: '',

    doctor_error: false,

    explain_doctor: '',

    explain_doctor_error: false,



    menstrual: '',

    menstrual_error: false,

    explain_menstrual: '',

    explain_menstrual_error: false,




    menstrual_period: '',

    menstrual_period_error: false,

    explain_menstrual_period: '',

    explain_menstrual_period_error: false,


    periods: '',

    periods_error: false,

    explain_periods: '',

    explain_periods_error: false,

    athlete_signature: '',

    athlete_signature_error: false,

    parent_signature: '',
    parent_signature_error: false,






  };

  const [thirdformInfo, setThirdforminInfo] = useState(thirdform_default);




  const handleChangeThird = (event) => {
    var user_temp = { ...thirdformInfo };

    setSuccessMsgThird('');
    setErrorMsgThird('');
    user_temp.datefir_error = false;
    user_temp.sports_error = false;
    user_temp.supplemnets_error = false;
    user_temp.allergies_error = false;
    user_temp.allergies_data_error = false;
    user_temp.restricted_error = false;
    user_temp.explain_restricted_error = false;
    user_temp.medical_error = false;
    user_temp.medical_data_error = false;
    user_temp.other_error = false;
    user_temp.explain_error = false;
    user_temp.hospital_error = false;
    user_temp.explain_hospital_error = false;
    user_temp.surgery_error = false;
    user_temp.explain_surgery_error = false;
    user_temp.exercise_error = false;
    user_temp.explain_exercise_error = false;
    user_temp.chest_error = false;
    user_temp.explain_chest_error = false;
    user_temp.irregular_error = false;
    user_temp.explain_irregular_error = false;
    user_temp.heart_problem_error = false;
    user_temp.explain_heart_problem_error = false;
    user_temp.heart_problem_data_error = false;
    user_temp.heart_problem_data_other_error = false;
    user_temp.heart_doctor_error = false;
    user_temp.explain_heart_doctor_error = false;
    user_temp.lightheaded_error = false;
    user_temp.explain_lightheaded_error = false;
    user_temp.seizure_error = false;
    user_temp.explain_seizure_error = false;
    user_temp.breath_error = false;
    user_temp.explain_breath_error = false;
    user_temp.death_syndrome_error = false;
    user_temp.explain_death_syndrome_error = false;
    user_temp.hypertrophic_error = false;
    user_temp.explain_hypertrophic_error = false;
    user_temp.pacemaker_error = false;
    user_temp.explain_pacemaker_error = false;
    user_temp.unexplained_seizures_error = false;
    user_temp.explain_unexplained_seizures_error = false;
    user_temp.practice_error = false;
    user_temp.explain_practice_error = false;
    user_temp.dislocated_error = false;
    user_temp.explain_dislocated_error = false;
    user_temp.injections_error = false;
    user_temp.explain_injections_error = false;
    user_temp.stress_error = false;
    user_temp.explain_stress_error = false;
    user_temp.instability_error = false;
    user_temp.explain_instability_error = false;
    user_temp.orthotics_error = false;
    user_temp.explain_orthotics_error = false;
    user_temp.joint_injury_error = false;
    user_temp.explain_joint_injury_error = false;
    user_temp.swollen_error = false;
    user_temp.explain_swollen_error = false;
    user_temp.arthritis_error = false;
    user_temp.explain_arthritis_error = false;
    user_temp.breathing_exercise_error = false;
    user_temp.explain_breathing_exercise_error = false;
    user_temp.asthma_medicine_error = false;
    user_temp.explain_asthma_medicine_error = false;
    user_temp.asthma_family_error = false;
    user_temp.explain_asthma_family_error = false;
    user_temp.kidney_error = false;
    user_temp.explain_kidney_error = false;
    user_temp.hernia_error = false;
    user_temp.explain_hernia_error = false;
    user_temp.mononucleosis_error = false;
    user_temp.explain_mononucleosis_error = false;
    user_temp.pressure_sores_error = false;
    user_temp.explain_pressure_sores_error = false;
    user_temp.mrsa_error = false;
    user_temp.explain_mrsa_error = false;
    user_temp.head_injury_error = false;
    user_temp.explain_head_injury_error = false;
    user_temp.memory_problems_error = false;
    user_temp.explain_memory_problems_error = false;
    user_temp.seizure_disorder_error = false;
    user_temp.explain_seizure_disorder_error = false;
    user_temp.headaches_exercise_error = false;
    user_temp.numbness_error = false;
    user_temp.explain_numbness_error = false;
    user_temp.arms_error = false;
    user_temp.explain_arms_error = false;
    user_temp.heal_error = false;
    user_temp.explain_heal_error = false;
    user_temp.cramps_error = false;
    user_temp.explain_cramps_error = false;
    user_temp.sickle_error = false;
    user_temp.explain_sickle_error = false;
    user_temp.vision_error = false;
    user_temp.explain_vision_error = false;
    user_temp.eye_injuries_error = false;
    user_temp.explain_eye_injuries_error = false;
    user_temp.contact_lenses_error = false;
    user_temp.explain_contact_lenses_error = false;
    user_temp.face_shield_error = false;
    user_temp.explain_face_shield_error = false;
    user_temp.weight_error = false;
    user_temp.explain_weight_error = false;
    user_temp.lose_weight_error = false;
    user_temp.explain_lose_weight_error = false;
    user_temp.foods_error = false;
    user_temp.explain_foods_error = false;
    user_temp.eating_disorder_error = false;
    user_temp.explain_eating_disorder_error = false;
    user_temp.doctor_error = false;
    user_temp.explain_doctor_error = false;
    user_temp.menstrual_error = false;
    user_temp.explain_menstrual_error = false;
    user_temp.menstrual_period_error = false;
    user_temp.explain_menstrual_period_error = false;
    user_temp.periods_error = false;
    user_temp.explain_periods_error = false;
    user_temp.athlete_signature_error = false;
    user_temp.parent_signature_error = false;


    if (event.target.name == "datefir") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datefir = value;
      }

      document.getElementById('datesec').focus();
    }
    if (event.target.name == "datesec") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datesec = value;
      }


      document.getElementById('dateth').focus();
    }
    if (event.target.name == "dateth") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.dateth = value;
      }

      document.getElementById('datefor').focus();
    }
    if (event.target.name == "datefor") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datefor = value;
      }

      document.getElementById('datefif').focus();

    }
    if (event.target.name == "datefif") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datefif = value;
      }

      document.getElementById('datesix').focus();

    }
    if (event.target.name == "datesix") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datesix = value;
      }
      document.getElementById('dateseven').focus();


    }
    if (event.target.name == "dateseven") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.dateseven = value;
      }

      document.getElementById('dateeight').focus();


    }
    if (event.target.name == "dateeight") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.dateeight = value;
      }

    }

    if (event.target.name == "sports") {
      user_temp.sports = event.target.value;

    }


    if (event.target.name == "supplemnets") {
      user_temp.supplemnets = event.target.value;

    }
    if (event.target.name == "allergies") {
      user_temp.allergies = event.target.value;
      if (event.target.value != 'Yes') {
        user_temp.allergies_data = '';
      }

    }
    if (event.target.name == "restricted") {
      user_temp.restricted = event.target.value;

    }
    if (event.target.name == "explain_restricted") {
      user_temp.explain_restricted = event.target.value;

    }
    if (event.target.name == "medical") {
      user_temp.medical = event.target.value;
      if (event.target.value != 'Yes') {
        user_temp.medical_data = '';
      }

    }

    if (event.target.name == "other") {
      user_temp.other = event.target.value;

    }
    if (event.target.name == "explain") {
      user_temp.explain = event.target.value;

    }
    if (event.target.name == "hospital") {
      user_temp.hospital = event.target.value;

    }

    if (event.target.name == "explain_hospital") {
      user_temp.explain_hospital = event.target.value;

    }
    if (event.target.name == "surgery") {
      user_temp.surgery = event.target.value;

    }
    if (event.target.name == "explain_surgery") {
      user_temp.explain_surgery = event.target.value;

    }
    if (event.target.name == "exercise") {
      user_temp.exercise = event.target.value;

    }
    if (event.target.name == "explain_exercise") {
      user_temp.explain_exercise = event.target.value;

    }
    if (event.target.name == "chest") {
      user_temp.chest = event.target.value;

    }

    if (event.target.name == "explain_chest") {
      user_temp.explain_chest = event.target.value;

    }
    if (event.target.name == "irregular") {
      user_temp.irregular = event.target.value;

    }
    if (event.target.name == "explain_irregular") {
      user_temp.explain_irregular = event.target.value;

    }
    if (event.target.name == "heart_problem") {
      user_temp.heart_problem = event.target.value;
      if (event.target.value != 'Yes') {
        user_temp.heart_problem_data = '';
      }

    }
    if (event.target.name == "explain_heart_problem") {
      user_temp.explain_heart_problem = event.target.value;

    }
    if (event.target.name == "heart_problem_data_other") {
      user_temp.heart_problem_data_other = event.target.value;

    }
    if (event.target.name == "heart_doctor") {
      user_temp.heart_doctor = event.target.value;

    }
    if (event.target.name == "explain_heart_doctor") {
      user_temp.explain_heart_doctor = event.target.value;

    }
    if (event.target.name == "lightheaded") {
      user_temp.lightheaded = event.target.value;

    }
    if (event.target.name == "explain_lightheaded") {
      user_temp.explain_lightheaded = event.target.value;

    }
    if (event.target.name == "seizure") {
      user_temp.seizure = event.target.value;

    }
    if (event.target.name == "explain_seizure") {
      user_temp.explain_seizure = event.target.value;

    }



    if (event.target.name == "breath") {
      user_temp.breath = event.target.value;

    }
    if (event.target.name == "explain_breath") {
      user_temp.explain_breath = event.target.value;

    }

    if (event.target.name == "death_syndrome") {
      user_temp.death_syndrome = event.target.value;

    }
    if (event.target.name == "explain_death_syndrome") {
      user_temp.explain_death_syndrome = event.target.value;

    }
    if (event.target.name == "hypertrophic") {
      user_temp.hypertrophic = event.target.value;

    }
    if (event.target.name == "explain_hypertrophic") {
      user_temp.explain_hypertrophic = event.target.value;

    }
    if (event.target.name == "pacemaker") {
      user_temp.pacemaker = event.target.value;

    }
    if (event.target.name == "explain_pacemaker") {
      user_temp.explain_pacemaker = event.target.value;

    }
    if (event.target.name == "unexplained_seizures") {
      user_temp.unexplained_seizures = event.target.value;

    }
    if (event.target.name == "explain_unexplained_seizures") {
      user_temp.explain_unexplained_seizures = event.target.value;

    }
    if (event.target.name == "practice") {
      user_temp.practice = event.target.value;

    }
    if (event.target.name == "explain_practice") {
      user_temp.explain_practice = event.target.value;

    }
    if (event.target.name == "dislocated") {
      user_temp.dislocated = event.target.value;

    }
    if (event.target.name == "explain_dislocated") {
      user_temp.explain_dislocated = event.target.value;

    }
    if (event.target.name == "injections") {
      user_temp.injections = event.target.value;

    }
    if (event.target.name == "explain_injections") {
      user_temp.explain_injections = event.target.value;

    }
    if (event.target.name == "stress") {
      user_temp.stress = event.target.value;

    }
    if (event.target.name == "explain_stress") {
      user_temp.explain_stress = event.target.value;

    }
    if (event.target.name == "instability") {
      user_temp.instability = event.target.value;

    }
    if (event.target.name == "explain_instability") {
      user_temp.explain_instability = event.target.value;

    }

    if (event.target.name == "orthotics") {
      user_temp.orthotics = event.target.value;

    }
    if (event.target.name == "explain_orthotics") {
      user_temp.explain_orthotics = event.target.value;

    }
    if (event.target.name == "joint_injury") {
      user_temp.joint_injury = event.target.value;

    }
    if (event.target.name == "explain_joint_injury") {
      user_temp.explain_joint_injury = event.target.value;

    }
    if (event.target.name == "swollen") {
      user_temp.swollen = event.target.value;

    }
    if (event.target.name == "explain_swollen") {
      user_temp.explain_swollen = event.target.value;

    }
    if (event.target.name == "arthritis") {
      user_temp.arthritis = event.target.value;

    }
    if (event.target.name == "explain_arthritis") {
      user_temp.explain_arthritis = event.target.value;

    }
    if (event.target.name == "breathing_exercise") {
      user_temp.breathing_exercise = event.target.value;

    }
    if (event.target.name == "explain_breathing_exercise") {
      user_temp.explain_breathing_exercise = event.target.value;

    }
    if (event.target.name == "asthma_medicine") {
      user_temp.asthma_medicine = event.target.value;

    }
    if (event.target.name == "explain_asthma_medicine") {
      user_temp.explain_asthma_medicine = event.target.value;

    }

    if (event.target.name == "asthma_family") {
      user_temp.asthma_family = event.target.value;

    }
    if (event.target.name == "explain_asthma_family") {
      user_temp.explain_asthma_family = event.target.value;

    }
    if (event.target.name == "kidney") {
      user_temp.kidney = event.target.value;

    }
    if (event.target.name == "explain_kidney") {
      user_temp.explain_kidney = event.target.value;

    }

    if (event.target.name == "hernia") {
      user_temp.hernia = event.target.value;

    }
    if (event.target.name == "explain_hernia") {
      user_temp.explain_hernia = event.target.value;

    }
    if (event.target.name == "mononucleosis") {
      user_temp.mononucleosis = event.target.value;

    }
    if (event.target.name == "explain_mononucleosis") {
      user_temp.explain_mononucleosis = event.target.value;

    }

    if (event.target.name == "pressure_sores") {
      user_temp.pressure_sores = event.target.value;

    }
    if (event.target.name == "explain_pressure_sores") {
      user_temp.explain_pressure_sores = event.target.value;

    }
    if (event.target.name == "mrsa") {
      user_temp.mrsa = event.target.value;

    }
    if (event.target.name == "explain_mrsa") {
      user_temp.explain_mrsa = event.target.value;

    }
    if (event.target.name == "head_injury") {
      user_temp.head_injury = event.target.value;

    }
    if (event.target.name == "explain_head_injury") {
      user_temp.explain_head_injury = event.target.value;

    }
    if (event.target.name == "memory_problems") {
      user_temp.memory_problems = event.target.value;

    }
    if (event.target.name == "explain_memory_problems") {
      user_temp.explain_memory_problems = event.target.value;

    }
    if (event.target.name == "seizure_disorder") {
      user_temp.seizure_disorder = event.target.value;

    }
    if (event.target.name == "explain_seizure_disorder") {
      user_temp.explain_seizure_disorder = event.target.value;

    }



    if (event.target.name == "headaches_exercise") {
      user_temp.headaches_exercise = event.target.value;

    }

    if (event.target.name == "explain_headaches_exercise") {
      user_temp.explain_headaches_exercise = event.target.value;

    }



    if (event.target.name == "numbness") {
      user_temp.numbness = event.target.value;

    }

    if (event.target.name == "explain_numbness") {
      user_temp.explain_numbness = event.target.value;

    }




    if (event.target.name == "arms") {
      user_temp.arms = event.target.value;

    }

    if (event.target.name == "explain_arms") {
      user_temp.explain_arms = event.target.value;

    }



    if (event.target.name == "heal") {
      user_temp.heal = event.target.value;

    }

    if (event.target.name == "explain_heal") {
      user_temp.explain_heal = event.target.value;

    }



    if (event.target.name == "cramps") {
      user_temp.cramps = event.target.value;

    }

    if (event.target.name == "explain_cramps") {
      user_temp.explain_cramps = event.target.value;

    }


    if (event.target.name == "sickle") {
      user_temp.sickle = event.target.value;

    }

    if (event.target.name == "explain_sickle") {
      user_temp.explain_sickle = event.target.value;

    }


    if (event.target.name == "vision") {
      user_temp.vision = event.target.value;

    }

    if (event.target.name == "explain_vision") {
      user_temp.explain_vision = event.target.value;

    }


    if (event.target.name == "eye_injuries") {
      user_temp.eye_injuries = event.target.value;

    }

    if (event.target.name == "explain_eye_injuries") {
      user_temp.explain_eye_injuries = event.target.value;

    }


    if (event.target.name == "contact_lenses") {
      user_temp.contact_lenses = event.target.value;

    }

    if (event.target.name == "explain_contact_lenses") {
      user_temp.explain_contact_lenses = event.target.value;

    }




    if (event.target.name == "face_shield") {
      user_temp.face_shield = event.target.value;

    }

    if (event.target.name == "explain_face_shield") {
      user_temp.explain_face_shield = event.target.value;

    }


    if (event.target.name == "weight") {
      user_temp.weight = event.target.value;

    }

    if (event.target.name == "explain_weight") {
      user_temp.explain_weight = event.target.value;

    }


    if (event.target.name == "lose_weight") {
      user_temp.lose_weight = event.target.value;

    }

    if (event.target.name == "explain_lose_weight") {
      user_temp.explain_lose_weight = event.target.value;

    }

    if (event.target.name == "foods") {
      user_temp.foods = event.target.value;

    }

    if (event.target.name == "explain_foods") {
      user_temp.explain_foods = event.target.value;

    }

    if (event.target.name == "eating_disorder") {
      user_temp.eating_disorder = event.target.value;

    }
    console.log(event.target.name);
    if (event.target.name == "explain_eating_disorder") {
      user_temp.explain_eating_disorder = event.target.value;

    }

    if (event.target.name == "doctor") {
      user_temp.doctor = event.target.value;

    }

    if (event.target.name == "explain_doctor") {
      user_temp.explain_doctor = event.target.value;

    }


    if (event.target.name == "menstrual") {
      user_temp.menstrual = event.target.value;

    }

    if (event.target.name == "explain_menstrual") {
      user_temp.explain_menstrual = event.target.value;

    }

    if (event.target.name == "menstrual_period") {
      user_temp.menstrual_period = event.target.value;

    }

    if (event.target.name == "periods") {
      user_temp.periods = event.target.value;

    }

    if (event.target.name == "athlete_signature") {
      user_temp.athlete_signature = event.target.value;

    }
    if (event.target.name == "parent_signature") {
      user_temp.parent_signature = event.target.value;

    }
    secureLocalStorage.setItem("alldatathirdform", JSON.stringify(user_temp));

    secureLocalStorage.setItem("oldstudid", (userData.stuid));
    setThirdforminInfo(user_temp);





  }

  const handleChangeThirddata = (event) => {
    var user_temp = { ...thirdformInfo };

    user_temp.allergies_data_error = false;
    user_temp.medical_data_error = false;
    if (event.target.name == "allergies_data" && user_temp.allergies == 'Yes') {
      if (event.target.value == 'Medicines') {
        if (user_temp.allergies_data.includes(" Medicines") == true) {
          user_temp.allergies_data = user_temp.allergies_data.replace(" Medicines", "");
        } else {
          user_temp.allergies_data += " Medicines";

        }
      }

      if (event.target.value == 'Pollens') {
        if (user_temp.allergies_data.includes(" Pollens") == true) {
          user_temp.allergies_data = user_temp.allergies_data.replace(" Pollens", "");
        } else {
          user_temp.allergies_data += " Pollens";

        }
      }

      if (event.target.value == 'Food') {
        if (user_temp.allergies_data.includes(" Food") == true) {
          user_temp.allergies_data = user_temp.allergies_data.replace(" Food", "");
        } else {
          user_temp.allergies_data += " Food";

        }
      }


      if (event.target.value == 'Stinging Insects') {
        if (user_temp.allergies_data.includes(" Stinging Insects") == true) {
          user_temp.allergies_data = user_temp.allergies_data.replace(" Stinging Insects", "");
        } else {
          user_temp.allergies_data += " Stinging Insects";

        }
      }



    }
    if (event.target.name == "medical_data" && user_temp.medical == 'Yes') {
      if (event.target.value == 'Anemia') {
        if (user_temp.medical_data.includes(" Anemia") == true) {
          user_temp.medical_data = user_temp.medical_data.replace(" Anemia", "");
        } else {
          user_temp.medical_data += " Anemia";

        }
      }

      if (event.target.value == 'Diabetes') {
        if (user_temp.medical_data.includes(" Diabetes") == true) {
          user_temp.medical_data = user_temp.medical_data.replace(" Diabetes", "");
        } else {
          user_temp.medical_data += " Diabetes";

        }
      }

      if (event.target.value == 'Infections') {
        if (user_temp.medical_data.includes(" Infections") == true) {
          user_temp.medical_data = user_temp.medical_data.replace(" Infections", "");
        } else {
          user_temp.medical_data += " Infections";

        }
      }


      if (event.target.value == 'Asthma') {
        if (user_temp.medical_data.includes(" Asthma") == true) {
          user_temp.medical_data = user_temp.medical_data.replace(" Asthma", "");
        } else {
          user_temp.medical_data += " Asthma";

        }
      }



    }
    if (event.target.name == "heart_problem_data" && user_temp.heart_problem == 'Yes') {
      if (event.target.value == 'High blood pressure') {
        if (user_temp.heart_problem_data.includes(" High blood pressure") == true) {
          user_temp.heart_problem_data = user_temp.heart_problem_data.replace(" High blood pressure", "");
        } else {
          user_temp.heart_problem_data += " High blood pressure";

        }
      }

      if (event.target.value == 'A heart murmur') {
        if (user_temp.heart_problem_data.includes(" A heart murmur") == true) {
          user_temp.heart_problem_data = user_temp.heart_problem_data.replace(" A heart murmur", "");
        } else {
          user_temp.heart_problem_data += " A heart murmur";

        }
      }

      if (event.target.value == 'High Cholesterol') {
        if (user_temp.heart_problem_data.includes(" High Cholesterol") == true) {
          user_temp.heart_problem_data = user_temp.heart_problem_data.replace(" High Cholesterol", "");
        } else {
          user_temp.heart_problem_data += " High Cholesterol";

        }
      }


      if (event.target.value == 'A heart infection') {
        if (user_temp.heart_problem_data.includes(" A heart infection") == true) {
          user_temp.heart_problem_data = user_temp.heart_problem_data.replace(" A heart infection", "");
        } else {
          user_temp.heart_problem_data += " A heart infection";

        }
      }

      if (event.target.value == 'Kawasaki disease') {
        if (user_temp.heart_problem_data.includes(" Kawasaki disease") == true) {
          user_temp.heart_problem_data = user_temp.heart_problem_data.replace(" Kawasaki disease", "");
        } else {
          user_temp.heart_problem_data += " Kawasaki disease";

        }
      }

    }
    console.log(event.target.value);
    console.log(user_temp.allergies_data);
    secureLocalStorage.setItem("alldatathirdform", JSON.stringify(user_temp));

    secureLocalStorage.setItem("oldstudid", (userData.stuid));
    setThirdforminInfo(user_temp);


  }

  const [successMsgThird, setSuccessMsgThird] = useState('');
  const [errorMsgThird, setErrorMsgThird] = useState('');

  const [parentLoaderThird, setparentLoaderThird] = useState(false);


  const handleSubmitThird = (event) => {

    setSuccessMsgThird('');
    setErrorMsgThird('');
    var user_temp = { ...thirdformInfo };



    user_temp.datefir_error = false;
    user_temp.sports_error = false;
    user_temp.supplemnets_error = false;
    user_temp.allergies_error = false;
    user_temp.allergies_data_error = false;
    user_temp.restricted_error = false;
    user_temp.explain_restricted_error = false;
    user_temp.medical_error = false;
    user_temp.medical_data_error = false;
    user_temp.other_error = false;
    user_temp.explain_error = false;
    user_temp.hospital_error = false;
    user_temp.explain_hospital_error = false;
    user_temp.surgery_error = false;
    user_temp.explain_surgery_error = false;
    user_temp.exercise_error = false;
    user_temp.explain_exercise_error = false;
    user_temp.chest_error = false;
    user_temp.explain_chest_error = false;
    user_temp.irregular_error = false;
    user_temp.explain_irregular_error = false;
    user_temp.heart_problem_error = false;
    user_temp.explain_heart_problem_error = false;
    user_temp.heart_problem_data_error = false;
    user_temp.heart_problem_data_other_error = false;
    user_temp.heart_doctor_error = false;
    user_temp.explain_heart_doctor_error = false;
    user_temp.lightheaded_error = false;
    user_temp.explain_lightheaded_error = false;
    user_temp.seizure_error = false;
    user_temp.explain_seizure_error = false;
    user_temp.breath_error = false;
    user_temp.explain_breath_error = false;
    user_temp.death_syndrome_error = false;
    user_temp.explain_death_syndrome_error = false;
    user_temp.hypertrophic_error = false;
    user_temp.explain_hypertrophic_error = false;
    user_temp.pacemaker_error = false;
    user_temp.explain_pacemaker_error = false;
    user_temp.unexplained_seizures_error = false;
    user_temp.explain_unexplained_seizures_error = false;
    user_temp.practice_error = false;
    user_temp.explain_practice_error = false;
    user_temp.dislocated_error = false;
    user_temp.explain_dislocated_error = false;
    user_temp.injections_error = false;
    user_temp.explain_injections_error = false;
    user_temp.stress_error = false;
    user_temp.explain_stress_error = false;
    user_temp.instability_error = false;
    user_temp.explain_instability_error = false;
    user_temp.orthotics_error = false;
    user_temp.explain_orthotics_error = false;
    user_temp.joint_injury_error = false;
    user_temp.explain_joint_injury_error = false;
    user_temp.swollen_error = false;
    user_temp.explain_swollen_error = false;
    user_temp.arthritis_error = false;
    user_temp.explain_arthritis_error = false;
    user_temp.breathing_exercise_error = false;
    user_temp.explain_breathing_exercise_error = false;
    user_temp.asthma_medicine_error = false;
    user_temp.explain_asthma_medicine_error = false;
    user_temp.asthma_family_error = false;
    user_temp.explain_asthma_family_error = false;
    user_temp.kidney_error = false;
    user_temp.explain_kidney_error = false;
    user_temp.hernia_error = false;
    user_temp.explain_hernia_error = false;
    user_temp.mononucleosis_error = false;
    user_temp.explain_mononucleosis_error = false;
    user_temp.pressure_sores_error = false;
    user_temp.explain_pressure_sores_error = false;
    user_temp.mrsa_error = false;
    user_temp.explain_mrsa_error = false;
    user_temp.head_injury_error = false;
    user_temp.explain_head_injury_error = false;
    user_temp.memory_problems_error = false;
    user_temp.explain_memory_problems_error = false;
    user_temp.seizure_disorder_error = false;
    user_temp.explain_seizure_disorder_error = false;
    user_temp.headaches_exercise_error = false;
    user_temp.numbness_error = false;
    user_temp.explain_numbness_error = false;
    user_temp.arms_error = false;
    user_temp.explain_arms_error = false;
    user_temp.heal_error = false;
    user_temp.explain_heal_error = false;
    user_temp.cramps_error = false;
    user_temp.explain_cramps_error = false;
    user_temp.sickle_error = false;
    user_temp.explain_sickle_error = false;
    user_temp.vision_error = false;
    user_temp.explain_vision_error = false;
    user_temp.eye_injuries_error = false;
    user_temp.explain_eye_injuries_error = false;
    user_temp.contact_lenses_error = false;
    user_temp.explain_contact_lenses_error = false;
    user_temp.face_shield_error = false;
    user_temp.explain_face_shield_error = false;
    user_temp.weight_error = false;
    user_temp.explain_weight_error = false;
    user_temp.lose_weight_error = false;
    user_temp.explain_lose_weight_error = false;
    user_temp.foods_error = false;
    user_temp.explain_foods_error = false;
    user_temp.eating_disorder_error = false;
    user_temp.explain_eating_disorder_error = false;
    user_temp.doctor_error = false;
    user_temp.explain_doctor_error = false;
    user_temp.menstrual_error = false;
    user_temp.explain_menstrual_error = false;
    user_temp.menstrual_period_error = false;
    user_temp.explain_menstrual_period_error = false;
    user_temp.periods_error = false;
    user_temp.explain_periods_error = false;
    user_temp.athlete_signature_error = false;
    user_temp.parent_signature_error = false;

    if (user_temp.datefir == "") {
      user_temp.datefir_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please enter date of exam"); return false;
    }

    if (user_temp.datesec == "") {
      user_temp.datefir_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please enter date of exam"); return false;
    }


    if (user_temp.dateth == '') {
      user_temp.datefir_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please enter date of exam"); return false;
    }


    if (user_temp.datefor == '') {
      user_temp.datefir_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please enter date of exam"); return false;
    }
    if (user_temp.datefif == '') {

      user_temp.datefir_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please enter date of exam"); return false;
    }

    if (user_temp.datesix == '') {

      user_temp.datefir_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please enter date of exam"); return false;
    }

    if (user_temp.dateseven == '') {
      user_temp.datefir_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please enter date of exam"); return false;
    }

    if (user_temp.dateeight == "") {
      user_temp.datefir_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please enter date of exam"); return false;
    }

    if (user_temp.sports == '') {
      user_temp.sports_error = true;


      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please enter sports name"); return false;
    }

    if (user_temp.supplemnets == '') {
      user_temp.supplemnets_error = true;


      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please enter medicines and allergies"); return false;
    }




    if (user_temp.allergies == '') {
      user_temp.allergies_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you have any allergies?"); return false;

    }
    if (user_temp.allergies_data == '' && user_temp.allergies == 'Yes') {
      user_temp.allergies_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please identify specific allergy "); return false;

    }
    if (user_temp.restricted == '') {
      user_temp.restricted_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select has a doctor ever denied or restricted your participation in sports for any reason?"); return false;

    }

    if (user_temp.explain_restricted == ''
      && user_temp.restricted == 'Yes') {
      user_temp.explain_restricted_error = true;

      setThirdforminInfo(user_temp);

      setErrorMsgThird("Please explain has a doctor ever denied or restricted your participation in sports for any reason?"); return false;
    }

    //         if (user_temp.explain_restricted== '' ) {
    // user_temp.explain_restricted_error=true;

    //       }
    if (user_temp.medical == '') {
      user_temp.medical_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you have any ongoing medical conditions?"); return false;


    }
    if (user_temp.explain == ''
      && user_temp.medical == 'Yes') {
      user_temp.explain_error = true;

      setThirdforminInfo(user_temp);

      setErrorMsgThird("Please explain do you have any ongoing medical conditions?"); return false;
    }


    if (user_temp.medical_data == '' && user_temp.medical == 'Yes') {
      user_temp.medical_data_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please identify  ongoing medical conditions"); return false;

    }

    //        if (user_temp.other== '') {
    // user_temp.other_error=true;

    //       }
    //        if (user_temp.explain== '') {
    // user_temp.explain_error=true;

    //       }
    if (user_temp.hospital == '') {
      user_temp.hospital_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever spent the night in the hospital?"); return false;

    }
    if (user_temp.explain_hospital == ''
      && user_temp.hospital == 'Yes') {
      user_temp.explain_hospital_error = true;

      setThirdforminInfo(user_temp);

      setErrorMsgThird("Please explain have you ever spent the night in the hospital?"); return false;
    }



    if (user_temp.surgery == '') {
      user_temp.surgery_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever had surgery?"); return false;


    }
    if (user_temp.explain_surgery == ''
      && user_temp.surgery == 'Yes') {
      user_temp.explain_surgery_error = true;

      setThirdforminInfo(user_temp);

      setErrorMsgThird("Please explain have you ever had surgery?"); return false;
    }

    //        if (user_temp.explain_surgery== '') {
    // user_temp.explain_surgery_error=true;

    //       }
    if (user_temp.exercise == '') {
      user_temp.exercise_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever passed out or nearly passed out DURING or AFTER exercise?"); return false;



    }
    if (user_temp.explain_exercise == '' && user_temp.exercise == 'Yes') {
      user_temp.explain_exercise_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you ever passed out or nearly passed out DURING or AFTER exercise?"); return false;

    }
    if (user_temp.chest == '') {
      user_temp.chest_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever had discomfort, pain, lightness, or pressure in your chest during exercise?"); return false;


    }

    if (user_temp.explain_chest == '' && user_temp.chest == 'Yes') {
      user_temp.explain_chest_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you ever had discomfort, pain, lightness, or pressure in your chest during exercise?"); return false;


    }
    if (user_temp.irregular == '') {
      user_temp.irregular_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select does your heart ever race or skip beats (irregular beats) during exercise?"); return false;


    }
    if (user_temp.explain_irregular == '' && user_temp.irregular == 'Yes') {
      user_temp.explain_irregular_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain does your heart ever race or skip beats (irregular beats) during exercise?"); return false;


    }
    if (user_temp.heart_problem == '') {
      user_temp.heart_problem_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select has a doctor ever told you that you have any heart problems?"); return false;


    }
    if (user_temp.heart_problem_data == '' && user_temp.heart_problem == 'Yes') {
      user_temp.heart_problem_data_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please Check the  heart problems"); return false;


    }
    if (user_temp.explain_heart_problem == '' && user_temp.heart_problem == 'Yes') {
      user_temp.explain_heart_problem_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain has a doctor ever told you that you have any heart problems?"); return false;


    }
    //        if (user_temp.heart_problem_data_other== '') {
    // user_temp.heart_problem_data_other_error=true;

    //       }
    if (user_temp.heart_doctor == '') {
      user_temp.heart_doctor_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select has a doctor ever ordered a test for your heart? (For example, ECG/EKG, echocardiogram)"); return false;


    }
    if (user_temp.explain_heart_doctor == '' && user_temp.heart_doctor == 'Yes') {
      user_temp.explain_heart_doctor_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain has a doctor ever ordered a test for your heart? (For example, ECG/EKG, echocardiogram)"); return false;


    }
    if (user_temp.lightheaded == '') {
      user_temp.lightheaded_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you get lightheaded or feel more short of breath than expected during exercise?"); return false;


    }
    if (user_temp.explain_lightheaded == '' && user_temp.lightheaded == 'Yes') {
      user_temp.explain_lightheaded_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do you get lightheaded or feel more short of breath than expected during exercise?"); return false;

    }
    if (user_temp.seizure == '') {
      user_temp.seizure_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever had an unexplained seizure?"); return false;

    }
    if (user_temp.explain_seizure == '' && user_temp.explain_seizure == 'Yes') {
      user_temp.explain_seizure_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you ever had an unexplained seizure?"); return false;

    }



    if (user_temp.breath == '') {
      user_temp.breath_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you get more tired or short of breath more quickly than your friends during exercise?"); return false;


    }
    if (user_temp.explain_breath == '' && user_temp.breath == 'Yes') {
      user_temp.explain_breath_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do you get more tired or short of breath more quickly than your friends during exercise?"); return false;


    }

    if (user_temp.death_syndrome == '') {
      user_temp.death_syndrome_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select has any family member or relative died of heart problems or had an unexpected or unexplained sudden death before age 50 (including drowning, unexplained car accident, or sudden infant death syndrome)?"); return false;


    }
    if (user_temp.explain_death_syndrome == '' && user_temp.death_syndrome == 'Yes') {
      user_temp.explain_death_syndrome_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain has any family member or relative died of heart problems or had an unexpected or unexplained sudden death before age 50 (including drowning, unexplained car accident, or sudden infant death syndrome)?"); return false;


    }
    if (user_temp.hypertrophic == '') {
      user_temp.hypertrophic_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select does anyone in your family have hypertrophic cardiomyopathy, Marfan syndrome, arrhythmogenic right ventricular cardiomyopathy, long QT syndrome, short QT syndrome, Brugada syndrome, or catecholaminergic polymorphic ventricular tachycardia?"); return false;



    }
    if (user_temp.explain_hypertrophic == '' && user_temp.hypertrophic == 'Yes') {
      user_temp.explain_hypertrophic_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain does anyone in your family have hypertrophic cardiomyopathy, Marfan syndrome, arrhythmogenic right ventricular cardiomyopathy, long QT syndrome, short QT syndrome, Brugada syndrome, or catecholaminergic polymorphic ventricular tachycardia?"); return false;



    }
    if (user_temp.pacemaker == '') {

      user_temp.pacemaker_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select does anyone in your family have a heart problem, pacemaker, or implanted defibrillator?"); return false;


    }
    if (user_temp.explain_pacemaker == '' && user_temp.pacemaker == 'Yes') {
      user_temp.explain_pacemaker_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain does anyone in your family have a heart problem, pacemaker, or implanted defibrillator?"); return false;

    }
    if (user_temp.unexplained_seizures == '') {
      user_temp.unexplained_seizures_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select has anyone in your family had unexplained fainting, unexplained seizures, or near drowning?"); return false;


    }
    if (user_temp.explain_unexplained_seizures == '' && user_temp.unexplained_seizures == 'Yes') {
      user_temp.explain_unexplained_seizures_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain has anyone in your family had unexplained fainting, unexplained seizures, or near drowning?"); return false;


    }
    if (user_temp.practice == '') {
      user_temp.practice_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever had an injury to a bone, muscle, ligament, or tendon that caused you to miss a practice or a game?"); return false;


    }
    if (user_temp.explain_practice == '' && user_temp.practice == 'Yes') {
      user_temp.explain_practice_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you ever had an injury to a bone, muscle, ligament, or tendon that caused you to miss a practice or a game?"); return false;

    }
    if (user_temp.dislocated == '') {
      user_temp.dislocated_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever had any broken or fractured bones or dislocated joints?"); return false;


    }
    if (user_temp.explain_dislocated == '' && user_temp.dislocated == 'Yes') {
      user_temp.explain_dislocated_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you ever had any broken or fractured bones or dislocated joints?"); return false;


    }
    if (user_temp.injections == '') {
      user_temp.injections_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever had an injury that required x-rays, MRI, CT scan, injections, therapy, a brace, a cast, or crutches?"); return false;


    }
    if (user_temp.explain_injections == '' && user_temp.injections == 'Yes') {
      user_temp.explain_injections_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you ever had an injury that required x-rays, MRI, CT scan, injections, therapy, a brace, a cast, or crutches?"); return false;


    }
    if (user_temp.stress == '') {
      user_temp.stress_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever had a stress fracture?"); return false;


    }
    if (user_temp.explain_stress == '' && user_temp.stress == 'Yes') {
      user_temp.explain_stress_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you ever had a stress fracture?"); return false;


    }
    if (user_temp.instability == '') {
      user_temp.instability_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever been told that you have or have you had an x-ray for neck instability or atlantoaxial instability? (Down syndrome or dwarfism)"); return false;

    }
    if (user_temp.explain_instability == '' && user_temp.instability == 'Yes') {
      user_temp.explain_instability_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you ever been told that you have or have you had an x-ray for neck instability or atlantoaxial instability? (Down syndrome or dwarfism)"); return false;


    }

    if (user_temp.orthotics == '') {
      user_temp.orthotics_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you regularly use a brace, orthotics, or other assistive device ?"); return false;


    }
    if (user_temp.explain_orthotics == '' && user_temp.orthotics == 'Yes') {
      user_temp.explain_orthotics_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do you regularly use a brace, orthotics, or other assistive device ?"); return false;

    }
    if (user_temp.joint_injury == '') {
      user_temp.joint_injury_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you have a bone, muscle, or joint injury that bothers you?"); return false;


    }
    if (user_temp.explain_joint_injury == '' && user_temp.joint_injury == 'Yes') {
      user_temp.explain_joint_injury_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do you have a bone, muscle, or joint injury that bothers you?"); return false;

    }
    if (user_temp.swollen == '') {
      user_temp.swollen_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do any of your joints become painful, swollen, feel warm, or look red ?"); return false;



    }
    if (user_temp.explain_swollen == '' && user_temp.swollen == 'Yes') {
      user_temp.explain_swollen_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do any of your joints become painful, swollen, feel warm, or look red ?"); return false;


    }
    if (user_temp.arthritis == '') {
      user_temp.arthritis_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you have any history of juvenile arthritis or connective tissue disease ?"); return false;


    }
    if (user_temp.explain_arthritis == '' && user_temp.arthritis == 'Yes') {
      user_temp.explain_arthritis_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do you have any history of juvenile arthritis or connective tissue disease ?"); return false;

    }
    if (user_temp.breathing_exercise == '') {
      user_temp.breathing_exercise_error = true;

      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you cough, wheeze, or have difficulty breathing during or after exercise?"); return false;

    }
    if (user_temp.explain_breathing_exercise == '' && user_temp.breathing_exercise == 'Yes') {
      user_temp.explain_breathing_exercise_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do you cough, wheeze, or have difficulty breathing during or after exercise?"); return false;

    }
    if (user_temp.asthma_medicine == '') {
      user_temp.asthma_medicine_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever used an inhaler or taken asthma medicine?"); return false;


    }
    if (user_temp.explain_asthma_medicine == '' && user_temp.asthma_medicine == 'Yes') {
      user_temp.explain_asthma_medicine_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you ever used an inhaler or taken asthma medicine?"); return false;

    }

    if (user_temp.asthma_family == '') {
      user_temp.asthma_family_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select Is there anyone in your family who has asthma?"); return false;

    }
    if (user_temp.explain_asthma_family == '' && user_temp.asthma_family == 'Yes') {
      user_temp.explain_asthma_family_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain Is there anyone in your family who has asthma?"); return false;


    }
    if (user_temp.kidney == '') {
      user_temp.kidney_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select Were you born without or are you missing a kidney, an eye, a testicle (males), your spleen, or any other organ?"); return false;

    }
    if (user_temp.explain_kidney == '' && user_temp.kidney == 'Yes') {
      user_temp.explain_kidney_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain Were you born without or are you missing a kidney, an eye, a testicle (males), your spleen, or any other organ?"); return false;


    }

    if (user_temp.hernia == '') {
      user_temp.hernia_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you have groin pain or a painful bulge or hernia in the groin area?"); return false;

    }
    if (user_temp.explain_hernia == '' && user_temp.hernia == 'Yes') {
      user_temp.explain_hernia_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do you have groin pain or a painful bulge or hernia in the groin area?"); return false;

    }
    if (user_temp.mononucleosis == '') {
      user_temp.mononucleosis_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you had infectious mononucleosis (mono) within the last month?"); return false;

    }
    if (user_temp.explain_mononucleosis == '' && user_temp.mononucleosis == 'Yes') {
      user_temp.explain_mononucleosis_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you had infectious mononucleosis (mono) within the last month?"); return false;

    }

    if (user_temp.pressure_sores == '') {
      user_temp.pressure_sores_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you have any rashes, pressure sores, or other skin problems?"); return false;


    }
    if (user_temp.explain_pressure_sores == '' && user_temp.pressure_sores == 'Yes') {
      user_temp.explain_pressure_sores_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do you have any rashes, pressure sores, or other skin problems?"); return false;

    }
    if (user_temp.mrsa == '') {
      user_temp.mrsa_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you had a herpes or MRSA skin infection?"); return false;


    }
    if (user_temp.explain_mrsa == '' && user_temp.mrsa == 'Yes') {
      user_temp.explain_mrsa_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you had a herpes or MRSA skin infection?"); return false;

    }
    if (user_temp.head_injury == '') {
      user_temp.head_injury_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever had a head injury or concussion?"); return false;


    }
    if (user_temp.explain_head_injury == '' && user_temp.head_injury == 'Yes') {
      user_temp.explain_head_injury_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you ever had a head injury or concussion?"); return false;

    }
    if (user_temp.memory_problems == '') {
      user_temp.memory_problems_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever had a hit or blow to the head that caused confusion, prolonged headache, or memory problems?"); return false;

    }
    if (user_temp.explain_memory_problems == '' && user_temp.memory_problems == 'Yes') {
      user_temp.explain_memory_problems_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you ever had a hit or blow to the head that caused confusion, prolonged headache, or memory problems?"); return false;

    }
    if (user_temp.seizure_disorder == '') {
      user_temp.seizure_disorder_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you have a history of seizure disorder?"); return false;

    }
    if (user_temp.explain_seizure_disorder == '' && user_temp.seizure_disorder == 'Yes') {
      user_temp.explain_seizure_disorder_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do you have a history of seizure disorder?"); return false;

    }



    if (user_temp.headaches_exercise == '') {
      user_temp.headaches_exercise_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you have headaches with exercise?"); return false;


    }

    if (user_temp.explain_headaches_exercise == '' && user_temp.headaches_exercise == 'Yes') {
      user_temp.explain_headaches_exercise_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do you have headaches with exercise?"); return false;

    }



    if (user_temp.numbness == '') {
      user_temp.numbness_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever had numbness, tingling, or weakness in your arms or legs after being hit or falling?"); return false;


    }

    if (user_temp.explain_numbness == '' && user_temp.numbness == 'Yes') {
      user_temp.explain_numbness_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you ever had numbness, tingling, or weakness in your arms or legs after being hit or falling?"); return false;

    }




    if (user_temp.arms == '') {
      user_temp.arms_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever been unable to move your arms or legs after being hit or falling?"); return false;


    }

    if (user_temp.explain_arms == '' && user_temp.arms == 'Yes') {
      user_temp.explain_arms_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you ever been unable to move your arms or legs after being hit or falling?"); return false;

    }



    if (user_temp.heal == '') {
      user_temp.heal_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever become ill while exercising in the heal?"); return false;


    }

    if (user_temp.explain_heal == '' && user_temp.heal == 'Yes') {
      user_temp.explain_heal_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you ever become ill while exercising in the heal?"); return false;

    }



    if (user_temp.cramps == '') {
      user_temp.cramps_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you get frequent muscle cramps when exercising?"); return false;


    }

    if (user_temp.explain_cramps == '' && user_temp.cramps == 'Yes') {
      user_temp.explain_cramps_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do you get frequent muscle cramps when exercising?"); return false;

    }


    if (user_temp.sickle == '') {
      user_temp.sickle_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you or someone in your family have sickle cell trait or disease?"); return false;


    }

    if (user_temp.explain_sickle == '' && user_temp.sickle == 'Yes') {
      user_temp.explain_sickle_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do you or someone in your family have sickle cell trait or disease?"); return false;

    }


    if (user_temp.vision == '') {
      user_temp.vision_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you had any problems with your eyes or vision?"); return false;


    }

    if (user_temp.explain_vision == '' && user_temp.vision == 'Yes') {
      user_temp.explain_vision_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you had any problems with your eyes or vision?"); return false;


    }


    if (user_temp.eye_injuries == '') {
      user_temp.eye_injuries_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you had any eye injuries?"); return false;


    }

    if (user_temp.explain_eye_injuries == '' && user_temp.eye_injuries == 'Yes') {
      user_temp.explain_eye_injuries_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you had any eye injuries?"); return false;


    }


    if (user_temp.contact_lenses == '') {
      user_temp.contact_lenses_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you wear glasses or contact lenses?"); return false;
    }

    if (user_temp.explain_contact_lenses == '' && user_temp.contact_lenses == 'Yes') {
      user_temp.explain_contact_lenses_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do you wear glasses or contact lenses?"); return false;

    }




    if (user_temp.face_shield == '') {
      user_temp.face_shield_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you wear protective eyewear, such as goggles or a face shield?"); return false;

    }

    if (user_temp.explain_face_shield == '' && user_temp.face_shield == 'Yes') {
      user_temp.explain_face_shield_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do you wear protective eyewear, such as goggles or a face shield?"); return false;

    }


    if (user_temp.weight == '') {
      user_temp.weight_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you worry about your weight?"); return false;

    }

    if (user_temp.explain_weight == '' && user_temp.weight == 'Yes') {
      user_temp.explain_weight_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do you worry about your weight?"); return false;

    }


    if (user_temp.lose_weight == '') {
      user_temp.lose_weight_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select are you trying to or has anyone recommended that you gain or lose weight?"); return false;

    }

    if (user_temp.explain_lose_weight == '' && user_temp.lose_weight == 'Yes') {
      user_temp.explain_lose_weight_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain are you trying to or has anyone recommended that you gain or lose weight?"); return false;

    }

    if (user_temp.foods == '') {
      user_temp.foods_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select are you on a special diet or do you avoid certain types of foods?"); return false;

    }

    if (user_temp.explain_foods == '' && user_temp.foods == 'Yes') {
      user_temp.explain_foods_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain are you on a special diet or do you avoid certain types of foods?"); return false;

    }

    if (user_temp.eating_disorder == '') {
      user_temp.eating_disorder_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select have you ever had an eating disorder?"); return false;


    }

    if (user_temp.explain_eating_disorder == '' && user_temp.eating_disorder == 'Yes') {
      user_temp.explain_eating_disorder_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain have you ever had an eating disorder?"); return false;


    }

    if (user_temp.doctor == '') {
      user_temp.doctor_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please select do you have any concerns that you would like to discuss with a doctor?"); return false;


    }

    if (user_temp.explain_doctor == '' && user_temp.doctor == 'Yes') {
      user_temp.explain_doctor_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please explain do you have any concerns that you would like to discuss with a doctor?"); return false;

    }


    //       if (user_temp.menstrual== '') {
    //     user_temp.menstrual_error=true;
    //                setThirdforminInfo(user_temp); 
    // setErrorMsgThird("Please select have you ever had a menstrual period?");return false;


    //           }

    //            if (user_temp.explain_menstrual== '' && user_temp.menstrual== 'Yes') {
    //     user_temp.explain_menstrual_error=true;
    //             setThirdforminInfo(user_temp); 
    // setErrorMsgThird("Please explain have you ever had a menstrual period?");return false;

    //           }

    //            if (user_temp.menstrual_period== '') {
    //     user_temp.menstrual_period_error=true;
    //                        setThirdforminInfo(user_temp); 
    // setErrorMsgThird("Please enter How old were you when you had your first menstrual period?");return false;

    //           }

    // if (user_temp.periods== '') {
    //     user_temp.periods_error=true;

    //             setThirdforminInfo(user_temp); 
    // setErrorMsgThird("Please enter How many periods have you had in the last 12 months?");return false;

    //           }

    if (user_temp.athlete_signature == '') {
      user_temp.athlete_signature_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please enter signature of athlete"); return false;


    }
    if (user_temp.parent_signature == '') {
      user_temp.parent_signature_error = true;
      setThirdforminInfo(user_temp);
      setErrorMsgThird("Please enter signature of parent/guardian"); return false;


    }

    if (userData != null && userData.locat_up == "0" && (checkdiss == false)) {
      setSubmitch('third');
      var resultnew = locations.map(function (el) {
        var o = Object.assign({}, el);
        if (userData.location_at_id == o.location_id) {
          setmainSearchValue(o.location_id);
          setInputValue(o);
         

 setCheckdiss(true);
          setSearchValue(o);
         setTimeout(function () {
            setOpendischolllog(true);
          }, 500);
          return false;

        }


        //return o;
      });

      return false;
    } else {
      setOpendischolllog(false);
    }

    user_temp.date = user_temp.datefif + user_temp.datesix + user_temp.dateseven + user_temp.dateeight + '-' + user_temp.datefir + user_temp.datesec + '-' + user_temp.dateth + user_temp.datefor;

    setparentLoaderThird(true);
    setOpenLog(true);
    Axios.post(`/pdf_form_submit`, { studid: userData.stuid, id: 3, formdata: user_temp, ip_address: ipuser, newlocation: mainsearchValue })
      .then(res => {
        console.log(res.data);

        if (res.data.status == true) {
          secureLocalStorage.setItem("userdata", JSON.stringify(res.data.studentdetalis));

          console.log(res.data.data);
          var arrst = [];
          var docnew = {};
          var resultnew = res.data.studentdata.map(function (el) {
            var o = Object.assign({}, el);
            if (o.form_id == 3) {
              docnew = o;

            }


            //return o;
          });
          console.log(docnew);
          console.log(allstudentlisdata);
          if (allstudentlisdata.length > 0) {
            arrst.push(docnew);
            var resultk = allstudentlisdata.map(function (el) {
              var ou = Object.assign({}, el);

              if (ou.form_id != 3) {


                arrst.push(ou);
              } else {

              }

              console.log(allstudentlisdata);
              console.log(ou);

              return ou;
            });
          } else {
            arrst.push(docnew);
          }

          console.log(arrst);
          setAllstudentlisdata(arrst);
          secureLocalStorage.setItem("studenentformdata", JSON.stringify(arrst));

          // storage[0].userdata = res.data.data;
          // secureLocalStorage.setItem("studenentformdata", JSON.stringify(res.data.studentdata));
          // setAllstudentlisdata(res.data.studentdata);
          setparentLoaderThird(false);
          setSuccessMsgThird('Form Submitted Successfully');
          setOpenLog(false);
          setTimeout(function () {
            setOpenLog(false);
            setSuccessMsgThird('');
            setErrorMsgThird('');

          }, 1000);

        }
        else {

          setErrorMsgThird(res.data.data);
          setparentLoaderThird(false);
        }

      })
      .catch(error => {
        setErrorMsgThird('Network Connection Problem, please try again!');
        setparentLoaderThird(false);

      });

  }


  var fifthform_default = {
    datefir: '',

    datefir_error: false,
    datesec: '',


    dateth: '',


    datefor: '',


    datefif: '',


    datesix: '',


    dateseven: '',


    dateeight: '',


    sports: '',

    sports_error: false,
    advised_not_participate: '',
    advised_not_participate_error: false,

    explain_advised_not_participate: '',
    explain_advised_not_participate_error: false,

    sustained_lost_memory: '',
    sustained_lost_memory_error: false,

    explain_sustained_lost_memory: '',
    explain_sustained_lost_memory_error: false,
    broken_bone: '',
    broken_bone_error: false,

    explain_broken_bone: '',
    explain_broken_bone_error: false,


    fainted: '',
    fainted_error: false,

    explain_fainted: '',
    explain_fainted_error: false,

    chest_pains: '',
    chest_pains_error: false,

    explain_chest_pains: '',
    explain_chest_pains_error: false,


    unusual_tiredness: '',
    unusual_tiredness_error: false,

    explain_unusual_tiredness: '',
    explain_unusual_tiredness_error: false,



    emergency_room: '',
    emergency_room_error: false,

    explain_emergency_room: '',
    explain_emergency_room_error: false,

    sudden_death_any_member: '',
    sudden_death_any_member_error: false,

    explain_sudden_death_any_member: '',
    explain_sudden_death_any_member_error: false,


    prescribed_medications: '',
    prescribed_medications_error: false,

    explain_prescribed_medications: '',
    explain_prescribed_medications_error: false,


    been_coronavirus: '',
    been_coronavirus_error: false,

    explain_been_coronavirus: '',
    explain_been_coronavirus_error: false,


    coronavirus_symptomatic: '',
    coronavirus_symptomatic_error: false,

    explain_coronavirus_symptomatic: '',
    explain_coronavirus_symptomatic_error: false,

    coronavirus_hospitalized: '',
    coronavirus_hospitalized_error: false,

    explain_coronavirus_hospitalized: '',
    explain_coronavirus_hospitalized_error: false,


    parent_signature: '',
    parent_signature_error: false,



  };

  const [fifthformInfo, setFifthforminInfo] = useState(fifthform_default);




  const handleChangeFifth = (event) => {
    var user_temp = { ...fifthformInfo };

    setSuccessMsgFifth('');
    setErrorMsgFifth('');
    user_temp.datefir_error = false;
    user_temp.sports_error = false;
    user_temp.advised_not_participate_error = false;
    user_temp.explain_advised_not_participate_error = false;
    user_temp.sustained_lost_memory_error = false;
    user_temp.explain_sustained_lost_memory_error = false;
    user_temp.broken_bone_error = false;
    user_temp.explain_broken_bone_error = false;
    user_temp.fainted_error = false;
    user_temp.explain_fainted_error = false;
    user_temp.chest_pains_error = false;
    user_temp.explain_chest_pains_error = false;
    user_temp.unusual_tiredness_error = false;
    user_temp.explain_unusual_tiredness_error = false;
    user_temp.emergency_room_error = false;
    user_temp.explain_emergency_room_error = false;
    user_temp.sudden_death_any_member_error = false;
    user_temp.explain_sudden_death_any_member_error = false;
    user_temp.prescribed_medications_error = false;
    user_temp.explain_prescribed_medications_error = false;
    user_temp.been_coronavirus_error = false;
    user_temp.explain_been_coronavirus_error = false;
    user_temp.coronavirus_symptomatic_error = false;
    user_temp.explain_coronavirus_symptomatic_error = false;
    user_temp.coronavirus_hospitalized_error = false;
    user_temp.explain_coronavirus_hospitalized_error = false;
    user_temp.parent_signature_error = false;


    if (event.target.name == "datefir") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datefir = value;
      }
      document.getElementById('datesec_fif').focus();
    }
    if (event.target.name == "datesec") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datesec = value;
      }
      document.getElementById('dateth_fif').focus();
    }
    if (event.target.name == "dateth") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.dateth = value;
      }
      document.getElementById('datefor_fif').focus();
    }
    if (event.target.name == "datefor") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datefor = value;
      }
      document.getElementById('datefif_fif').focus();

    }
    if (event.target.name == "datefif") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datefif = value;
      }
      document.getElementById('datesix_fif').focus();

    }
    if (event.target.name == "datesix") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datesix = value;
      }
      document.getElementById('dateseven_fif').focus();


    }
    if (event.target.name == "dateseven") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.dateseven = value;
      }
      document.getElementById('dateeight_fif').focus();


    }
    if (event.target.name == "dateeight") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.dateeight = value;
      }

    }

    if (event.target.name == "sports") {
      user_temp.sports = event.target.value;

    }


    if (event.target.name == "advised_not_participate") {
      user_temp.advised_not_participate = event.target.value;

    }

    if (event.target.name == "explain_advised_not_participate") {
      console.log(event.target.name);
      console.log(event.target.value);
      user_temp.explain_advised_not_participate = event.target.value;

    }

    if (event.target.name == "sustained_lost_memory") {
      user_temp.sustained_lost_memory = event.target.value;

    }
    if (event.target.name == "explain_sustained_lost_memory") {
      user_temp.explain_sustained_lost_memory = event.target.value;

    }
    if (event.target.name == "broken_bone") {
      user_temp.broken_bone = event.target.value;

    }

    if (event.target.name == "explain_broken_bone") {
      user_temp.explain_broken_bone = event.target.value;

    }
    if (event.target.name == "fainted") {
      user_temp.fainted = event.target.value;

    }


    if (event.target.name == "explain_fainted") {
      user_temp.explain_fainted = event.target.value;

    }
    if (event.target.name == "chest_pains") {
      user_temp.chest_pains = event.target.value;

    }

    if (event.target.name == "explain_chest_pains") {
      user_temp.explain_chest_pains = event.target.value;

    }
    if (event.target.name == "unusual_tiredness") {
      user_temp.unusual_tiredness = event.target.value;

    }
    if (event.target.name == "explain_unusual_tiredness") {
      user_temp.explain_unusual_tiredness = event.target.value;

    }
    if (event.target.name == "emergency_room") {
      user_temp.emergency_room = event.target.value;

    }
    if (event.target.name == "explain_emergency_room") {
      user_temp.explain_emergency_room = event.target.value;

    }
    if (event.target.name == "sudden_death_any_member") {
      user_temp.sudden_death_any_member = event.target.value;

    }

    if (event.target.name == "explain_sudden_death_any_member") {
      user_temp.explain_sudden_death_any_member = event.target.value;

    }
    if (event.target.name == "prescribed_medications") {
      user_temp.prescribed_medications = event.target.value;

    }
    if (event.target.name == "explain_prescribed_medications") {
      user_temp.explain_prescribed_medications = event.target.value;

    }
    if (event.target.name == "been_coronavirus") {
      user_temp.been_coronavirus = event.target.value;

    }
    if (event.target.name == "explain_been_coronavirus") {
      user_temp.explain_been_coronavirus = event.target.value;

    }

    if (event.target.name == "coronavirus_symptomatic") {
      user_temp.coronavirus_symptomatic = event.target.value;

    }
    if (event.target.name == "explain_coronavirus_symptomatic") {
      user_temp.explain_coronavirus_symptomatic = event.target.value;

    }
    if (event.target.name == "coronavirus_hospitalized") {
      user_temp.coronavirus_hospitalized = event.target.value;

    }
    if (event.target.name == "explain_coronavirus_hospitalized") {
      user_temp.explain_coronavirus_hospitalized = event.target.value;

    }
    if (event.target.name == "parent_signature") {
      user_temp.parent_signature = event.target.value;

    }

    secureLocalStorage.setItem("alldatafifthform", JSON.stringify(user_temp));

    secureLocalStorage.setItem("oldstudid", (userData.stuid));
    setFifthforminInfo(user_temp);





  }


  const [successMsgFifth, setSuccessMsgFifth] = useState('');
  const [errorMsgFifth, setErrorMsgFifth] = useState('');

  const [parentLoaderFifth, setparentLoaderFifth] = useState(false);

  const handleSubmitFifth = (event) => {

    setSuccessMsgFifth('');
    setErrorMsgFifth('');
    var user_temp = { ...fifthformInfo };



    user_temp.datefir_error = false;
    user_temp.sports_error = false;
    user_temp.advised_not_participate_error = false;
    user_temp.explain_advised_not_participate_error = false;
    user_temp.sustained_lost_memory_error = false;
    user_temp.explain_sustained_lost_memory_error = false;
    user_temp.broken_bone_error = false;
    user_temp.explain_broken_bone_error = false;
    user_temp.fainted_error = false;
    user_temp.explain_fainted_error = false;
    user_temp.chest_pains_error = false;
    user_temp.explain_chest_pains_error = false;
    user_temp.unusual_tiredness_error = false;
    user_temp.explain_unusual_tiredness_error = false;
    user_temp.emergency_room_error = false;
    user_temp.explain_emergency_room_error = false;
    user_temp.sudden_death_any_member_error = false;
    user_temp.explain_sudden_death_any_member_error = false;
    user_temp.prescribed_medications_error = false;
    user_temp.explain_prescribed_medications_error = false;
    user_temp.been_coronavirus_error = false;
    user_temp.explain_been_coronavirus_error = false;
    user_temp.coronavirus_symptomatic_error = false;
    user_temp.explain_coronavirus_symptomatic_error = false;
    user_temp.coronavirus_hospitalized_error = false;
    user_temp.explain_coronavirus_hospitalized_error = false;
    user_temp.parent_signature_error = false;


    if (user_temp.datefir == "") {
      user_temp.datefir_error = true;

      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter date of last physical examination"); return false;
    }

    if (user_temp.datesec == "") {
      user_temp.datefir_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter date of last physical examination"); return false;
    }


    if (user_temp.dateth == '') {
      user_temp.datefir_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter date of last physical examination"); return false;
    }


    if (user_temp.datefor == '') {
      user_temp.datefir_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter date of last physical examination"); return false;
    }
    if (user_temp.datefif == '') {

      user_temp.datefir_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter date of last physical examination"); return false;
    }

    if (user_temp.datesix == '') {

      user_temp.datefir_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter date of last physical examination"); return false;
    }

    if (user_temp.dateseven == '') {
      user_temp.datefir_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter date of last physical examination"); return false;
    }

    if (user_temp.dateeight == "") {
      user_temp.datefir_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter date of last physical examination"); return false;
    }

    if (user_temp.sports == '') {
      user_temp.sports_error = true;

      setFifthforminInfo(user_temp);
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter sports name"); return false;
    }

    if (user_temp.advised_not_participate == '') {
      user_temp.advised_not_participate_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please select been medically advised not to participate in a sport?"); return false;
    }
    console.log(user_temp.explain_advised_not_participate);
    console.log(user_temp.advised_not_participate);


    if (user_temp.explain_advised_not_participate == ''
      && user_temp.advised_not_participate == 'Yes') {
      user_temp.explain_advised_not_participate_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain been medically advised not to participate in a sport?"); return false;
    }


    if (user_temp.sustained_lost_memory == '') {
      user_temp.sustained_lost_memory_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select sustained a concussion, been unconscious or lost memory from a blow to the head?"); return false;

    }
    if (user_temp.explain_sustained_lost_memory == ''
      && user_temp.sustained_lost_memory == 'Yes') {
      user_temp.explain_sustained_lost_memory_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain sustained a concussion, been unconscious or lost memory from a blow to the head?"); return false;
    }


    if (user_temp.broken_bone == '') {
      user_temp.broken_bone_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select broken a bone or sprained/strained/dislocated any muscle or joints?"); return false;

    }

    if (user_temp.explain_broken_bone == ''
      && user_temp.broken_bone == 'Yes') {
      user_temp.explain_broken_bone_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain broken a bone or sprained/strained/dislocated any muscle or joints?"); return false;
    }

    //         if (user_temp.explain_restricted== '' ) {
    // user_temp.explain_restricted_error=true;

    //       }
    if (user_temp.fainted == '') {
      user_temp.fainted_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select fainted or blacked out?"); return false;


    }
    if (user_temp.explain_fainted == ''
      && user_temp.fainted == 'Yes') {
      user_temp.explain_fainted_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain fainted or blacked out?"); return false;
    }



    //        if (user_temp.explain== '') {
    // user_temp.explain_error=true;

    //       }
    if (user_temp.chest_pains == '') {
      user_temp.chest_pains_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select experienced chest pains, shortness of breath or racing heart?"); return false;

    }
    if (user_temp.explain_chest_pains == ''
      && user_temp.chest_pains == 'Yes') {
      user_temp.explain_chest_pains_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain experienced chest pains, shortness of breath or racing heart?"); return false;
    }




    //        if (user_temp.explain_exercise== '') {
    // user_temp.explain_exercise_error=true;

    //       }
    if (user_temp.unusual_tiredness == '') {
      user_temp.unusual_tiredness_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select has there been a recent history of fatigue and unusual tiredness?"); return false;


    }

    if (user_temp.explain_unusual_tiredness == ''
      && user_temp.unusual_tiredness == 'Yes') {
      user_temp.explain_unusual_tiredness_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain has there been a recent history of fatigue and unusual tiredness?"); return false;
    }

    //        if (user_temp.explain_chest== '') {
    // user_temp.explain_chest_error=true;

    //       }
    if (user_temp.emergency_room == '') {
      user_temp.emergency_room_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select been hospitalized or had to go to the emergency room?"); return false;


    }

    if (user_temp.explain_emergency_room == ''
      && user_temp.emergency_room == 'Yes') {
      user_temp.explain_emergency_room_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain  been hospitalized or had to go to the emergency room?"); return false;

    }

    //        if (user_temp.explain_irregular== '') {
    // user_temp.explain_irregular_error=true;

    //       }
    if (user_temp.sudden_death_any_member == '') {
      user_temp.sudden_death_any_member_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select since the last physical examination, has there been a sudden death in the family or has any member of the family under age 50 had a heart attack or heart trouble?"); return false;


    }

    if (user_temp.explain_sudden_death_any_member == ''
      && user_temp.sudden_death_any_member == 'Yes') {
      user_temp.explain_sudden_death_any_member_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain  since the last physical examination, has there been a sudden death in the family or has any member of the family under age 50 had a heart attack or heart trouble?"); return false;
    }


    if (user_temp.prescribed_medications == '') {
      user_temp.prescribed_medications_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select started or stopped taking any over-the-counter or prescribed medications?"); return false;


    }

    if (user_temp.explain_prescribed_medications == ''
      && user_temp.prescribed_medications == 'Yes') {
      user_temp.explain_prescribed_medications_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain  started or stopped taking any over-the-counter or prescribed medications?"); return false;
    }

    //        if (user_temp.explain_heart_doctor== '') {
    // user_temp.explain_heart_doctor_error=true;

    //       }

    //        if (user_temp.explain_lightheaded== '') {
    // user_temp.explain_lightheaded_error=true;

    //       }
    if (user_temp.been_coronavirus == '') {
      user_temp.been_coronavirus_error = true;

      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select been diagnosed with Coronavirus (COVID-19)?"); return false;

    }
    if (user_temp.explain_been_coronavirus == ''
      && user_temp.been_coronavirus == 'Yes') {
      user_temp.explain_been_coronavirus_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain  been diagnosed with Coronavirus (COVID-19)?"); return false;
    }

    //        if (user_temp.explain_seizure== '') {
    // user_temp.explain_seizure_error=true;

    //       }



    if (user_temp.coronavirus_symptomatic == '') {
      user_temp.coronavirus_symptomatic_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select if diagnosed with Coronavirus (COVID-19), was your son/daughter symptomatic?"); return false;


    }

    if (user_temp.explain_coronavirus_symptomatic == ''
      && user_temp.coronavirus_symptomatic == 'Yes') {
      user_temp.explain_coronavirus_symptomatic_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain  if diagnosed with Coronavirus (COVID-19), was your son/daughter symptomatic?"); return false;
    }

    //        if (user_temp.explain_breath== '') {
    // user_temp.explain_breath_error=true;

    //       }

    if (user_temp.coronavirus_hospitalized == '') {
      user_temp.coronavirus_hospitalized_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select if diagnosed with Coronavirus (COVID-19), was your son/daughter hospitalized?"); return false;


    }
    if (user_temp.explain_coronavirus_hospitalized == ''
      && user_temp.coronavirus_hospitalized == 'Yes') {
      user_temp.explain_coronavirus_hospitalized_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain  if diagnosed with Coronavirus (COVID-19), was your son/daughter hospitalized?"); return false;
    }


    if (user_temp.parent_signature == '') {
      user_temp.parent_signature_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter signature of parent/guardian"); return false;


    }
    if (userData != null && userData.locat_up == "0" && (checkdiss == false)) {
      setSubmitch('five');
      var resultnew = locations.map(function (el) {
        var o = Object.assign({}, el);
        if (userData.location_at_id == o.location_id) {
          setmainSearchValue(o.location_id);
          setInputValue(o);
           

 setCheckdiss(true);
          setSearchValue(o);
         setTimeout(function () {
            setOpendischolllog(true);
          }, 500);
          return false;

        }


        //return o;
      });

      return false;
    } else {
      setOpendischolllog(false);
    }
    setparentLoaderFifth(true);
    user_temp.date = user_temp.datefif + user_temp.datesix + user_temp.dateseven + user_temp.dateeight + '-' + user_temp.datefir + user_temp.datesec + '-' + user_temp.dateth + user_temp.datefor;
    setOpenLog(true);
    Axios.post(`/pdf_form_submit`, { studid: userData.stuid, id: 5, formdata: user_temp, ip_address: ipuser, newlocation: mainsearchValue })
      .then(res => {
        console.log(res.data);

        if (res.data.status == true) {
          secureLocalStorage.setItem("userdata", JSON.stringify(res.data.studentdetalis));

          console.log(res.data.data);
          var arrst = [];
          var docnew = {};
          var resultnew = res.data.studentdata.map(function (el) {
            var o = Object.assign({}, el);
            if (o.form_id == 5) {
              docnew = o;

            }


            //return o;
          });
          console.log(docnew);
          console.log(allstudentlisdata);
          if (allstudentlisdata.length > 0) {
            arrst.push(docnew);
            var resultk = allstudentlisdata.map(function (el) {
              var ou = Object.assign({}, el);

              if (ou.form_id != 5) {


                arrst.push(ou);
              } else {

              }

              console.log(allstudentlisdata);
              console.log(ou);

              return ou;
            });
          } else {
            arrst.push(docnew);
          }

          console.log(arrst);
          setAllstudentlisdata(arrst);
          secureLocalStorage.setItem("studenentformdata", JSON.stringify(arrst));

          // storage[0].userdata = res.data.data;
          // secureLocalStorage.setItem("studenentformdata", JSON.stringify(res.data.studentdata));
          // setAllstudentlisdata(res.data.studentdata);
          setparentLoaderFifth(false);
          setSuccessMsgFifth('Form Submitted Successfully');
          setOpenLog(false);
          setTimeout(function () {
            setOpenLog(false);
            setSuccessMsgFifth('');
            setErrorMsgFifth('');

          }, 1000);

        }
        else {

          setErrorMsgFifth(res.data.data);
          setparentLoaderFifth(false);
        }

      })
      .catch(error => {
        setErrorMsgFifth('Network Connection Problem, please try again!');
        setparentLoaderFifth(false);

      });

  }
  var forthform_default = {
    datefir: '',

    datefir_error: false,
    datesec: '',


    dateth: '',


    datefor: '',


    datefif: '',


    datesix: '',


    dateseven: '',


    dateeight: '',


    sports: '',

    sports_error: false,
    disability: '',
    disability_error: false,


    date_of_disability: '',
    date_of_disability_text: '',
    date_of_disability_error: false,

    classification: '',
    classification_error: false,

    cause_of_disability: '',
    cause_of_disability_error: false,


    list_of_sports: '',
    list_of_sports_error: false,



    use_assistive_device: '',
    use_assistive_device_error: false,

    explain_use_assistive_device: '',
    explain_use_assistive_device_error: false,




    special_brace: '',
    special_brace_error: false,

    explain_special_brace: '',
    explain_special_brace_error: false,

    any_rashes_pressure: '',
    any_rashes_pressure_error: false,

    explain_any_rashes_pressure: '',
    explain_any_rashes_pressure_error: false,

    hearing_loss: '',
    hearing_loss_error: false,

    explain_hearing_loss: '',
    explain_hearing_loss_error: false,

    visual_impairment: '',
    visual_impairment_error: false,

    explain_visual_impairment: '',
    explain_visual_impairment_error: false,

    bowel_bladder_function: '',
    bowel_bladder_function_error: false,

    explain_bowel_bladder_function: '',
    explain_bowel_bladder_function_error: false,

    discomfort_when_urinating: '',
    discomfort_when_urinating_error: false,

    explain_discomfort_when_urinating: '',
    explain_discomfort_when_urinating_error: false,
    autonomic_dysreflexia: '',
    autonomic_dysreflexia_error: false,

    explain_autonomic_dysreflexia: '',
    explain_autonomic_dysreflexia_error: false,

    diagnosed_heat_related: '',
    diagnosed_heat_related_error: false,

    explain_diagnosed_heat_related: '',
    explain_diagnosed_heat_related_error: false,


    muscle_spasticity: '',
    muscle_spasticity_error: false,

    explain_muscle_spasticity: '',
    explain_muscle_spasticity_error: false,

    frequent_seizures: '',
    frequent_seizures_error: false,

    explain_frequent_seizures: '',
    explain_frequent_seizures_error: false,

    atlantoaxial_instability: '',
    atlantoaxial_instability_error: false,

    explain_atlantoaxial_instability: '',
    explain_atlantoaxial_instability_error: false,


    xray_evaluation: '',
    xray_evaluation_error: false,

    explain_xray_evaluation: '',
    explain_xray_evaluation_error: false,

    dislocated_joints: '',
    dislocated_joints_error: false,

    explain_dislocated_joints: '',
    explain_dislocated_joints_error: false,


    easy_bleeding: '',
    easy_bleeding_error: false,

    explain_easy_bleeding: '',
    explain_easy_bleeding_error: false,

    enlarged_spleen: '',
    enlarged_spleen_error: false,

    explain_enlarged_spleen: '',
    explain_enlarged_spleen_error: false,


    hepatitis: '',
    hepatitis_error: false,

    explain_hepatitis: '',
    explain_hepatitis_error: false,

    osteopenia_or_osteoporosis: '',
    osteopenia_or_osteoporosis_error: false,

    explain_osteopenia_or_osteoporosis: '',
    explain_osteopenia_or_osteoporosis_error: false,


    controlling_bowel: '',
    controlling_bowel_error: false,

    explain_controlling_bowel: '',
    explain_controlling_bowel_error: false,


    controlling_bladder: '',
    controlling_bladder_error: false,

    explain_controlling_bladder: '',
    explain_controlling_bladder_error: false,

    numbnesss_in_arms_or_hands: '',
    numbnesss_in_arms_or_hands_error: false,

    explain_numbnesss_in_arms_or_hands: '',
    explain_numbnesss_in_arms_or_hands_error: false,


    numbnesss_in_legs_or_feet: '',
    numbnesss_in_legs_or_feet_error: false,

    explain_numbnesss_in_legs_or_feet: '',
    explain_numbnesss_in_legs_or_feet_error: false,

    weakness_in_arms_hands: '',
    weakness_in_arms_hands_error: false,

    explain_weakness_in_arms_hands: '',
    explain_weakness_in_arms_hands_error: false,


    weakness_in_leg_feet: '',
    weakness_in_leg_feet_error: false,

    explain_weakness_in_leg_feet: '',
    explain_weakness_in_leg_feet_error: false,


    change_in_coordination: '',
    change_in_coordination_error: false,

    explain_change_in_coordination: '',
    explain_change_in_coordination_error: false,


    change_ability_walk: '',
    change_ability_walk_error: false,

    explain_change_ability_walk: '',
    explain_change_ability_walk_error: false,

    spina_bifida: '',
    spina_bifida_error: false,

    explain_spina_bifida: '',
    explain_spina_bifida_error: false,


    latex_allergy: '',
    latex_allergy_error: false,

    explain_latex_allergy: '',
    explain_latex_allergy_error: false,

    athlete_signature: '',
    athlete_signature_error: false,

    parent_signature: '',
    parent_signature_error: false,






  };

  const [forthformInfo, setForthforminInfo] = useState(forthform_default);

  const [chaechdateofdid, setChaechdateofdid] = useState(false);





  const handleChangeForth = (event) => {
    var user_temp = { ...forthformInfo };

    setSuccessMsgForth('');
    setErrorMsgForth('');
    user_temp.datefir_error = false;
    user_temp.sports_error = false;
    user_temp.disability_error = false;
    user_temp.date_of_disability_error = false;
    user_temp.classification_error = false;
    user_temp.cause_of_disability_error = false;
    user_temp.list_of_sports_error = false;
    user_temp.use_assistive_device_error = false;
    user_temp.explain_use_assistive_device_error = false;
    user_temp.special_brace_error = false;
    user_temp.explain_special_brace_error = false;
    user_temp.any_rashes_pressure_error = false;
    user_temp.explain_any_rashes_pressure_error = false;

    user_temp.hearing_loss_error = false;
    user_temp.explain_hearing_loss_error = false;
    user_temp.visual_impairment_error = false;
    user_temp.explain_visual_impairment_error = false;


    user_temp.bowel_bladder_function_error = false;
    user_temp.explain_bowel_bladder_function_error = false;

    user_temp.discomfort_when_urinating_error = false;
    user_temp.explain_discomfort_when_urinating_error = false;

    user_temp.autonomic_dysreflexia_error = false;
    user_temp.explain_autonomic_dysreflexia_error = false;
    user_temp.diagnosed_heat_related_error = false;
    user_temp.explain_diagnosed_heat_related_error = false;

    user_temp.muscle_spasticity_error = false;
    user_temp.explain_muscle_spasticity_error = false;


    user_temp.frequent_seizures_error = false;
    user_temp.explain_frequent_seizures_error = false;


    user_temp.atlantoaxial_instability_error = false;
    user_temp.explain_atlantoaxial_instability_error = false;

    user_temp.xray_evaluation_error = false;
    user_temp.explain_xray_evaluation_error = false;

    user_temp.dislocated_joints_error = false;
    user_temp.explain_dislocated_joints_error = false;

    user_temp.xray_evaluation_error = false;
    user_temp.explain_xray_evaluation_error = false;

    user_temp.easy_bleeding_error = false;
    user_temp.explain_easy_bleeding_error = false;

    user_temp.enlarged_spleen_error = false;
    user_temp.explain_enlarged_spleen_error = false;

    user_temp.hepatitis_error = false;
    user_temp.explain_hepatitis_error = false;

    user_temp.osteopenia_or_osteoporosis_error = false;
    user_temp.explain_osteopenia_or_osteoporosis_error = false;

    user_temp.controlling_bowel_error = false;
    user_temp.explain_controlling_bowel_error = false;

    user_temp.controlling_bladder_error = false;
    user_temp.explain_controlling_bladder_error = false;

    user_temp.numbnesss_in_arms_or_hands_error = false;
    user_temp.explain_numbnesss_in_arms_or_hands_error = false;

    user_temp.numbnesss_in_legs_or_feet_error = false;
    user_temp.explain_numbnesss_in_legs_or_feet_error = false;


    user_temp.weakness_in_arms_hands_error = false;
    user_temp.explain_weakness_in_arms_hands_error = false;


    user_temp.weakness_in_leg_feet_error = false;
    user_temp.explain_weakness_in_leg_feet_error = false;


    user_temp.change_in_coordination_error = false;
    user_temp.explain_change_in_coordination_error = false;


    user_temp.change_ability_walk_error = false;
    user_temp.explain_change_ability_walk_error = false;



    user_temp.spina_bifida_error = false;
    user_temp.explain_spina_bifida_error = false;
    user_temp.latex_allergy_error = false;
    user_temp.explain_latex_allergy_error = false;
    user_temp.athlete_signature_error = false;
    user_temp.parent_signature_error = false;





    if (event.target.name == "datefir") {

      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datefir = value;
      }


      document.getElementById('datesec_for').focus();
    }
    if (event.target.name == "datesec") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datesec = value;
      }
      document.getElementById('dateth_for').focus();
    }
    if (event.target.name == "dateth") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.dateth = value;
      }
      document.getElementById('datefor_for').focus();
    }
    if (event.target.name == "datefor") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datefor = value;
      }
      document.getElementById('datefif_for').focus();

    }
    if (event.target.name == "datefif") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datefif = value;
      }
      document.getElementById('datesix_for').focus();

    }
    if (event.target.name == "datesix") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datesix = value;
      }
      document.getElementById('dateseven_for').focus();


    }
    if (event.target.name == "dateseven") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.dateseven = value;
      }
      document.getElementById('dateeight_for').focus();


    }
    if (event.target.name == "dateeight") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.dateeight = value;
      }

    }

    if (event.target.name == "sports") {
      user_temp.sports = event.target.value;

    }


    if (event.target.name == "disability") {
      user_temp.disability = event.target.value;

    }

    if (event.target.name == "date_of_disability") {
      user_temp.date_of_disability = event.target.value;
      user_temp.date_of_disability_text = formatDate(event.target.value);
      console.log(user_temp.date_of_disability_text);

    }


    if (event.target.name == "classification") {
      user_temp.classification = event.target.value;

    }

    if (event.target.name == "cause_of_disability") {
      user_temp.cause_of_disability = event.target.value;

    }

    if (event.target.name == "list_of_sports") {
      user_temp.list_of_sports = event.target.value;

    }

    if (event.target.name == "use_assistive_device") {
      user_temp.use_assistive_device = event.target.value;

    }


    if (event.target.name == "explain_use_assistive_device") {
      user_temp.explain_use_assistive_device = event.target.value;

    }

    if (event.target.name == "special_brace") {
      user_temp.special_brace = event.target.value;

    }
    if (event.target.name == "explain_special_brace") {
      user_temp.explain_special_brace = event.target.value;

    }
    if (event.target.name == "any_rashes_pressure") {
      user_temp.any_rashes_pressure = event.target.value;

    }

    if (event.target.name == "explain_any_rashes_pressure") {
      user_temp.explain_any_rashes_pressure = event.target.value;

    }
    if (event.target.name == "hearing_loss") {
      user_temp.hearing_loss = event.target.value;

    }


    if (event.target.name == "explain_hearing_loss") {
      user_temp.explain_hearing_loss = event.target.value;

    }
    if (event.target.name == "visual_impairment") {
      user_temp.visual_impairment = event.target.value;

    }

    if (event.target.name == "explain_visual_impairment") {
      user_temp.explain_visual_impairment = event.target.value;

    }
    if (event.target.name == "bowel_bladder_function") {
      user_temp.bowel_bladder_function = event.target.value;

    }
    if (event.target.name == "explain_bowel_bladder_function") {
      user_temp.explain_bowel_bladder_function = event.target.value;

    }
    if (event.target.name == "discomfort_when_urinating") {
      user_temp.discomfort_when_urinating = event.target.value;

    }
    if (event.target.name == "explain_discomfort_when_urinating") {
      user_temp.explain_discomfort_when_urinating = event.target.value;

    }
    if (event.target.name == "autonomic_dysreflexia") {
      user_temp.autonomic_dysreflexia = event.target.value;

    }

    if (event.target.name == "explain_autonomic_dysreflexia") {
      user_temp.explain_autonomic_dysreflexia = event.target.value;

    }
    if (event.target.name == "diagnosed_heat_related") {
      user_temp.diagnosed_heat_related = event.target.value;

    }
    if (event.target.name == "explain_diagnosed_heat_related") {
      user_temp.explain_diagnosed_heat_related = event.target.value;

    }
    if (event.target.name == "muscle_spasticity") {
      user_temp.muscle_spasticity = event.target.value;

    }
    if (event.target.name == "explain_muscle_spasticity") {
      user_temp.explain_muscle_spasticity = event.target.value;

    }

    if (event.target.name == "frequent_seizures") {
      user_temp.frequent_seizures = event.target.value;

    }
    if (event.target.name == "explain_frequent_seizures") {
      user_temp.explain_frequent_seizures = event.target.value;

    }
    if (event.target.name == "atlantoaxial_instability") {
      user_temp.atlantoaxial_instability = event.target.value;

    }
    if (event.target.name == "explain_atlantoaxial_instability") {
      user_temp.explain_atlantoaxial_instability = event.target.value;

    }

    if (event.target.name == "xray_evaluation") {
      user_temp.xray_evaluation = event.target.value;

    }
    if (event.target.name == "explain_xray_evaluation") {
      user_temp.explain_xray_evaluation = event.target.value;

    }

    if (event.target.name == "dislocated_joints") {
      user_temp.dislocated_joints = event.target.value;

    }
    if (event.target.name == "explain_dislocated_joints") {
      user_temp.explain_dislocated_joints = event.target.value;

    }
    if (event.target.name == "easy_bleeding") {
      user_temp.easy_bleeding = event.target.value;

    }
    if (event.target.name == "explain_easy_bleeding") {
      user_temp.explain_easy_bleeding = event.target.value;

    }


    if (event.target.name == "enlarged_spleen") {
      user_temp.enlarged_spleen = event.target.value;

    }
    if (event.target.name == "explain_enlarged_spleen") {
      user_temp.explain_enlarged_spleen = event.target.value;

    }
    if (event.target.name == "hepatitis") {
      user_temp.hepatitis = event.target.value;

    }
    if (event.target.name == "explain_hepatitis") {
      user_temp.explain_hepatitis = event.target.value;

    }
    if (event.target.name == "osteopenia_or_osteoporosis") {
      user_temp.osteopenia_or_osteoporosis = event.target.value;

    }
    if (event.target.name == "explain_osteopenia_or_osteoporosis") {
      user_temp.explain_osteopenia_or_osteoporosis = event.target.value;

    }


    if (event.target.name == "controlling_bowel") {
      user_temp.controlling_bowel = event.target.value;

    }
    if (event.target.name == "explain_controlling_bowel") {
      user_temp.explain_controlling_bowel = event.target.value;

    }

    if (event.target.name == "controlling_bladder") {
      user_temp.controlling_bladder = event.target.value;

    }
    if (event.target.name == "explain_controlling_bladder") {
      user_temp.explain_controlling_bladder = event.target.value;

    }

    if (event.target.name == "numbnesss_in_arms_or_hands") {
      user_temp.numbnesss_in_arms_or_hands = event.target.value;

    }
    if (event.target.name == "explain_numbnesss_in_arms_or_hands") {
      user_temp.explain_numbnesss_in_arms_or_hands = event.target.value;

    }

    if (event.target.name == "numbnesss_in_legs_or_feet") {
      user_temp.numbnesss_in_legs_or_feet = event.target.value;

    }
    if (event.target.name == "explain_numbnesss_in_legs_or_feet") {
      user_temp.explain_numbnesss_in_legs_or_feet = event.target.value;

    }


    if (event.target.name == "weakness_in_arms_hands") {
      user_temp.weakness_in_arms_hands = event.target.value;

    }
    if (event.target.name == "explain_weakness_in_arms_hands") {
      user_temp.explain_weakness_in_arms_hands = event.target.value;

    }

    if (event.target.name == "weakness_in_leg_feet") {
      user_temp.weakness_in_leg_feet = event.target.value;

    }
    if (event.target.name == "explain_weakness_in_leg_feet") {
      user_temp.explain_weakness_in_leg_feet = event.target.value;

    }


    if (event.target.name == "change_in_coordination") {
      user_temp.change_in_coordination = event.target.value;

    }
    if (event.target.name == "explain_change_in_coordination") {
      user_temp.explain_change_in_coordination = event.target.value;

    }

    if (event.target.name == "change_ability_walk") {
      user_temp.change_ability_walk = event.target.value;

    }
    if (event.target.name == "explain_change_ability_walk") {
      user_temp.explain_change_ability_walk = event.target.value;

    }


    if (event.target.name == "spina_bifida") {
      user_temp.spina_bifida = event.target.value;

    }
    if (event.target.name == "explain_spina_bifida") {
      user_temp.explain_spina_bifida = event.target.value;

    }


    if (event.target.name == "latex_allergy") {
      user_temp.latex_allergy = event.target.value;

    }
    if (event.target.name == "explain_latex_allergy") {
      user_temp.explain_latex_allergy = event.target.value;

    }

    if (event.target.name == "athlete_signature") {
      user_temp.athlete_signature = event.target.value;

    }

    if (event.target.name == "parent_signature") {
      user_temp.parent_signature = event.target.value;

    }

    secureLocalStorage.setItem("alldataforthform", JSON.stringify(user_temp));

    secureLocalStorage.setItem("oldstudid", (userData.stuid));
    setForthforminInfo(user_temp);





  }


  const [successMsgForth, setSuccessMsgForth] = useState('');
  const [errorMsgForth, setErrorMsgForth] = useState('');

  const [parentLoaderForth, setparentLoaderForth] = useState(false);

  const handleSubmitForth = (event) => {

    setSuccessMsgForth('');
    setErrorMsgForth('');
    var user_temp = { ...forthformInfo };



    user_temp.datefir_error = false;
    user_temp.sports_error = false;
    user_temp.disability_error = false;
    user_temp.date_of_disability_error = false;
    user_temp.classification_error = false;
    user_temp.cause_of_disability_error = false;
    user_temp.list_of_sports_error = false;
    user_temp.use_assistive_device_error = false;
    user_temp.explain_use_assistive_device_error = false;
    user_temp.special_brace_error = false;
    user_temp.explain_special_brace_error = false;
    user_temp.any_rashes_pressure_error = false;
    user_temp.explain_any_rashes_pressure_error = false;

    user_temp.hearing_loss_error = false;
    user_temp.explain_hearing_loss_error = false;
    user_temp.visual_impairment_error = false;
    user_temp.explain_visual_impairment_error = false;


    user_temp.bowel_bladder_function_error = false;
    user_temp.explain_bowel_bladder_function_error = false;

    user_temp.discomfort_when_urinating_error = false;
    user_temp.explain_discomfort_when_urinating_error = false;

    user_temp.autonomic_dysreflexia_error = false;
    user_temp.explain_autonomic_dysreflexia_error = false;
    user_temp.diagnosed_heat_related_error = false;
    user_temp.explain_diagnosed_heat_related_error = false;

    user_temp.muscle_spasticity_error = false;
    user_temp.explain_muscle_spasticity_error = false;


    user_temp.frequent_seizures_error = false;
    user_temp.explain_frequent_seizures_error = false;


    user_temp.atlantoaxial_instability_error = false;
    user_temp.explain_atlantoaxial_instability_error = false;

    user_temp.xray_evaluation_error = false;
    user_temp.explain_xray_evaluation_error = false;

    user_temp.dislocated_joints_error = false;
    user_temp.explain_dislocated_joints_error = false;

    user_temp.xray_evaluation_error = false;
    user_temp.explain_xray_evaluation_error = false;

    user_temp.easy_bleeding_error = false;
    user_temp.explain_easy_bleeding_error = false;

    user_temp.enlarged_spleen_error = false;
    user_temp.explain_enlarged_spleen_error = false;

    user_temp.hepatitis_error = false;
    user_temp.explain_hepatitis_error = false;

    user_temp.osteopenia_or_osteoporosis_error = false;
    user_temp.explain_osteopenia_or_osteoporosis_error = false;

    user_temp.controlling_bowel_error = false;
    user_temp.explain_controlling_bowel_error = false;

    user_temp.controlling_bladder_error = false;
    user_temp.explain_controlling_bladder_error = false;

    user_temp.numbnesss_in_arms_or_hands_error = false;
    user_temp.explain_numbnesss_in_arms_or_hands_error = false;

    user_temp.numbnesss_in_legs_or_feet_error = false;
    user_temp.explain_numbnesss_in_legs_or_feet_error = false;


    user_temp.weakness_in_arms_hands_error = false;
    user_temp.explain_weakness_in_arms_hands_error = false;


    user_temp.weakness_in_leg_feet_error = false;
    user_temp.explain_weakness_in_leg_feet_error = false;


    user_temp.change_in_coordination_error = false;
    user_temp.explain_change_in_coordination_error = false;


    user_temp.change_ability_walk_error = false;
    user_temp.explain_change_ability_walk_error = false;



    user_temp.spina_bifida_error = false;
    user_temp.explain_spina_bifida_error = false;
    user_temp.latex_allergy_error = false;
    user_temp.explain_latex_allergy_error = false;
    user_temp.athlete_signature_error = false;
    user_temp.parent_signature_error = false;


    if (user_temp.datefir == "") {
      user_temp.datefir_error = true;

      setForthforminInfo(user_temp);
      setErrorMsgForth("Please enter date of exam"); return false;
    }

    if (user_temp.datesec == "") {
      user_temp.datefir_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please enter date of exam"); return false;
    }


    if (user_temp.dateth == '') {
      user_temp.datefir_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please enter date of exam"); return false;
    }


    if (user_temp.datefor == '') {
      user_temp.datefir_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please enter date of exam"); return false;
    }
    if (user_temp.datefif == '') {

      user_temp.datefir_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please enter date of exam"); return false;
    }

    if (user_temp.datesix == '') {

      user_temp.datefir_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please enter date of exam"); return false;
    }

    if (user_temp.dateseven == '') {
      user_temp.datefir_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please enter date of exam"); return false;
    }

    if (user_temp.dateeight == "") {
      user_temp.datefir_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please enter date of exam"); return false;
    }

    if (user_temp.sports == '') {
      user_temp.sports_error = true;

      setForthforminInfo(user_temp);
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please enter sports name"); return false;
    }

    if (user_temp.disability == '') {
      user_temp.disability_error = true;

      setForthforminInfo(user_temp);
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please enter type of disability"); return false;
    }

    if (user_temp.date_of_disability == '') {
      user_temp.date_of_disability_error = true;

      setForthforminInfo(user_temp);
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please enter date of disability"); return false;
    }

    if (user_temp.cause_of_disability == '') {
      user_temp.cause_of_disability_error = true;

      setForthforminInfo(user_temp);
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please enter cause of disability (birth, disease, accidenUtrauma, other)"); return false;
    }


    if (user_temp.list_of_sports == '') {
      user_temp.list_of_sports_error = true;

      setForthforminInfo(user_temp);
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please enter  list the sports you are interested in playing)"); return false;
    }


    if (user_temp.use_assistive_device == '') {
      user_temp.use_assistive_device_error = true;

      setForthforminInfo(user_temp);
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select do you regularly use a brace, assistive device, or prosthetic?"); return false;
    }

    if (user_temp.explain_use_assistive_device == ''
      && user_temp.use_assistive_device == 'Yes') {
      user_temp.explain_use_assistive_device_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain  do you regularly use a brace, assistive device, or prosthetic?"); return false;
    }



    if (user_temp.special_brace == '') {
      user_temp.special_brace_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select do you use any special brace or assistive device for sports?"); return false;

    }
    if (user_temp.explain_special_brace == ''
      && user_temp.special_brace == 'Yes') {
      user_temp.explain_special_brace_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain  do you use any special brace or assistive device for sports?"); return false;
    }


    if (user_temp.any_rashes_pressure == '') {
      user_temp.any_rashes_pressure_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select do you have any rashes, pressure sores, or any other skin problems?"); return false;

    }

    if (user_temp.explain_any_rashes_pressure == ''
      && user_temp.any_rashes_pressure == 'Yes') {
      user_temp.explain_any_rashes_pressure_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain  do you have any rashes, pressure sores, or any other skin problems?"); return false;
    }

    //         if (user_temp.explain_restricted== '' ) {
    // user_temp.explain_restricted_error=true;

    //       }
    if (user_temp.hearing_loss == '') {
      user_temp.hearing_loss_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select do you have a hearing loss? Do you use a hearing aid?"); return false;


    }
    if (user_temp.explain_hearing_loss == ''
      && user_temp.hearing_loss == 'Yes') {
      user_temp.explain_hearing_loss_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain  do you have a hearing loss? Do you use a hearing aid?"); return false;
    }



    //        if (user_temp.explain== '') {
    // user_temp.explain_error=true;

    //       }
    if (user_temp.visual_impairment == '') {
      user_temp.visual_impairment_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select do you have a visual impairment?"); return false;

    }
    if (user_temp.explain_visual_impairment == ''
      && user_temp.visual_impairment == 'Yes') {
      user_temp.explain_visual_impairment_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain  do you have a visual impairment?"); return false;
    }



    //        if (user_temp.explain_exercise== '') {
    // user_temp.explain_exercise_error=true;

    //       }
    if (user_temp.bowel_bladder_function == '') {
      user_temp.bowel_bladder_function_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select do you use any special devices for bowel or bladder function?"); return false;


    }
    if (user_temp.explain_bowel_bladder_function == ''
      && user_temp.bowel_bladder_function == 'Yes') {
      user_temp.explain_bowel_bladder_function_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain  do you use any special devices for bowel or bladder function?"); return false;
    }


    //        if (user_temp.explain_chest== '') {
    // user_temp.explain_chest_error=true;

    //       }
    if (user_temp.discomfort_when_urinating == '') {
      user_temp.discomfort_when_urinating_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select do you have burning or discomfort when urinating?"); return false;


    }

    if (user_temp.explain_discomfort_when_urinating == ''
      && user_temp.discomfort_when_urinating == 'Yes') {
      user_temp.explain_discomfort_when_urinating_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain  do you have burning or discomfort when urinating?"); return false;
    }

    //        if (user_temp.explain_irregular== '') {
    // user_temp.explain_irregular_error=true;

    //       }
    if (user_temp.autonomic_dysreflexia == '') {
      user_temp.autonomic_dysreflexia_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select have you had autonomic dysreflexia?"); return false;


    }
    if (user_temp.explain_autonomic_dysreflexia == ''
      && user_temp.autonomic_dysreflexia == 'Yes') {
      user_temp.explain_autonomic_dysreflexia_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain  have you had autonomic dysreflexia?"); return false;
    }


    if (user_temp.diagnosed_heat_related == '') {
      user_temp.diagnosed_heat_related_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select have you ever been diagnosed with a heat-related (hyperthermia) or cold-related (hypothermia) illness?"); return false;


    }
    if (user_temp.explain_diagnosed_heat_related == ''
      && user_temp.diagnosed_heat_related == 'Yes') {
      user_temp.explain_diagnosed_heat_related_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain  have you ever been diagnosed with a heat-related (hyperthermia) or cold-related (hypothermia) illness?"); return false;
    }

    //        if (user_temp.explain_heart_doctor== '') {
    // user_temp.explain_heart_doctor_error=true;

    //       }

    //        if (user_temp.explain_lightheaded== '') {
    // user_temp.explain_lightheaded_error=true;

    //       }
    if (user_temp.muscle_spasticity == '') {
      user_temp.muscle_spasticity_error = true;

      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select do you have muscle spasticity?"); return false;

    }

    if (user_temp.explain_muscle_spasticity == ''
      && user_temp.muscle_spasticity == 'Yes') {
      user_temp.explain_muscle_spasticity_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain  do you have muscle spasticity?"); return false;
    }

    //        if (user_temp.explain_seizure== '') {
    // user_temp.explain_seizure_error=true;

    //       }



    if (user_temp.frequent_seizures == '') {
      user_temp.frequent_seizures_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select do you have frequent seizures that cannot be controlled by medication?"); return false;


    }
    if (user_temp.explain_frequent_seizures == ''
      && user_temp.frequent_seizures == 'Yes') {
      user_temp.explain_frequent_seizures_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain  do you have frequent seizures that cannot be controlled by medication?"); return false;
    }

    //        if (user_temp.explain_breath== '') {
    // user_temp.explain_breath_error=true;

    //       }

    if (user_temp.atlantoaxial_instability == '') {
      user_temp.atlantoaxial_instability_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select atlantoaxial instability"); return false;


    }
    if (user_temp.explain_atlantoaxial_instability == ''
      && user_temp.atlantoaxial_instability == 'Yes') {
      user_temp.explain_atlantoaxial_instability_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain atlantoaxial instability?"); return false;
    }

    if (user_temp.xray_evaluation == '') {
      user_temp.xray_evaluation_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select x-ray evaluation for atlantoaxial instability"); return false;


    }

    if (user_temp.explain_xray_evaluation == ''
      && user_temp.xray_evaluation == 'Yes') {
      user_temp.explain_xray_evaluation_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain atlantoaxial instability?"); return false;
    }



    if (user_temp.dislocated_joints == '') {
      user_temp.dislocated_joints_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select dislocated joints (more than one)"); return false;


    }
    if (user_temp.explain_dislocated_joints == ''
      && user_temp.dislocated_joints == 'Yes') {
      user_temp.explain_dislocated_joints_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain dislocated joints (more than one)"); return false;
    }



    if (user_temp.easy_bleeding == '') {
      user_temp.easy_bleeding_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select easy bleeding"); return false;


    }

    if (user_temp.explain_easy_bleeding == ''
      && user_temp.easy_bleeding == 'Yes') {
      user_temp.explain_easy_bleeding_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain easy bleeding"); return false;
    }

    if (user_temp.enlarged_spleen == '') {
      user_temp.enlarged_spleen_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select enlarged spleen"); return false;


    }

    if (user_temp.explain_enlarged_spleen == ''
      && user_temp.enlarged_spleen == 'Yes') {
      user_temp.explain_enlarged_spleen_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain enlarged spleen"); return false;
    }

    if (user_temp.hepatitis == '') {
      user_temp.hepatitis_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select hepatitis"); return false;


    }
    if (user_temp.explain_hepatitis == ''
      && user_temp.hepatitis == 'Yes') {
      user_temp.explain_hepatitis_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain hepatitis"); return false;
    }

    if (user_temp.osteopenia_or_osteoporosis == '') {
      user_temp.osteopenia_or_osteoporosis_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select osteopenia or osteoporosis"); return false;


    }
    if (user_temp.explain_osteopenia_or_osteoporosis == ''
      && user_temp.osteopenia_or_osteoporosis == 'Yes') {
      user_temp.explain_osteopenia_or_osteoporosis_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain osteopenia or osteoporosis"); return false;
    }

    if (user_temp.controlling_bowel == '') {
      user_temp.controlling_bowel_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select difficulty controlling bowel"); return false;


    }
    if (user_temp.explain_controlling_bowel == ''
      && user_temp.controlling_bowel == 'Yes') {
      user_temp.explain_controlling_bowel_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain difficulty controlling bowel"); return false;
    }

    if (user_temp.controlling_bladder == '') {
      user_temp.controlling_bladder_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select difficulty controlling bladder"); return false;


    }
    if (user_temp.explain_controlling_bladder == ''
      && user_temp.controlling_bladder == 'Yes') {
      user_temp.explain_controlling_bladder_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain difficulty controlling bladder"); return false;
    }


    if (user_temp.numbnesss_in_arms_or_hands == '') {
      user_temp.numbnesss_in_arms_or_hands_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select numbness or tingling in arms or hands"); return false;


    }
    if (user_temp.explain_numbnesss_in_arms_or_hands == ''
      && user_temp.numbnesss_in_arms_or_hands == 'Yes') {
      user_temp.explain_numbnesss_in_arms_or_hands_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain numbness or tingling in arms or hands"); return false;
    }

    if (user_temp.numbnesss_in_legs_or_feet == '') {
      user_temp.numbnesss_in_legs_or_feet_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select numbness or tingling in legs or feet"); return false;


    }

    if (user_temp.explain_numbnesss_in_legs_or_feet == ''
      && user_temp.numbnesss_in_legs_or_feet == 'Yes') {
      user_temp.explain_numbnesss_in_legs_or_feet_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain numbness or tingling in legs or feet"); return false;
    }



    if (user_temp.weakness_in_arms_hands == '') {
      user_temp.weakness_in_arms_hands_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select weakness in arms or hands"); return false;


    }
    if (user_temp.explain_weakness_in_arms_hands == ''
      && user_temp.weakness_in_arms_hands == 'Yes') {
      user_temp.explain_weakness_in_arms_hands_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain weakness in arms or hands"); return false;
    }
    if (user_temp.weakness_in_leg_feet == '') {
      user_temp.weakness_in_leg_feet_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select weakness in legs or feet"); return false;


    }
    if (user_temp.explain_weakness_in_leg_feet == ''
      && user_temp.weakness_in_leg_feet == 'Yes') {
      user_temp.explain_weakness_in_leg_feet_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain weakness in legs or feet"); return false;
    }

    if (user_temp.change_in_coordination == '') {
      user_temp.change_in_coordination_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select recent change in coordination"); return false;


    }
    if (user_temp.explain_change_in_coordination == ''
      && user_temp.change_in_coordination == 'Yes') {
      user_temp.explain_change_in_coordination_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain recent change in coordination"); return false;
    }

    if (user_temp.change_ability_walk == '') {
      user_temp.change_ability_walk_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select recent change in ability to walk"); return false;


    }
    if (user_temp.explain_change_ability_walk == ''
      && user_temp.change_ability_walk == 'Yes') {
      user_temp.explain_change_ability_walk_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain recent change in ability to walk"); return false;
    }


    if (user_temp.spina_bifida == '') {
      user_temp.spina_bifida_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select spina bifida"); return false;


    }
    if (user_temp.explain_spina_bifida == ''
      && user_temp.spina_bifida == 'Yes') {
      user_temp.explain_spina_bifida_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain spina bifida"); return false;
    }

    if (user_temp.latex_allergy == '') {
      user_temp.latex_allergy_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please select latex allergy"); return false;


    }

    if (user_temp.explain_latex_allergy == ''
      && user_temp.latex_allergy == 'Yes') {
      user_temp.explain_latex_allergy_error = true;

      setForthforminInfo(user_temp);

      setErrorMsgForth("Please explain latex allergy"); return false;
    }



    if (user_temp.athlete_signature == '') {
      user_temp.athlete_signature_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please enter signature of athlete"); return false;


    }

    if (user_temp.parent_signature == '') {
      user_temp.parent_signature_error = true;
      setForthforminInfo(user_temp);
      setErrorMsgForth("Please enter signature of parent/guardian"); return false;


    }
    if (userData != null && userData.locat_up == "0" && (checkdiss == false)) {
      setSubmitch('four');
      var resultnew = locations.map(function (el) {
        var o = Object.assign({}, el);
        if (userData.location_at_id == o.location_id) {
          setmainSearchValue(o.location_id);
          setInputValue(o);
          
 setCheckdiss(true);
          setSearchValue(o);
         setTimeout(function () {
            setOpendischolllog(true);
          }, 500);
          return false;

        }


        //return o;
      });

      return false;
    } else {
      setOpendischolllog(false);
    }
    setparentLoaderForth(true);
    user_temp.date = user_temp.datefif + user_temp.datesix + user_temp.dateseven + user_temp.dateeight + '-' + user_temp.datefir + user_temp.datesec + '-' + user_temp.dateth + user_temp.datefor;
    setOpenLog(true);
    Axios.post(`/pdf_form_submit`, { studid: userData.stuid, id: 4, formdata: user_temp, ip_address: ipuser, newlocation: mainsearchValue })
      .then(res => {
        console.log(res.data);

        if (res.data.status == true) {
          secureLocalStorage.setItem("userdata", JSON.stringify(res.data.studentdetalis));

          console.log(res.data.data);
          var arrst = [];
          var docnew = {};
          var resultnew = res.data.studentdata.map(function (el) {
            var o = Object.assign({}, el);
            if (o.form_id == 4) {
              docnew = o;

            }


            //return o;
          });
          console.log(docnew);
          console.log(allstudentlisdata);
          if (allstudentlisdata.length > 0) {
            arrst.push(docnew);
            var resultk = allstudentlisdata.map(function (el) {
              var ou = Object.assign({}, el);

              if (ou.form_id != 4) {


                arrst.push(ou);
              } else {

              }

              console.log(allstudentlisdata);
              console.log(ou);

              return ou;
            });
          } else {
            arrst.push(docnew);
          }

          console.log(arrst);
          setAllstudentlisdata(arrst);
          secureLocalStorage.setItem("studenentformdata", JSON.stringify(arrst));

          // storage[0].userdata = res.data.data;
          // secureLocalStorage.setItem("studenentformdata", JSON.stringify(res.data.studentdata));
          // setAllstudentlisdata(res.data.studentdata);
          setparentLoaderForth(false);
          setSuccessMsgForth('Form Submitted Successfully');
          setOpenLog(false);
          setTimeout(function () {
            setOpenLog(false);
            setSuccessMsgForth('');
            setErrorMsgForth('');

          }, 1000);

        }
        else {

          setErrorMsgForth(res.data.data);
          setparentLoaderForth(false);
        }

      })
      .catch(error => {
        setErrorMsgForth('Network Connection Problem, please try again!');
        setparentLoaderForth(false);

      });

  }
  const [openLogacc, setOpenLogacc] = React.useState(false);
  const [valueacc, setAalueacc] = React.useState('');
  const handleOpenLogaccb = () => setOpenLogacc(true);
  const handleCloselogaccb = () => setOpenLogacc(false);
  const handleOpenLogacc = (val) => {
    setAalueacc(val);
    setCheckprf(false);
    setOpenLogacc(true);
  }

  const handleEdit = (val) => {
    console.log(val);
    if (val == 1) {
      secureLocalStorage.removeItem("alldatafirstform");
      setFirstforminInfo(firstform_default);
    }
    else if (val == 2) {
      secureLocalStorage.removeItem("alldatasecondform");
      setSecondforminInfo(secondform_default);
    }
    else if (val == 3) {
      secureLocalStorage.removeItem("alldatathirdform");
      setThirdforminInfo(thirdform_default);
    }
    else if (val == 4) {
      secureLocalStorage.removeItem("alldataforthform");
      setForthforminInfo(forthform_default);
    }
    else if (val == 5) {
      secureLocalStorage.removeItem("alldatafifthform");
      setFifthforminInfo(fifthform_default);
    }
    else if (val == 6) {
      secureLocalStorage.removeItem("alldatasixform");
      setSixforminInfo(sixform_default);
    }
    else if (val == 7) {
      secureLocalStorage.removeItem("alldatasevenform");
      setSevenforminInfo(seventhform_default);
    }
    else if (val == 8) {
      secureLocalStorage.removeItem("alldataeightform");
      setEightforminInfo(eightthform_default);
    }
    else if (val == 9) {
      secureLocalStorage.removeItem("alldatanineform");
      setNineforminInfo(ninethform_default);
    }
    else if (val == 10) {
      secureLocalStorage.removeItem("alldatatenform");
      setTenforminInfo(tenform_default);
    }
    var arrst = [];

    var result = allstudentlisdata.map(function (el) {
      var o = Object.assign({}, el);
      if (o.form_id != val) {
        arrst.push(o);
      }
      console.log(allstudentlisdata);
      console.log(o);

      return o;
    });
    console.log(arrst);
    setAllstudentlisdata(arrst);
    secureLocalStorage.setItem("studenentformdata", JSON.stringify(arrst));
    setOpenLogacc(false);

  }
  function handleKeyAccountPress(event) {
    const charCode = event.which || event.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 189 && charCode <= 96 && charCode >= 105) {
      // The pressed key is not a number
      event.preventDefault();
    }
  }
  function handleKeyAccountPress(event) {
    const charCode = event.which || event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46 && charCode != 45) {
      // The pressed key is not a number
      event.preventDefault();
    }
  }


  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#676666',
      color: '#ffffff',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),

    },
  }));


  const handleDownloadFile = (stuid, formid, pdfname) => {

    Axios.get(`/parent/download-form/${stuid}/${formid}`, {
      responseType: 'blob',
    })
      .then(res => {
        downloadBlob(res.data, pdfname);
      })
  }

  const getFormData = (form_id) => {
    if (Array.isArray(allstudentlisdata)) {
      return allstudentlisdata.find(i => i.form_id == form_id);
    } else {
      return null;
    }
  }

  const downloadBlob = (data, filename) => {
    // Create a blob from the res data
    const blob = new Blob([data], { type: data.type });

    // Create a link element
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    window.URL.revokeObjectURL(link.href);
    document.body.removeChild(link);

  }

  const handleReqFormDownload = () => {
    handleAllDownload();
  }

  const handleAllDownload = () => {
    setAllFromDownloadSuccess(null);
    setAllFromDownloadError(null);
    setOpenAllDownload(true);
    setDownloadFroms({});
  }

  const closeAllDownload = () => {
    setOpenAllDownload(false);
  }

  const [downloadFroms, setDownloadFroms] = useState({});
  const [allFormDownloadProcess, setAllFormDownloadProcess] = useState(false);
  const [allFromDownloadSuccess, setAllFromDownloadSuccess] = useState(null);
  const [allFromDownloadError, setAllFromDownloadError] = useState(null);
  const handleOnChangeDownloadForm = (e) => {
    const { name, checked } = e.target;
    setDownloadFroms({ ...downloadFroms, [name]: checked });
  }

  const handleDownloadAllFromSubmit = () => {
    if (allFormDownloadProcess) return;
    setAllFormDownloadProcess(true);

    let formIds = [];
    let downloadFromsK = Object.keys(downloadFroms);
    for (let i = 0; i < downloadFromsK.length; i++) {
      if (downloadFroms[downloadFromsK[i]]) {
        formIds.push(downloadFromsK[i].split('_')[1]);
      }
    }

    Axios.post(`/parentformsend`, { studid: userData.stuid, form_id: formIds.join(",") })
      .then(res => {
        if (res.data.status) {
          setAllFromDownloadSuccess(res.data.message);
          setTimeout(() => {
            closeAllDownload();
            setAllFromDownloadSuccess(null);
          }, 2000);
        } else {
          setAllFromDownloadError(res.data.message);
        }
        setAllFormDownloadProcess(false);
      }).catch(error => {
        setAllFromDownloadError('Network Connection Problem, please try again!');
      })
  }

  const allForms = [{
    lable: "CONSENT FORM FOR INTERSCHOLASTIC ATHLETICS",
    id: 1
  }, {
    lable: "PREPARTICIPATION PHYSICAL EVALUATION | HISTORY FORM",
    id: 3
  }, {
    lable: "PREPARTICIPATION  PHYSICAL  EVALUATION | THE ATHLETE WITH SPECIAL NEEDS: SUPPLEMENTAL HISTORY FORM",
    id: 4
  }, {
    lable: "NEW JERSEY DEPARTMENT OF EDUCATION HEALTH HISTORY UPDATE QUESTIONNAIRE",
    id: 5
  }, {
    lable: "SPORTS-RELATED CONCUSSION AND HEAD INJURY FACT SHEET AND PARENT/GUARDIAN ACKNOWLEDGEMENT FORM",
    id: 6
  }, {
    lable: "SUDDEN CARDIAC DEATH PAMPHLET SIGN-OFF SHEET",
    id: 7
  }, {
    lable: "USE AND MISUSE OF OPIOID DRUGS FACT SHEET",
    id: 8
  }, {
    lable: "NJSIAA OPIOID POLICY ACKNOWLEDGEMENT",
    id: 9
  }, {
    lable: "NJSIAA STEROID TESTING POLICY CONSENT TO RANDOM TESTING",
    id: 10
  }];

  const getCompletedForms = () => {
    let completedForms = [];
    if (Array.isArray(allstudentlisdata)) {
      for (let i = 0; i < allForms.length; i++) {
        let x = allstudentlisdata.find(j => j.form_id == allForms[i].id);
        if (x) {
          completedForms.push(allForms[i]);
        }
      }
    }
    return completedForms;
  }

  const checkIsAllFormChecked = () => {
    let downloadFromsK = Object.keys(downloadFroms);
    for (let i = 0; i < downloadFromsK.length; i++) {
      if (downloadFroms[downloadFromsK[i]]) {
        return true;
      }
    }
    return false;
  }


  return (
    <>

      <HeaderForm />
      <div className='regis-main-sec forms-main-sec'>
        <div className='container-fluid'>

          <div className='row'>
            <div className='col-md-12'>
              <div className='regis-head forms-heading-sec'>
                <h2>Parent Permission/Consent Form for Athletic Participation</h2>

                <div class="d-flex justify-content-end">
                  {/*{
                    isTimerComplete ?
                      <div class="all_download"><GetAppIcon role="button" onClick={handleAllDownload} /></div>
                      : null
                  }*/}
                  <div>
                    <Link to="/formstatus">
                      <p className='go-frm-cols go-new-add'>CHECK YOUR APPLICATION STATUS</p>

                      <div class="scroll-prompt" scroll-prompt="" ng-show="showPrompt" style={{ opacity: '1' }}>
                        <div class="scroll-prompt-arrow-container chek-scroll">
                          <div class="scroll-prompt-arrow"><div></div></div>
                          <div class="scroll-prompt-arrow new-scroll"><div></div></div>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div className='forms-nme-sec'>
            <div className='row'>
              <div className='col-md-12'>
                <div className='form-accor'>
                  <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Typography sx={{ width: '33%', flexShrink: 0 }}>
                        PARENTS CONSENT FORM
                      </Typography>
                      <Typography className="green-dwn" sx={{ fontSize: '15px', marginRight: '14px', color: 'text.secondary', float: 'left', width: '100%', textAlign: 'center', color: '#e98d05', fontWeight: '600', width: '33%', flexShrink: 0 }} >
                        {(userData != null && userData.sp_need == 'Y')
                          ?
                          <>
                            7 Forms
                          </>

                          :
                          <>6 Forms</>
                        }



                      </Typography>

                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>

                        <div className='form-accor-sec color-form-occur'>
                          <Accordion expanded={expandednew === 'panel1f'} onChange={handleChangenew('panel1f')}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1-content"
                              id="panel1-header"
                            >
                              <Typography sx={{ width: '80%', flexShrink: 0 }}>CONSENT FORM FOR INTERSCHOLASTIC ATHLETICS</Typography>

                              <Typography className="green-dwn" sx={{ float: 'right', textAlign: 'right', color: '#008430', fontWeight: '600', width: '20%', flexShrink: 0, }} >

                                {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 1) == true) ?

                                  'Completed' :
                                  <span className='pebdingarmh'>Pending</span>
                                }
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>

                                <div className='form-main-sec'>

                                  {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 1) == true) ?

                                    '' : <>  <div className='row'>
                                      <div className='col-md-3'>
                                        <div className='heading-logo'>
                                          <img src={newlogos} />
                                        </div>
                                      </div>
                                      <div className='col-md-6'>
                                        <div className='heading-form-para'>
                                          <h1>Jersey City Public Schools Department of Athletics</h1>
                                        </div>
                                      </div>
                                      <div className='col-md-3'>
                                        <div className='right-head'>
                                          <p>346 Claremont Ave Jersey City, NJ 07305</p>
                                        </div>
                                      </div>
                                    </div>

                                      <div className='row'>
                                        <div className='col-md-12'>
                                          <div className='form-heading'>
                                            <h2>CONSENT FORM FOR INTERSCHOLASTIC ATHLETICS</h2>
                                          </div>
                                        </div>
                                      </div>

                                      <div className='row'>

                                        <div className='col-md-12'>
                                          <div className='form-content-sec'>
                                            <p className='form-para'>With my full knowledge and consent<span><input type="text" className="input-form outlne-none"
                                              value={firstformInfo.consent} onChange={handleChangeFirst}
                                              name="consent" />
                                              {firstformInfo.consent_error == true ? 'Please enter the consent!' : ''}
                                            </span>
                                              may participate in all physical activities and may take trips that are part of this program.
                                            </p>
                                            <p className='form-para'>The school authorities will exercise maximum care in the administration and control of athletic activities in order to safeguard participants against injury and accident.</p>
                                            <p className='form-para'>Realizing that such activity involves the potential for injury, which is inherent in all sports, I/we acknowledge that even with the best coaching, use of the most advanced protective equipment and strict observances of the rules, injuries are still a possibility. On rare occasions these injures can be so severe as to result in total disability, paralysis, or even death. I/we acknowledge that I/we have read and understand this warning.</p>
                                            <p className='form-para'>In the event of an injury to my child I give consent as parent/guardian to have my child assessed and treated by a certified Athletic Trainer. I also give my permission for disclosure of medical information regarding my child and any treatment necessary in the event of a medical emergency.</p>
                                            <p className='form-para'>I certify that the information provided herein is accurate as of the date of these signatures. </p>


                                          </div>
                                        </div>

                                      </div>



                                      <div className='sign-sec-main  acknw-cont-sec'>
                                      <div className='row sign-top-mrn'>
                                            <div className='col-md-4'>
                                              <div class="sign-secs">


                                                <input class="text-input-sign cusrive-font-sec" type="text" id="fname" placeholder=""  value={firstformInfo.parent_signature} onChange={handleChangeFirst}
                                                name="parent_signature" />
                                                <p>Parent/Guardian (Signature) </p>
                                                <p className='error-msg-frm error-msg-frm-top'>
                                                  <span>
                                                      {firstformInfo.parent_signature_error == true ? 'Please enter the parent/guardian signature!' : ''}
                                                  </span>
                                                </p>

                                              </div>
                                            </div>
                                            <div className='col-md-4'>
                                              <div class="sign-secs new-nocur-spac">


                                                <input class="text-input-sign " type="text" id="fname" placeholder=""  value={firstformInfo.parent_name} onChange={handleChangeFirst}
                                                name="parent_name"  />
                                                <p>Parent/Guardian (Print Name)    </p>
                                                <p className='error-msg-frm error-msg-frm-top'>
                                                  <span>
                                               {firstformInfo.parent_name_error == true ? 'Please enter the parent/guardian print name!' : ''}
                                                  </span>
                                                </p>

                                              </div>
                                            </div>

                                            {/* <div className='col-md-4'>
                                              <div class="sign-secs">


                                                <input class="text-input-sign" type="text" value={sixformInfo.athlete_name} onChange={handleChangeSix}
                                                  name="athlete_name" id="fname" placeholder="" />
                                                <p>Print Student-Athlete's Name  </p>
                                                <p className='error-msg-frm error-msg-frm-top'>
                                                  <span>
                                                    {sixformInfo.athlete_name_error == true ? 'Please enter print student-athlete name!' : ''}
                                                  </span>
                                                </p>
                                              </div>
                                            </div> */}
                                            <div className='col-md-3'>
                                              <div className='form-date-sec form-date-nbw'>
                                                <label >Date </label>

                                                <div className='sign-sec'>

                                                  <p className='colon-sec'>:</p>
                                                  <p style={{ fontWeight: '400', marginLeft: '9px', paddingTop: '7px' }}>{formDate}</p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>








                                          <div className='row'>
                                            <div className='col-md-4'>
                                              <div class="sign-secs">


                                                <input class="text-input-sign cusrive-font-sec" type="text" id="fname" placeholder=""
                                                  value={firstformInfo.student_signature} onChange={handleChangeFirst}
                                                name="student_signature" />
                                                <p>Student (Signature) </p>
                                                <p className='error-msg-frm error-msg-frm-top'>
                                                  <span>
                                                    {firstformInfo.student_signature_error == true ? 'Please enter the student signature!' : ''}
                                                  </span>
                                                </p>
                                              </div>
                                            </div>

                                            <div className='col-md-4'>
                                              <div class="sign-secs new-nocur-spac">


                                                <input class="text-input-sign " type="text" id="fname" placeholder=""
                                                  
                                                   value={firstformInfo.student_name} onChange={handleChangeFirst}
                                                name="student_name" />
                                                <p>Student (Print Name) </p>
                                                <p className='error-msg-frm error-msg-frm-top'>
                                                  <span>
                                                 {firstformInfo.student_name_error == true ? 'Please enter the student print name!' : ''}
                                                  </span>
                                                </p>
                                              </div>
                                            </div>

                                            {/* <div className='col-md-4'>
                                              <div class="sign-secs">


                                                <input class="text-input-sign" type="text"
                                                  value={sixformInfo.parent_name} onChange={handleChangeSix}
                                                  name="parent_name" id="fname" placeholder="" />
                                                <p>Print Parent/Guardian's Name  </p>
                                                <p className='error-msg-frm error-msg-frm-top'>
                                                  <span>
                                                    {sixformInfo.parent_name_error == true ? 'Please enter print parent/guardian name!' : ''}
                                                  </span>
                                                </p>
                                              </div>
                                            </div> */}

                                            <div className='col-md-3'>
                                              <div className='form-date-sec form-date-nbw'>
                                                <label >Date </label>

                                                <div className='sign-sec'>

                                                  <p className='colon-sec'>:</p>
                                                  <p style={{ fontWeight: '400', marginLeft: '9px', paddingTop: '7px' }}>{formDate}</p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        {/* <div className='row'>
                                          <div className='col-md-9'>
                                            <div className='sign-sec new-sp-sign'>
                                              <p>Parent/Guardian (Signature) <span className='spn-mar-le'>:</span></p>
                                            
                                              <input className='text-input-sign cusrive-font-sec' type="text" id="fname"
                                                placeholder=''
                                                value={firstformInfo.parent_signature} onChange={handleChangeFirst}
                                                name="parent_signature"

                                              />
                                              <p className='error-msg-frm erro-nau'>
                                                <span>
                                                  {firstformInfo.parent_signature_error == true ? 'Please enter the parent/guardian signature!' : ''}</span>
                                              </p>

                                            </div>



                                          </div>
                                          <div className='col-md-3'>



                                            <div className='sign-sec'>
                                              <p className='date-right'>Date</p>
                                              <p className='colon-sec'>:</p>
                                              <p style={{ fontWeight: '400' }}>{formDate}</p>
                                            </div>
                                          </div>


                                        </div> */}
{/* 
                                        <div className='row'>
                                          <div className='col-md-9'>
                                            <div className='sign-sec new-sp-sign'>
                                              <p>Parent/Guardian (Print Name) <span className='spn-mar-le'>:</span></p>
                                              
                                              <input className='text-input-sign' type="text" id="fname" placeholder=''
                                                value={firstformInfo.parent_name} onChange={handleChangeFirst}
                                                name="parent_name" />
                                              <p className='error-msg-frm erro-nau'>
                                                <span>
                                                  {firstformInfo.parent_name_error == true ? 'Please enter the parent/guardian print name!' : ''}
                                                </span>
                                              </p>
                                            </div>

                                          </div>
                                        </div> */}


                                        {/* <div className='row'>
                                          <div className='col-md-9'>
                                            <div className='sign-sec new-sp-sign'>
                                              <p>Student (Signature) <span className='spn-mar-le'>:</span> </p>
                                            
                                              <input className='text-input-sign cusrive-font-sec' type="text" id="fname" placeholder=''
                                                value={firstformInfo.student_signature} onChange={handleChangeFirst}
                                                name="student_signature"
                                              />
                                              <p className='error-msg-frm erro-nau'>
                                                <span>
                                                  {firstformInfo.student_signature_error == true ? 'Please enter the student signature!' : ''}
                                                </span>
                                              </p>
                                            </div>



                                          </div>
                                          <div className='col-md-3'>


                                            <div className='sign-sec'>
                                              <p className='date-right'>Date </p>
                                              <p className='colon-sec'>:</p>
                                              <p style={{ fontWeight: '400' }}>{formDate}</p>
                                            </div>
                                          </div>


                                        </div> */}

                                        {/* <div className='row'>
                                          <div className='col-md-9'>
                                            <div className='sign-sec new-sp-sign'>
                                              <p>Student (Print Name) <span className='spn-mar-le'>:</span></p>
                                             
                                              <input className='text-input-sign' type="text" id="fname" placeholder=''

                                                value={firstformInfo.student_name} onChange={handleChangeFirst}
                                                name="student_name" />
                                              <p className='error-msg-frm erro-nau'>
                                                <span>
                                                  {firstformInfo.student_name_error == true ? 'Please enter the student print name!' : ''}
                                                </span>
                                              </p>

                                            </div>

                                          </div>
                                        </div> */}

                                        <div className='row'>
                                          <div className='col-md-12'>
                                            <div className='std-form-inner address-sec add-new-spac'>
                                              <label>Address <span className='spn-mar-le'>:</span></label>
                                              {/* <p className='float-left'>:</p> */}
                                              <textarea className='new-textara-inpt' type="text" id="fname" placeholder='' rows="4" cols="50"
                                                value={firstformInfo.address} onChange={handleChangeFirst}
                                                name="address"
                                              />
                                              <p className='error-msg-frm'>
                                                <span>
                                                  {firstformInfo.address_error == true ? 'Please enter the address!' : ''}</span>
                                              </p>
                                            </div>

                                          </div>
                                        </div>


                                      </div>

                                      <div className='emer-sec'>
                                        <div className='row'>
                                          <div className='emer-sec-head'>
                                            <h2>Emergency Phone Numbers:</h2>
                                          </div>

                                        </div>


                                        <div className='row'>
                                          <div className='col-md-3'>
                                            <div className='std-form-inner'>
                                              <label>Primary#</label>
                                              <input className='new-txt-fld' type="text" id="fname" value={firstformInfo.primary} onChange={handleChangeFirst}
                                                name="primary" placeholder='' />
                                              <p className='error-msg-frm'>
                                                <span>
                                                  {firstformInfo.primary_error == true ? 'Please enter the primary!' : ''}
                                                </span>
                                              </p>

                                            </div>
                                          </div>
                                          <div className='col-md-3'>
                                            <div className='std-form-inner'>
                                              <label>Relationship</label>
                                              <input className='new-txt-fld' type="text" id="fname" value={firstformInfo.relationship_primary} onChange={handleChangeFirst}
                                                name="relationship_primary" placeholder='' />
                                              <p className='error-msg-frm'>
                                                <span>
                                                  {firstformInfo.relationship_primary_error == true ? 'Please enter the relationship!' : ''}
                                                </span>
                                              </p>

                                            </div>
                                          </div>
                                          <div className='col-md-3'>
                                            <div className='std-form-inner'>
                                              <label>Secondary#</label>
                                              <input className='new-txt-fld' type="text" id="fname" value={firstformInfo.secondary} onChange={handleChangeFirst}
                                                name="secondary" placeholder='' />
                                              <p className='error-msg-frm'>
                                                <span>
                                                  {firstformInfo.secondary_error == true ? 'Please enter the secondary!' : ''}
                                                </span>
                                              </p>

                                            </div>
                                          </div>
                                          <div className='col-md-3'>
                                            <div className='std-form-inner'>
                                              <label>Relationship</label>
                                              <input className='new-txt-fld' type="text" id="fname" value={firstformInfo.relationship_secondary} onChange={handleChangeFirst}
                                                name="relationship_secondary" placeholder='' />
                                              <p className='error-msg-frm'>
                                                <span>
                                                  {firstformInfo.relationship_secondary_error == true ? 'Please enter the relationship!' : ''}
                                                </span>
                                              </p>
                                            </div>
                                          </div>

                                        </div>





                                      </div>

                                    </>}




                                  <div className='physici-sec' style={{ marginTop: '40px' }}>

                                    {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 1) == true) ?

                                      '' : <div className='row'>
                                        <div className='col-md-12'>
                                          <div className='physici-sec-head'>
                                            <h2>Physician Information</h2>

                                          </div>
                                        </div>
                                      </div>}
                                    <div className='physician-sec'>
                                      {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 1) == true) ?

                                        '' : <>
                                          <div className='row'>
                                            <div className='col-md-4'>
                                              <div className='std-form-inner'>
                                                <label>Physician Name</label>
                                                <input className='new-txt-fld' type="text" id="fname" value={firstformInfo.physican_name} onChange={handleChangeFirst}
                                                  name="physican_name" />
                                                <p className='error-msg-frm'>
                                                  <span>
                                                    {firstformInfo.physican_name_error == true ? 'Please enter the physician name!' : ''}
                                                  </span>
                                                </p>

                                              </div>
                                            </div>
                                            <div className='col-md-3'>
                                              <div className='std-form-inner'>
                                                <label>Physician Phone Number</label>
                                                <input className='new-txt-fld' type="text" id="fname" value={firstformInfo.physican_phone} onChange={handleChangeFirst}
                                                  name="physican_phone" />
                                                <p className='error-msg-frm'>
                                                  <span>
                                                    {firstformInfo.physican_phone_error == true ? 'Please enter the physician phone number!' : ''}
                                                  </span>
                                                </p>
                                              </div>

                                            </div>
                                            <div className='col-md-5'>
                                              <div className='std-form-inner address-sec phys-addrs const-add'>
                                                <label>Physician Address</label>
                                                <p className='float-left'>:</p>
                                                <textarea className='new-textara-inpt new-textara-inptss' type="text" id="fname" placeholder='' rows="4" cols="50"
                                                  value={firstformInfo.physican_address} onChange={handleChangeFirst}
                                                  name="physican_address"
                                                />
                                                <p className='error-msg-frm'>
                                                  <span>
                                                    {firstformInfo.physican_address_error == true ? 'Please enter the physician address!' : ''}
                                                  </span>
                                                </p>


                                              </div>
                                            </div>
                                          </div>
                                          <div className='row'>
                                            <div className='col-md-12'>
                                              <FormGroup className="radio-sec www-sec width-fix">
                                                <FormControlLabel label="I DO NOT HAVE A PHYSICIAN (Check if applicable)" control={<Checkbox />} checked={firstformInfo.no_physican} name="no_physican" onChange={handleChangeFirst} />

                                              </FormGroup>
                                              {firstformInfo.no_physican_error == true ? 'Please check it!' : ''}
                                            </div>

                                          </div>
                                        </>}
                                      <div class="login-submit login-submitss login-toltip">
                                        {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 1) == true) ?

                                          <>

                                            {(pdfExists(allstudentlisdata, userData.stuid + '_1_consent_form_for_interscholastic_athletics.pdf') == true)

                                              ?

                                              <>
                                                {/* <a data-tooltip-id="my-tooltip" data-tooltip-content="you will not be able to make changes to the form anymore.">
  <i class="fas fa-info-circle"></i> 
  <InfoIcon />
</a> */}

                                                {/* <Box sx={{ width: 500 }} className="togle-boxs">
      <Grid container justifyContent="center">
        <Grid item>
      
          <Tooltip title="you will not be able to make changes to the form anymore." placement="top" data-tooltip-id="my-tooltip">
           
            <InfoIcon />
          </Tooltip>
       
        </Grid>
      </Grid>
     
    </Box> */}






                                                <button class="btn btn-login btn-submit bt-forms bt-fill-newfrms btn-edits"
                                                  onClick={(e) => handleOpenLogacc(1)}
                                                >EDIT</button>

                                                <Timer
                                                  startDateTime={getFormData(1).created_at}
                                                  downloadFile={(userData.stuid + "_1_consent_form_for_interscholastic_athletics.pdf")}
                                                  stuid={userData.stuid}
                                                  formId={1}
                                                  handleDownloadFile={handleDownloadFile}
                                                  handleTimerComplete={handleTimerComplete}
                                                  handleReqFormDownload={handleReqFormDownload}
                                                />

                                                {/*<a title="Download"
                                              
                                                onClick={(e) => handleDownloadFile(userData.stuid,1,userData.stuid + '_1_consent_form_for_interscholastic_athletics.pdf')}
  target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>*/}


                                              </>

                                              :
                                              <>
                                                {/*<a title="Download" 
                                             
                                              onClick={(e) => handleDownloadFile(userData.stuid,1,userData.stuid + '_2_consent_form_for_interscholastic_athletics.pdf')}
target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>*/}

                                                <Timer
                                                  startDateTime={getFormData(1).created_at}
                                                  downloadFile={(userData.stuid + "_2_consent_form_for_interscholastic_athletics.pdf")}
                                                  stuid={userData.stuid}
                                                  formId={1}
                                                  handleDownloadFile={handleDownloadFile}
                                                  handleTimerComplete={handleTimerComplete}
                                                  handleReqFormDownload={handleReqFormDownload}
                                                />

                                              </>

                                            }

                                          </>

                                          : <button class="btn btn-login btn-submit bt-forms" onClick={handleSubmitFirst}>Submit
                                            {
                                              parentLoaderFirst != '' ?
                                                <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                                                : ''

                                            }
                                          </button>
                                        }

                                      </div>

                                      {
                                        successMsgFirst != '' ? <div className="success-msg success-login form-success">
                                          <p className="success-msg success-login">{successMsgFirst}</p>
                                        </div> :
                                          <div className="success-msg success-login form-success" style={{ visibility: 'hidden' }}>
                                            <p className="success-msg success-login">Form Submitted Successfully</p>
                                          </div>
                                      }


                                      {
                                        errorMsgFirst != '' ? <div className="error-msg error-login form-error" >
                                          <p className="error-msg error-login">{errorMsgFirst}</p>
                                        </div> : <div className="error-msg error-login" style={{ visibility: 'hidden' }} >
                                          <p className="error-msg error-login">Wrong credentials!</p>
                                        </div>
                                      }



                                    </div>


                                  </div>

                                </div>

                              </Typography>
                            </AccordionDetails>
                          </Accordion>

                        </div>

                        {/* <div className='form-accor-sec color-form-occur'>
                          <Accordion expanded={expandednew === 'panel2f'} onChange={handleChangenew('panel2f')}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1-content"
                              id="panel1-header"
                            >
                             
                              <Typography sx={{ width: '80%', flexShrink: 0 }}>COVID-19 QUESTIONNAIRE</Typography>

                              <Typography className="green-dwn" sx={{ width: '20%', flexShrink: 0, float: 'right', textAlign: 'right', color: '#008430', fontWeight: '600' }} >
                                {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 2) == true) ?

                                  'Completed' : <span className='pebdingarmh'>Pending</span>}
                              </Typography>


                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <div className='form-main-sec'>





                                  {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 2) == true) ?

                                    '' : <>
                                      <div className='row'>
                                        <div className='col-md-2'>
                                          <div className='heading-logo'>
                                            <img src={newlogos} />
                                          </div>
                                        </div>
                                        <div className='col-md-9'>
                                          <div className='heading-form-para'>
                                            <h1>NEW JERSEY STATE INTERSCHOLASTIC ATHLETIC ASSOCIATION</h1>
                                            <p>1161 Route 130 North, Robbinsville, NJ 08691-1104</p>
                                            <p>Phone 609-259-2776 ~ Fax 609-259-3047</p>
                                          </div>
                                        </div>
                                      
                                      </div>

                                      <div className='row'>
                                        <div className='col-md-12'>
                                          <div className='form-heading' style={{ marginTop: '20px', marginBottom: '60px' }}>
                                            <h2>COVID-19 Questionnaire</h2>

                                          </div>
                                        </div>
                                      </div>


                                      <div className='row'>
                                        <div className='col-md-4'>
                                          <div className='form-inner new-form-inner'>
                                            <h2>Name of Student</h2>
                                            <p>:</p>
                                            <p className='id-sec width-extra'>{userData.student_name} {userData.last_name}</p>

                                          </div>
                                        </div>

                                        <div className='col-md-3'>
                                          <div className='form-inner new-form-inner extranew-inn'>
                                            <h2>Date</h2>
                                            <p>:</p>
                                            <p className='form-data width-extra'>{formDate}</p>

                                          </div>
                                        </div>


                                      </div>


                                      <div className='margin-top-sec '>
                                        <div className='row '>
                                          <div className='col-md-4'>




                                            <div class=" row form-inner form-date-sec neww">
                                              <div className='col-md-5'>
                                                <h2>Parent/Guardian Cell</h2>
                                              </div>
                                              <div className='col-md-1 padding'>
                                                <p>:</p></div>

                                              <div className='col-md-6 padding'>
                                                <input type="text" class="text-datess new-border padding-fled" value={secondformInfo.parent} onChange={handleChangeSecond}
                                                  name="parent" />
                                                <p className='error-msg-frm'>

                                                  {secondformInfo.parent_error == true ? 'Please enter the parent/guardian cell!' : ''}

                                                </p>
                                              </div>
                                            </div>




                                          </div>
                                          <div className='col-md-4'>



                                            <div class=" row form-inner form-date-sec neww">
                                              <div className='col-md-3'>
                                                <h2>Sport(s)</h2>
                                              </div>
                                              <div className='col-md-1 padding'>
                                                <p>:</p></div>

                                              <div className='col-md-7 padding'>
                                                <input type="text" class="text-datess new-border padding-fled"
                                                  value={secondformInfo.sports} onChange={handleChangeSecond}
                                                  name="sports" />
                                                <p className='error-msg-frm'>

                                                  {secondformInfo.sports_error == true ? 'Please enter the sports!' : ''}

                                                </p>
                                              </div>
                                            </div>

                                          </div>

                                        </div>
                                      </div>

                                      <div class="row"><div class="emer-sec-head"><h2>COVID-19 Questions:</h2></div></div>



                                      <div className='row'>
                                        <div className='col-md-12'>
                                          <div className='medi-details-sec'>


                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-8'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className="new-labls">Has your son/daughter been diagnosed with Coronavirus (COVID-19)?
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-4">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"
                                                        name="covid_diagnose" checked={secondformInfo.covid_diagnose == 'Yes'}
                                                        onChange={handleChangeSecond} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"
                                                        name="covid_diagnose" checked={secondformInfo.covid_diagnose == 'No'}
                                                        onChange={handleChangeSecond} control={<Radio />} label="No" />

                                                      <div className='fied-miss'>
                                                        {secondformInfo.covid_diagnose_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>


                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-8'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className="new-labls">If diagnosed with Coronavirus (COVID-19), was your son/daughter symptomatic?
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-4">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"
                                                        name="covid_symptomatic" checked={secondformInfo.covid_symptomatic == 'Yes'}
                                                        onChange={handleChangeSecond} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"
                                                        name="covid_symptomatic" checked={secondformInfo.covid_symptomatic == 'No'}
                                                        onChange={handleChangeSecond} control={<Radio />} label="No" />
                                                      <div className='fied-miss'>
                                                        {secondformInfo.covid_symptomatic_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>



                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-8'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className="new-labls">If diagnosed with Coronavirus (COVID-19), was your son/daughter hospitalized?
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-4">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"
                                                        name="covid_hospitalized" checked={secondformInfo.covid_hospitalized == 'Yes'}
                                                        onChange={handleChangeSecond} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"
                                                        name="covid_hospitalized" checked={secondformInfo.covid_hospitalized == 'No'}
                                                        onChange={handleChangeSecond} control={<Radio />} label="No" />

                                                      <div className='fied-miss'>
                                                        {secondformInfo.covid_hospitalized_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>


                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-8'>
                                                    <FormLabel className="new-labls" id="demo-row-radio-buttons-group-label ">Has any member of the student-athlete''s household been diagnosed with Coronavirus (COVID-19)?
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-4">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"
                                                        name="covid_household" checked={secondformInfo.covid_household == 'Yes'}
                                                        onChange={handleChangeSecond} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"
                                                        name="covid_household" checked={secondformInfo.covid_household == 'No'}
                                                        onChange={handleChangeSecond} control={<Radio />} label="No" />

                                                      <div className='fied-miss'>
                                                        {secondformInfo.covid_household_error == true ? "Field missing" : ''}
                                                      </div>


                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                          </div>

                                        </div>
                                      </div>

                                      <div class="row">
                                        <div class="col-md-9">
                                          <div class="sign-sec sign-paret">
                                            <p>Signature of Parent/Guardian </p>
                                            <p class="colon-sec">:</p>
                                            <input class="text-input-sign cusrive-font-sec" type="text" id="fname"

                                              value={secondformInfo.parent_signature} onChange={handleChangeSecond}
                                              name="parent_signature" placeholder="" />

                                            {secondformInfo.parent_signature == true ? 'Please enter Signature of Parent/Guardian' : ''}
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-12">
                                          <div className='paret-cont'>
                                            <p>To participate in workouts during the summer recess period, the parent/guardian must complete this form. This form only needs to be
                                              completed one time.</p>
                                          </div>
                                        </div>
                                      </div>
                                    </>}

                                  <div className='row'>
                                    <div className='col-md-12'>
                                      <div class="login-submit login-submitss login-toltip">
                                        {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 2) == true) ?

                                          <>

                                            {(pdfExists(allstudentlisdata, userData.stuid + '_1_covid19_questionnaire.pdf') == true)

                                              ?

                                              <>

                                                <button class="btn btn-login btn-submit bt-forms bt-fill-newfrms btn-edits"
                                                  onClick={(e) => handleOpenLogacc(2)}
                                                >EDIT</button>
                                                <a title="Download" href={'https://s3-athleticform-assets.s3.us-east-1.amazonaws.com/uploads/' + userData.stuid + '_1_covid19_questionnaire.pdf'} target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>


                                              </>

                                              :
                                              <>
                                                <a title="Download" href={'https://s3-athleticform-assets.s3.us-east-1.amazonaws.com/uploads/' + userData.stuid + '_2_covid19_questionnaire.pdf'} target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>

                                              </>

                                            }

                                          </>

                                          :
                                          <button class="btn btn-login btn-submit bt-forms" onClick={handleSubmitSecond}>Submit
                                            {
                                              parentLoaderSecond != '' ?
                                                <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                                                : ''

                                            }
                                          </button>
                                        }
                                      </div>

                                      {
                                        successMsgSecond != '' ? <div className="success-msg success-login form-success">
                                          <p className="success-msg success-login">{successMsgSecond}</p>
                                        </div> : <div className="success-msg success-login form-success" style={{ visibility: 'hidden' }} >
                                          <p className="success-msg success-login">Form Submitted Successfully</p>
                                        </div>
                                      }


                                      {
                                        errorMsgSecond != '' ? <div className="error-msg error-login form-error" >
                                          <p className="error-msg error-login">{errorMsgSecond}</p>
                                        </div> : <div className="error-msg error-login form-error" style={{ visibility: 'hidden' }} >
                                          <p className="error-msg error-login">Wrong credentials!</p>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>

                              </Typography>
                            </AccordionDetails>
                          </Accordion>

                        </div>*/}


                        {((allstudentlisdata.length > 0 && userExists(allstudentlisdata, 4) == true) || userData.sp_need == 'Y') ?

                          <div className='form-accor-sec color-form-occur'>
                            <Accordion expanded={expandednew === 'panel4f'} onChange={handleChangenew('panel4f')}>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3-content"
                                id="panel3-header"
                              >
                                <Typography sx={{ width: '80%', flexShrink: 0 }}>PREPARTICIPATION  PHYSICAL  EVALUATION <span className='line-sec'>|</span> THE ATHLETE WITH SPECIAL NEEDS: SUPPLEMENTAL HISTORY FORM</Typography>
                                <Typography className="green-dwn break-dm" sx={{ flexShrink: 0, color: 'text.secondary', float: 'right', width: '20%', textAlign: 'right', color: '#008430', fontWeight: '600' }} >
                                  {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 4) == true) ?

                                    'Completed' : <span className='pebdingarmh'>Pending</span>}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Typography>

                                  <div className='form-main-sec'>





                                    {/* <div class="">
          <hr />
      </div> */}


                                    {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 4) == true) ?

                                      '' : <>
                                        <div className='row'>
                                          <div className='col-md-2'>
                                            <div className='heading-logo'>
                                              <img src={newlogos} />
                                            </div>
                                          </div>
                                          <div className='col-md-8'>
                                            <div className='heading-form-para'>
                                              <h1>PREPARTICIPATION  PHYSICAL  EVALUATION </h1>
                                              <h2>THE ATHLETE WITH SPECIAL NEEDS: SUPPLEMENTAL HISTORY FORM</h2>


                                            </div>
                                          </div>

                                        </div>

                                        <div className='date-form'>
                                          <div className='row'>
                                            <div className='col-md-12'>
                                              <div className='form-date-sec form-date-nbw'>
                                                <label>Date of Exam:</label>
                                                {/* <input type="date" className='text-date text-datess' placeholder='dd-mm-yyyy'/> */}
                                                <div className='date-sec date-text-nwd'>
                                                  <div className='date-slash'>
                                                    <input type="text" className="textmntg" id="datefir_for" placeholder='m'
                                                      value={forthformInfo.datefir} onKeyPress={(e) => handleKeyAccountPress(e)} onChange={handleChangeForth}
                                                      name="datefir" />
                                                    <input type="text" className="textmntg"
                                                      placeholder='m'
                                                      value={forthformInfo.datesec} onKeyPress={(e) => handleKeyAccountPress(e)} id="datesec_for" onChange={handleChangeForth}
                                                      name="datesec" />
                                                  </div>
                                                  <div className='date-slash'>
                                                    <p>-</p>
                                                  </div>
                                                  <div className='date-slash'>

                                                    <input type="text" className="textdate textmonthstg" placeholder='d'
                                                      value={forthformInfo.dateth} onKeyPress={(e) => handleKeyAccountPress(e)} id="dateth_for" onChange={handleChangeForth}
                                                      name="dateth" />
                                                    <input type="text" id="datefor_for" className="textdate textmonthstg" placeholder='d'
                                                      value={forthformInfo.datefor} onKeyPress={(e) => handleKeyAccountPress(e)} onChange={handleChangeForth}
                                                      name="datefor" />
                                                  </div>
                                                  <div className='date-slash'>
                                                    <p>-</p>
                                                  </div>
                                                  <div className='date-slash'>
                                                    <input type="text" id="datefif_for" className="textdate textyeartg" placeholder='y'
                                                      value={forthformInfo.datefif} onKeyPress={(e) => handleKeyAccountPress(e)} onChange={handleChangeForth}
                                                      name="datefif" />
                                                    <input type="text" id="datesix_for" className="textdate textyeartg" placeholder='y'
                                                      value={forthformInfo.datesix} onKeyPress={(e) => handleKeyAccountPress(e)} onChange={handleChangeForth}
                                                      name="datesix" />
                                                    <input type="text" id="dateseven_for" className="textdate textyeartg"
                                                      value={forthformInfo.dateseven} onKeyPress={(e) => handleKeyAccountPress(e)} onChange={handleChangeForth}
                                                      name="dateseven" placeholder='y' />
                                                    <input type="text" id="dateeight_for" className="textdate textyeartg"
                                                      value={forthformInfo.dateeight} onKeyPress={(e) => handleKeyAccountPress(e)} onChange={handleChangeForth}
                                                      name="dateeight" placeholder='y' />
                                                  </div>
                                                </div>
                                                {/* {forthformInfo.datefir_error == true ? 'Please enter Date of exam!' : ''} */}


                                              </div>

                                            </div>


                                            <p className='error-msg-frm ' style={{ textAlign: 'center' }}>
                                              <span className='dat-vall'>
                                                {forthformInfo.datefir_error == true ? 'Please enter date of exam!' : ''}
                                              </span>
                                            </p>
                                          </div>
                                        </div>


                                        <div class="row margin-data">
                                          <div class="col-md-3">
                                            <div class="form-inner new-form-inner ony-wid-main">
                                              <h2 className='ony-wid-name'>Name</h2>
                                              <p>:</p>
                                              <p class="id-sec width-extra ony-wid-exta">{userData.student_name} {userData.last_name}</p>
                                            </div>
                                          </div>
                                          <div class="col-md-3">
                                            <div class="form-inner new-form-inner">
                                              <h2>Date of Birth</h2>
                                              <p>:</p>
                                              <p class="form-data width-extra">{(userData.dob != null && userData.dob != '') && formatDate(userData.dob)}</p>
                                            </div>
                                          </div>
                                          <div class="col-md-2">
                                            <div class="form-inner new-form-inner extranew-inn">
                                              <h2>Sex</h2>
                                              <p>:</p>
                                              <p class="form-data width-extra">{userData.gender}</p>
                                            </div>
                                          </div>
                                          <div class="col-md-2">
                                            <div class="form-inner new-form-inner extranew-inn">
                                              <h2>Age </h2>
                                              <p>:</p>
                                              <p class="form-data width-extra"> {(userData.dob != null && userData.dob != '') && ageCalculator(userData.dob)}</p>
                                            </div>
                                          </div>
                                          <div class="col-md-2">
                                            <div class="form-inner new-form-inner extranew-inns">
                                              <h2>Grade</h2>
                                              <p>:</p>
                                              <p class="id-sec width-extra">{userData.stu_grade}</p>
                                            </div>
                                          </div>
                                        </div>


                                        <div class="row margin-data">

                                          <div class="col-md-3">
                                            <div class="form-inner new-form-inner ony-wid-main">
                                              <h2 className='ony-wid-name'>School</h2>
                                              <p>:</p>
                                              <p class="form-data width-extra ony-wid-exta">{userData.school_name}</p>
                                            </div>
                                          </div>

                                          <div class="col-md-9">
                                            <div class="form-inner form-date-sec form-sportss form-new-sportsss">
                                              <h2>Sport(s)</h2>
                                              <p>:</p>
                                              <input type="text" class="text-datess new-border width-extra"
                                                value={forthformInfo.sports} onChange={handleChangeForth}
                                                name="sports" />


                                              <div style={{ position: 'relative', display: 'block' }} >
                                                <p className='error-msg-frm error-sbso ' style={{ textAlign: 'center', marginLeft: '0px', position: 'absolute', left: '15%' }}>
                                                  {forthformInfo.sports_error == true ? 'Please enter the sports ' : ''}

                                                </p>
                                              </div>

                                            </div>
                                          </div>




                                        </div>

                                        <div className='emer-sec disble-sec'>
                                          <div className='row'>
                                            <div className='col-md-4'>
                                              {/* <div className='std-form-inner'>
              <label>Type of disability</label>
              <input className='text-input' type="text" id="fname"  placeholder=''  />
          </div> */}
                                              <div class=" row form-inner form-date-sec form-sportss neww">
                                                <div className='col-md-4'>
                                                  <h2>1. Type of disability</h2>
                                                </div>
                                                <div className='col-md-1 padding'>
                                                  <p>:</p></div>

                                                <div className='col-md-7 padding'>
                                                  <input type="text" class="text-datess new-border" value={forthformInfo.disability} onChange={handleChangeForth}
                                                    name="disability" />


                                                  <div style={{ position: 'relative', display: 'block' }} >
                                                    <p className='error-msg-frm error-sbso ' style={{ textAlign: 'center', marginLeft: '0px', position: 'absolute' }}>
                                                      {forthformInfo.disability_error == true ? 'Please enter type of disability ' : ''}

                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className='col-md-4'>

                                              <div class=" row form-inner form-date-sec form-sportss neww">
                                                <div className='col-md-4'>
                                                  <h2>2. Date of disability</h2>
                                                </div>
                                                <div className='col-md-1 padding'>
                                                  <p>:</p></div>


                                                <div className='col-md-7 padding'>
                                                  <input type="text" onFocus={(e) => { (e.target.type = "date"); setChaechdateofdid(true) }}
                                                    onBlur={(e) => { (e.target.type = "text"); setChaechdateofdid(false) }}
                                                    class="text-datess new-border"
                                                    value={(chaechdateofdid == true) ? forthformInfo.date_of_disability : forthformInfo.date_of_disability_text} onChange={handleChangeForth}
                                                    name="date_of_disability" placeholder="MM/DD/YYYY" />

                                                  <div style={{ position: 'relative', display: 'block' }} >
                                                    <p className='error-msg-frm error-sbso ' style={{ textAlign: 'center', marginLeft: '0px', position: 'absolute' }}>
                                                      {forthformInfo.date_of_disability_error == true ? 'Please Enter date of disability ' : ''}

                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className='col-md-4'>
                                              {/* 
          <div className='std-form-inner'>
              <label>Classification (if available)</label>
              <input className='text-input' type="text" id="fname"  placeholder=''  />
          </div> */}
                                              <div class=" row form-inner form-date-sec form-sportss neww">
                                                <div className='col-md-5'>
                                                  <h2>3. Classification (if available)</h2>
                                                </div>
                                                <div className='col-md-1 padding'>
                                                  <p>:</p></div>

                                                <div className='col-md-6 padding'>
                                                  <input type="text" class="text-datess new-border" value={forthformInfo.classification} onChange={handleChangeForth}
                                                    name="classification" /></div>
                                              </div>
                                            </div>

                                          </div>

                                          <div class="" style={{ marginTop: '45px' }}>
                                            <hr />
                                          </div>

                                          <div className='row' style={{ marginTop: '25px' }}>
                                            <div className='col-md-6'>
                                              <div class="std-form-inner other-sec">
                                                <label>4. Cause of disability (birth, disease, accidenUtrauma, other) </label><p class="float-left">:</p>
                                                <textarea class="new-textara-inpt" value={forthformInfo.cause_of_disability} onChange={handleChangeForth}
                                                  name="cause_of_disability"
                                                  type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>




                                                <div style={{ position: 'relative', display: 'block' }} >
                                                  <p className='error-msg-frm error-sbso ' style={{ textAlign: 'center', marginLeft: '0px', position: 'absolute' }}>
                                                    {forthformInfo.cause_of_disability_error == true ? 'Please enter cause of disability (birth, disease, accidenUtrauma, other)' : ''}

                                                  </p>
                                                </div>

                                              </div>
                                            </div>
                                            <div className='col-md-6'>
                                              <div class="std-form-inner other-sec">
                                                <label>5. List the sports you are interested in playing</label><p class="float-left">:</p>
                                                <textarea class="new-textara-inpt" type="text" id="fname"
                                                  value={forthformInfo.list_of_sports} onChange={handleChangeForth}
                                                  name="list_of_sports"
                                                  placeholder="" rows="4" cols="50"></textarea>
                                                <div style={{ position: 'relative', display: 'block' }} >
                                                  <p className='error-msg-frm error-sbso ' style={{ textAlign: 'center', marginLeft: '0px', position: 'absolute' }}>
                                                    {forthformInfo.list_of_sports_error == true ? 'Please enter list the sports you are interested in playing ' : ''}
                                                  </p>
                                                </div>

                                              </div>
                                            </div>


                                          </div>
                                        </div>

                                        <div class="" style={{ marginTop: '45px' }}>
                                          <hr />
                                        </div>
                                        {/* yes no section start */}
                                        <div class="medician-sec general-ques supp-sec">


                                          <div className='row'>
                                            <div className='medi-details-sec gener-ques'>


                                              <div className='radio-sec-medi-details radio-above'>
                                                <FormControl>
                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                        <p class="num-sec">6.</p> <p class="num-data-sec">Do you regularly use a brace, assistive device, or prosthetic?</p>
                                                      </FormLabel>
                                                    </div>

                                                    <div className="col-md-6">
                                                      <RadioGroup
                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="row-radio-buttons-group" className='radio-secss'
                                                      >
                                                        <FormControlLabel value="Yes"



                                                          name="use_assistive_device" checked={forthformInfo.use_assistive_device == 'Yes'}
                                                          onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No"


                                                          name="use_assistive_device" checked={forthformInfo.use_assistive_device == 'No'}
                                                          onChange={handleChangeForth} control={<Radio />} label="No" />


                                                        <div className='fied-miss'>
                                                          {forthformInfo.use_assistive_device_error == true ? 'Field missing' : ''}
                                                        </div>

                                                      </RadioGroup>


                                                    </div>
                                                  </div>


                                                  {forthformInfo.use_assistive_device == 'Yes' ?

                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <div class="std-form-inner address-sec">
                                                          <label>Explain

                                                          </label>
                                                          <p class="float-left">:</p>
                                                          <textarea class="textarea-input"
                                                            value={forthformInfo.explain_use_assistive_device} onChange={handleChangeForth}
                                                            name="explain_use_assistive_device" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                          <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                            <span>
                                                              {forthformInfo.explain_use_assistive_device_error == true ? 'Please enter the explanation' : ''}
                                                            </span>
                                                          </p>
                                                        </div>

                                                      </div>
                                                    </div>

                                                    : ''}

                                                </FormControl>
                                              </div>

                                              <div class="" style={{ marginTop: '0px' }}>
                                                <hr />
                                              </div>
                                              <div className='radio-sec-medi-details radio-above fam-about'>
                                                <FormControl>
                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                        <p class="num-sec">7.</p><p class="num-data-sec">Do you use any special brace or assistive device for sports?</p>
                                                      </FormLabel>
                                                    </div>

                                                    <div className="col-md-6">
                                                      <RadioGroup
                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="row-radio-buttons-group" className='radio-secss'
                                                      >
                                                        <FormControlLabel value="Yes"



                                                          name="special_brace" checked={forthformInfo.special_brace == 'Yes'}
                                                          onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No"


                                                          name="special_brace" checked={forthformInfo.special_brace == 'No'}
                                                          onChange={handleChangeForth} control={<Radio />} label="No" />

                                                        <div className='fied-miss'>
                                                          {forthformInfo.special_brace_error == true ? 'Field missing' : ''}
                                                        </div>
                                                      </RadioGroup>



                                                    </div>
                                                  </div>

                                                  {forthformInfo.special_brace == 'Yes' ?

                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <div class="std-form-inner address-sec">
                                                          <label>Explain

                                                          </label>
                                                          <p class="float-left">:</p>
                                                          <textarea class="textarea-input"
                                                            value={forthformInfo.explain_special_brace} onChange={handleChangeForth}
                                                            name="explain_special_brace" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                          <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                            <span>
                                                              {forthformInfo.explain_special_brace_error == true ? 'Please enter the explanation' : ''}
                                                            </span>
                                                          </p>
                                                        </div>

                                                      </div>
                                                    </div>

                                                    : ''}
                                                </FormControl>

                                              </div>

                                              <div class="" style={{ marginTop: '0px' }}>
                                                <hr />
                                              </div>

                                              <div className='radio-sec-medi-details radio-above fam-about'>
                                                <FormControl>
                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                        <p class="num-sec">8.</p><p class="num-data-sec">Do you have any rashes, pressure sores, or any other skin problems?</p>
                                                      </FormLabel>
                                                    </div>

                                                    <div className="col-md-6">
                                                      <RadioGroup
                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="row-radio-buttons-group" className='radio-secss'
                                                      >
                                                        <FormControlLabel value="Yes"



                                                          name="any_rashes_pressure" checked={forthformInfo.any_rashes_pressure == 'Yes'}
                                                          onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No"


                                                          name="any_rashes_pressure" checked={forthformInfo.any_rashes_pressure == 'No'}
                                                          onChange={handleChangeForth} control={<Radio />} label="No" />
                                                        <div className='fied-miss'>

                                                          {forthformInfo.any_rashes_pressure_error == true ? 'Field missing' : ''}
                                                        </div>

                                                      </RadioGroup>



                                                    </div>
                                                  </div>


                                                  {forthformInfo.any_rashes_pressure == 'Yes' ?

                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <div class="std-form-inner address-sec">
                                                          <label>Explain

                                                          </label>
                                                          <p class="float-left">:</p>
                                                          <textarea class="textarea-input"
                                                            value={forthformInfo.explain_any_rashes_pressure} onChange={handleChangeForth}
                                                            name="explain_any_rashes_pressure" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                          <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                            <span>
                                                              {forthformInfo.explain_any_rashes_pressure_error == true ? 'Please enter the explanation' : ''}
                                                            </span>
                                                          </p>
                                                        </div>

                                                      </div>
                                                    </div>

                                                    : ''}
                                                </FormControl>
                                              </div>
                                              <div class="" style={{ marginTop: '0px' }}>
                                                <hr />
                                              </div>

                                              <div className='radio-sec-medi-details radio-above fam-about'>
                                                <FormControl>
                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                        <p class="num-sec">9.</p><p class="num-data-sec">Do you have a hearing loss? Do you use a hearing aid?</p>
                                                      </FormLabel>
                                                    </div>

                                                    <div className="col-md-6">
                                                      <RadioGroup
                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="row-radio-buttons-group" className='radio-secss'
                                                      >
                                                        <FormControlLabel value="Yes"



                                                          name="hearing_loss" checked={forthformInfo.hearing_loss == 'Yes'}
                                                          onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No"


                                                          name="hearing_loss" checked={forthformInfo.hearing_loss == 'No'}
                                                          onChange={handleChangeForth} control={<Radio />} label="No" />
                                                        <div className='fied-miss'>

                                                          {forthformInfo.hearing_loss_error == true ? 'Field missing ' : ''}
                                                        </div>

                                                      </RadioGroup>


                                                    </div>
                                                  </div>

                                                  {forthformInfo.hearing_loss == 'Yes' ?

                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <div class="std-form-inner address-sec">
                                                          <label>Explain

                                                          </label>
                                                          <p class="float-left">:</p>
                                                          <textarea class="textarea-input"
                                                            value={forthformInfo.explain_hearing_loss} onChange={handleChangeForth}
                                                            name="explain_hearing_loss" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                          <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                            <span>
                                                              {forthformInfo.explain_hearing_loss_error == true ? 'Please enter the explanation' : ''}
                                                            </span>
                                                          </p>
                                                        </div>

                                                      </div>
                                                    </div>

                                                    : ''}
                                                </FormControl>
                                              </div>

                                              <div class="" style={{ marginTop: '0px' }}>
                                                <hr />
                                              </div>
                                              <div className='radio-sec-medi-details radio-above fam-about'>
                                                <FormControl>
                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                        <p class="num-sec">10.</p><p class="num-data-sec">Do you have a visual impairment?</p>
                                                      </FormLabel>
                                                    </div>

                                                    <div className="col-md-6">
                                                      <RadioGroup
                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="row-radio-buttons-group" className='radio-secss'
                                                      >
                                                        <FormControlLabel value="Yes"



                                                          name="visual_impairment" checked={forthformInfo.visual_impairment == 'Yes'}
                                                          onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No"


                                                          name="visual_impairment" checked={forthformInfo.visual_impairment == 'No'}
                                                          onChange={handleChangeForth} control={<Radio />} label="No" />

                                                        <div className='fied-miss'>

                                                          {forthformInfo.visual_impairment_error == true ? 'Field missing ' : ''}
                                                        </div>



                                                      </RadioGroup>




                                                    </div>
                                                  </div>

                                                  {forthformInfo.visual_impairment == 'Yes' ?

                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <div class="std-form-inner address-sec">
                                                          <label>Explain

                                                          </label>
                                                          <p class="float-left">:</p>
                                                          <textarea class="textarea-input"
                                                            value={forthformInfo.explain_visual_impairment} onChange={handleChangeForth}
                                                            name="explain_visual_impairment" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                          <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                            <span>
                                                              {forthformInfo.explain_visual_impairment_error == true ? 'Please enter the explanation' : ''}
                                                            </span>
                                                          </p>
                                                        </div>

                                                      </div>
                                                    </div>

                                                    : ''}
                                                </FormControl>
                                              </div>
                                              <div class="" style={{ marginTop: '0px' }}>
                                                <hr />
                                              </div>

                                              <div className='radio-sec-medi-details radio-above fam-about'>
                                                <FormControl>
                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                        <p class="num-sec">11.</p><p class="num-data-sec"> Do you use any special devices for bowel or bladder function?</p>
                                                      </FormLabel>
                                                    </div>

                                                    <div className="col-md-5">
                                                      <RadioGroup
                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="row-radio-buttons-group" className='radio-secss'
                                                      >
                                                        <FormControlLabel value="Yes"



                                                          name="bowel_bladder_function" checked={forthformInfo.bowel_bladder_function == 'Yes'}
                                                          onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No"


                                                          name="bowel_bladder_function" checked={forthformInfo.bowel_bladder_function == 'No'}
                                                          onChange={handleChangeForth} control={<Radio />} label="No" />

                                                        <div className='fied-miss'>

                                                          {forthformInfo.bowel_bladder_function_error == true ? 'Field missing' : ''}
                                                        </div>

                                                      </RadioGroup>



                                                    </div>
                                                  </div>


                                                  {forthformInfo.bowel_bladder_function == 'Yes' ?

                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <div class="std-form-inner address-sec">
                                                          <label>Explain

                                                          </label>
                                                          <p class="float-left">:</p>
                                                          <textarea class="textarea-input"
                                                            value={forthformInfo.explain_bowel_bladder_function} onChange={handleChangeForth}
                                                            name="explain_bowel_bladder_function" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                          <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                            <span>
                                                              {forthformInfo.explain_bowel_bladder_function_error == true ? 'Please enter the explanation' : ''}
                                                            </span>
                                                          </p>
                                                        </div>

                                                      </div>
                                                    </div>

                                                    : ''}
                                                </FormControl>
                                              </div>
                                              <div class="" style={{ marginTop: '0px' }}>
                                                <hr />
                                              </div>

                                              <div className='radio-sec-medi-details radio-above fam-about'>
                                                <FormControl>
                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                        <p class="num-sec">12.</p><p class="num-data-sec"> Do you have burning or discomfort when urinating?</p>
                                                      </FormLabel>
                                                    </div>

                                                    <div className="col-md-6">
                                                      <RadioGroup
                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="row-radio-buttons-group" className='radio-secss'
                                                      >
                                                        <FormControlLabel value="Yes"



                                                          name="discomfort_when_urinating" checked={forthformInfo.discomfort_when_urinating == 'Yes'}
                                                          onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No"


                                                          name="discomfort_when_urinating" checked={forthformInfo.discomfort_when_urinating == 'No'}
                                                          onChange={handleChangeForth} control={<Radio />} label="No" />
                                                        <div className='fied-miss'>

                                                          {forthformInfo.discomfort_when_urinating_error == true ? 'Field missing ' : ''}
                                                        </div>


                                                      </RadioGroup>


                                                    </div>
                                                  </div>
                                                  {forthformInfo.discomfort_when_urinating == 'Yes' ?

                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <div class="std-form-inner address-sec">
                                                          <label>Explain

                                                          </label>
                                                          <p class="float-left">:</p>
                                                          <textarea class="textarea-input"
                                                            value={forthformInfo.explain_discomfort_when_urinating} onChange={handleChangeForth}
                                                            name="explain_discomfort_when_urinating" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                          <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                            <span>
                                                              {forthformInfo.explain_discomfort_when_urinating_error == true ? 'Please enter the explanation' : ''}
                                                            </span>
                                                          </p>
                                                        </div>

                                                      </div>
                                                    </div>

                                                    : ''}
                                                </FormControl>
                                              </div>
                                              <div class="" style={{ marginTop: '0px' }}>
                                                <hr />
                                              </div>

                                              <div className='radio-sec-medi-details radio-above fam-about'>
                                                <FormControl>
                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                        <p class="num-sec">13.</p><p class="num-data-sec">Have you had autonomic dysreflexia?</p>
                                                      </FormLabel>
                                                    </div>

                                                    <div className="col-md-6">
                                                      <RadioGroup

                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="row-radio-buttons-group" className='radio-secss'
                                                      >
                                                        <FormControlLabel value="Yes"



                                                          name="autonomic_dysreflexia" checked={forthformInfo.autonomic_dysreflexia == 'Yes'}
                                                          onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No"


                                                          name="autonomic_dysreflexia" checked={forthformInfo.autonomic_dysreflexia == 'No'}
                                                          onChange={handleChangeForth} control={<Radio />} label="No" />
                                                        <div className='fied-miss'>

                                                          {forthformInfo.autonomic_dysreflexia_error == true ? 'Field missing ' : ''}
                                                        </div>



                                                      </RadioGroup>



                                                    </div>
                                                  </div>

                                                  {forthformInfo.autonomic_dysreflexia == 'Yes' ?

                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <div class="std-form-inner address-sec">
                                                          <label>Explain

                                                          </label>
                                                          <p class="float-left">:</p>
                                                          <textarea class="textarea-input"
                                                            value={forthformInfo.explain_autonomic_dysreflexia} onChange={handleChangeForth}
                                                            name="explain_autonomic_dysreflexia" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                          <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                            <span>
                                                              {forthformInfo.explain_autonomic_dysreflexia_error == true ? 'Please enter the explanation' : ''}
                                                            </span>
                                                          </p>
                                                        </div>

                                                      </div>
                                                    </div>

                                                    : ''}
                                                </FormControl>
                                              </div>
                                              <div class="" style={{ marginTop: '0px' }}>
                                                <hr />
                                              </div>

                                              <div className='radio-sec-medi-details radio-above fam-about'>
                                                <FormControl>
                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                        <p class="num-sec">14.</p><p class="num-data-sec">
                                                          Have you ever been diagnosed with a heat-related (hyperthermia) or cold-related (hypothermia) illness?
                                                        </p>
                                                      </FormLabel>
                                                    </div>

                                                    <div className="col-md-6">
                                                      <RadioGroup
                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="row-radio-buttons-group" className='radio-secss'
                                                      >
                                                        <FormControlLabel value="Yes"



                                                          name="diagnosed_heat_related" checked={forthformInfo.diagnosed_heat_related == 'Yes'}
                                                          onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No"


                                                          name="diagnosed_heat_related" checked={forthformInfo.diagnosed_heat_related == 'No'}
                                                          onChange={handleChangeForth} control={<Radio />} label="No" />
                                                        <div className='fied-miss'>

                                                          {forthformInfo.diagnosed_heat_related_error == true ? 'Field missing ' : ''}
                                                        </div>

                                                      </RadioGroup>


                                                    </div>
                                                  </div>

                                                  {forthformInfo.diagnosed_heat_related == 'Yes' ?

                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <div class="std-form-inner address-sec">
                                                          <label>Explain

                                                          </label>
                                                          <p class="float-left">:</p>
                                                          <textarea class="textarea-input"
                                                            value={forthformInfo.explain_diagnosed_heat_related} onChange={handleChangeForth}
                                                            name="explain_diagnosed_heat_related" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                          <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                            <span>
                                                              {forthformInfo.explain_diagnosed_heat_related_error == true ? 'Please enter the explanation' : ''}
                                                            </span>
                                                          </p>
                                                        </div>

                                                      </div>
                                                    </div>

                                                    : ''}
                                                </FormControl>
                                              </div>

                                              <div class="" style={{ marginTop: '0px' }}>
                                                <hr />
                                              </div>

                                              <div className='radio-sec-medi-details radio-above fam-about'>
                                                <FormControl>
                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                        <p class="num-sec">15.</p><p class="num-data-sec"> Do you have muscle spasticity?</p>
                                                      </FormLabel>
                                                    </div>

                                                    <div className="col-md-6">
                                                      <RadioGroup
                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="row-radio-buttons-group" className='radio-secss'
                                                      >
                                                        <FormControlLabel value="Yes"



                                                          name="muscle_spasticity" checked={forthformInfo.muscle_spasticity == 'Yes'}
                                                          onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No"


                                                          name="muscle_spasticity" checked={forthformInfo.muscle_spasticity == 'No'}
                                                          onChange={handleChangeForth} control={<Radio />} label="No" />

                                                        <div className='fied-miss'>

                                                          {forthformInfo.muscle_spasticity_error == true ? 'Field missing' : ''}
                                                        </div>


                                                      </RadioGroup>



                                                    </div>
                                                  </div>

                                                  {forthformInfo.muscle_spasticity == 'Yes' ?

                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <div class="std-form-inner address-sec">
                                                          <label>Explain

                                                          </label>
                                                          <p class="float-left">:</p>
                                                          <textarea class="textarea-input"
                                                            value={forthformInfo.explain_muscle_spasticity} onChange={handleChangeForth}
                                                            name="explain_muscle_spasticity" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                          <p className='error-msg-frm error-msg-frm-top error-new-his error-new-his'>
                                                            <span>
                                                              {forthformInfo.explain_muscle_spasticity_error == true ? 'Please enter the explanation' : ''}
                                                            </span>
                                                          </p>
                                                        </div>

                                                      </div>
                                                    </div>

                                                    : ''}
                                                </FormControl>
                                              </div>

                                              <div class="" style={{ marginTop: '0px' }}>
                                                <hr />
                                              </div>
                                              <div className='radio-sec-medi-details radio-above fam-about'>
                                                <FormControl>
                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                        <p class="num-sec">16.</p><p class="num-data-sec">Do you have frequent seizures that cannot be controlled by medication?</p>
                                                      </FormLabel>
                                                    </div>

                                                    <div className="col-md-6">
                                                      <RadioGroup
                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="row-radio-buttons-group" className='radio-secss'
                                                      >
                                                        <FormControlLabel value="Yes"



                                                          name="frequent_seizures" checked={forthformInfo.frequent_seizures == 'Yes'}
                                                          onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No"


                                                          name="frequent_seizures" checked={forthformInfo.frequent_seizures == 'No'}
                                                          onChange={handleChangeForth} control={<Radio />} label="No" />

                                                        <div className='fied-miss'>

                                                          {forthformInfo.frequent_seizures_error == true ? 'Field missing' : ''}
                                                        </div>


                                                      </RadioGroup>



                                                    </div>
                                                  </div>

                                                  {forthformInfo.frequent_seizures == 'Yes' ?

                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <div class="std-form-inner address-sec">
                                                          <label>Explain

                                                          </label>
                                                          <p class="float-left">:</p>
                                                          <textarea class="textarea-input"
                                                            value={forthformInfo.explain_frequent_seizures} onChange={handleChangeForth}
                                                            name="explain_frequent_seizures" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                          <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                            <span>
                                                              {forthformInfo.explain_frequent_seizures_error == true ? 'Please enter the explanation' : ''}
                                                            </span>
                                                          </p>
                                                        </div>

                                                      </div>
                                                    </div>

                                                    : ''}
                                                </FormControl>
                                              </div>

                                            </div>
                                          </div>

                                        </div>

                                      </>}


                                    {/* yes no section end */}


                                    <div className='indicate-sec'>

                                      {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 4) == true) ?

                                        '' : <>
                                          <div className='row'>
                                            <div className='col-md-12'>

                                              <div class="physici-sec-head">
                                                <h2 style={{ color: '#ffffff' }}>Please indicate if you have ever had any of the following</h2>
                                              </div>

                                            </div>
                                          </div>

                                          <div className='medi-details-sec gener-ques'>


                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      Atlantoaxial instability
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="atlantoaxial_instability" checked={forthformInfo.atlantoaxial_instability == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="atlantoaxial_instability" checked={forthformInfo.atlantoaxial_instability == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />
                                                      <div className='fied-miss'>

                                                        {forthformInfo.atlantoaxial_instability_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>



                                                  </div>
                                                </div>


                                                {forthformInfo.atlantoaxial_instability == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_atlantoaxial_instability} onChange={handleChangeForth}
                                                          name="explain_atlantoaxial_instability" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_atlantoaxial_instability_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}

                                              </FormControl>
                                            </div>


                                            <div class="" style={{ marginTop: '0px' }}>
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      X-ray evaluation for atlantoaxial instability
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="xray_evaluation" checked={forthformInfo.xray_evaluation == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="xray_evaluation" checked={forthformInfo.xray_evaluation == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />

                                                      <div className='fied-miss'>

                                                        {forthformInfo.xray_evaluation_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>



                                                  </div>
                                                </div>



                                                {forthformInfo.xray_evaluation == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_xray_evaluation} onChange={handleChangeForth}
                                                          name="explain_xray_evaluation" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_xray_evaluation_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}
                                              </FormControl>
                                            </div>

                                            <div class="" style={{ marginTop: '0px' }}>
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      Dislocated joints (more than one)
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="dislocated_joints" checked={forthformInfo.dislocated_joints == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="dislocated_joints" checked={forthformInfo.dislocated_joints == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />

                                                      <div className='fied-miss'>

                                                        {forthformInfo.dislocated_joints_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>


                                                  </div>
                                                </div>


                                                {forthformInfo.dislocated_joints == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_dislocated_joints} onChange={handleChangeForth}
                                                          name="explain_dislocated_joints" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_dislocated_joints_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}

                                              </FormControl>
                                            </div>
                                            <div class="" style={{ marginTop: '0px' }}>
                                              <hr />
                                            </div>


                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      Easy bleeding
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="easy_bleeding" checked={forthformInfo.easy_bleeding == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="easy_bleeding" checked={forthformInfo.easy_bleeding == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />
                                                      <div className='fied-miss'>

                                                        {forthformInfo.easy_bleeding_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>



                                                  </div>
                                                </div>




                                                {forthformInfo.easy_bleeding == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_easy_bleeding} onChange={handleChangeForth}
                                                          name="explain_easy_bleeding" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_easy_bleeding_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}
                                              </FormControl>
                                            </div>
                                            <div class="" style={{ marginTop: '0px' }}>
                                              <hr />
                                            </div>


                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      Enlarged spleen
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="enlarged_spleen" checked={forthformInfo.enlarged_spleen == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="enlarged_spleen" checked={forthformInfo.enlarged_spleen == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />

                                                      <div className='fied-miss'>

                                                        {forthformInfo.enlarged_spleen_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>


                                                  </div>
                                                </div>



                                                {forthformInfo.enlarged_spleen == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_enlarged_spleen} onChange={handleChangeForth}
                                                          name="explain_enlarged_spleen" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_enlarged_spleen_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}
                                              </FormControl>
                                            </div>

                                            <div class="" style={{ marginTop: '0px' }}>
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      Hepatitis
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="hepatitis" checked={forthformInfo.hepatitis == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="hepatitis" checked={forthformInfo.hepatitis == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />

                                                      <div className='fied-miss'>

                                                        {forthformInfo.hepatitis_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>


                                                  </div>
                                                </div>


                                                {forthformInfo.hepatitis == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_hepatitis} onChange={handleChangeForth}
                                                          name="explain_hepatitis" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_hepatitis_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}

                                              </FormControl>
                                            </div>
                                            <div class="" style={{ marginTop: '0px' }}>
                                              <hr />
                                            </div>


                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      Osteopenia or osteoporosis
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="osteopenia_or_osteoporosis" checked={forthformInfo.osteopenia_or_osteoporosis == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="osteopenia_or_osteoporosis" checked={forthformInfo.osteopenia_or_osteoporosis == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />

                                                      <div className='fied-miss'>

                                                        {forthformInfo.osteopenia_or_osteoporosis_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>



                                                  </div>
                                                </div>



                                                {forthformInfo.osteopenia_or_osteoporosis == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_osteopenia_or_osteoporosis} onChange={handleChangeForth}
                                                          name="explain_osteopenia_or_osteoporosis" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_osteopenia_or_osteoporosis_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}
                                              </FormControl>
                                            </div>

                                            <div class="" style={{ marginTop: '0px' }}>
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      Difficulty controlling bowel
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="controlling_bowel" checked={forthformInfo.controlling_bowel == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="controlling_bowel" checked={forthformInfo.controlling_bowel == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />

                                                      <div className='fied-miss'>

                                                        {forthformInfo.controlling_bowel_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>



                                                  </div>
                                                </div>


                                                {forthformInfo.controlling_bowel == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_controlling_bowel} onChange={handleChangeForth}
                                                          name="explain_controlling_bowel" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_controlling_bowel_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}

                                              </FormControl>
                                            </div>

                                            <div class="" style={{ marginTop: '0px' }}>
                                              <hr />
                                            </div>
                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      Difficulty controlling bladder
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="controlling_bladder" checked={forthformInfo.controlling_bladder == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="controlling_bladder" checked={forthformInfo.controlling_bladder == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />
                                                      <div className='fied-miss'>

                                                        {forthformInfo.controlling_bladder_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>



                                                  </div>
                                                </div>



                                                {forthformInfo.controlling_bladder == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_controlling_bladder} onChange={handleChangeForth}
                                                          name="explain_controlling_bladder" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_controlling_bladder_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}

                                              </FormControl>
                                            </div>
                                            <div class="" style={{ marginTop: '0px' }}>
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      Numbness or tingling in arms or hands
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="numbnesss_in_arms_or_hands" checked={forthformInfo.numbnesss_in_arms_or_hands == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="numbnesss_in_arms_or_hands" checked={forthformInfo.numbnesss_in_arms_or_hands == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />
                                                      <div className='fied-miss'>

                                                        {forthformInfo.numbnesss_in_arms_or_hands_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>




                                                  </div>
                                                </div>


                                                {forthformInfo.numbnesss_in_arms_or_hands == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_numbnesss_in_arms_or_hands} onChange={handleChangeForth}
                                                          name="explain_numbnesss_in_arms_or_hands" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_numbnesss_in_arms_or_hands_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}

                                              </FormControl>
                                            </div>
                                            <div class="" style={{ marginTop: '0px' }}>
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      Numbness or tingling in legs or feet
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="numbnesss_in_legs_or_feet" checked={forthformInfo.numbnesss_in_legs_or_feet == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="numbnesss_in_legs_or_feet" checked={forthformInfo.numbnesss_in_legs_or_feet == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />

                                                      <div className='fied-miss'>

                                                        {forthformInfo.numbnesss_in_legs_or_feet_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>



                                                  </div>
                                                </div>


                                                {forthformInfo.numbnesss_in_legs_or_feet == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_numbnesss_in_legs_or_feet} onChange={handleChangeForth}
                                                          name="explain_numbnesss_in_legs_or_feet" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_numbnesss_in_legs_or_feet_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}


                                              </FormControl>
                                            </div>
                                            <div class="" style={{ marginTop: '0px' }}>
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      Weakness in arms or hands
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="weakness_in_arms_hands" checked={forthformInfo.weakness_in_arms_hands == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="weakness_in_arms_hands" checked={forthformInfo.weakness_in_arms_hands == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />

                                                      <div className='fied-miss'>

                                                        {forthformInfo.weakness_in_arms_hands_error == true ? 'Field missing ' : ''}
                                                      </div>
                                                    </RadioGroup>




                                                  </div>
                                                </div>



                                                {forthformInfo.weakness_in_arms_hands == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_weakness_in_arms_hands} onChange={handleChangeForth}
                                                          name="explain_weakness_in_arms_hands" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_weakness_in_arms_hands_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}
                                              </FormControl>
                                            </div>

                                            <div class="" style={{ marginTop: '0px' }}>
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      Weakness in legs or feet
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="weakness_in_leg_feet" checked={forthformInfo.weakness_in_leg_feet == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="weakness_in_leg_feet" checked={forthformInfo.weakness_in_leg_feet == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />

                                                      <div className='fied-miss'>

                                                        {forthformInfo.weakness_in_leg_feet_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>



                                                  </div>
                                                </div>

                                                {forthformInfo.weakness_in_leg_feet == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_weakness_in_leg_feet} onChange={handleChangeForth}
                                                          name="explain_weakness_in_leg_feet" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_weakness_in_leg_feet_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}


                                              </FormControl>
                                            </div>

                                            <div class="" style={{ marginTop: '0px' }}>
                                              <hr />
                                            </div>
                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      Recent change in coordination
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="change_in_coordination" checked={forthformInfo.change_in_coordination == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="change_in_coordination" checked={forthformInfo.change_in_coordination == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />
                                                      <div className='fied-miss'>

                                                        {forthformInfo.change_in_coordination_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>



                                                  </div>
                                                </div>



                                                {forthformInfo.change_in_coordination == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_change_in_coordination} onChange={handleChangeForth}
                                                          name="explain_change_in_coordination" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_change_in_coordination_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>

                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}

                                              </FormControl>
                                            </div>

                                            <div class="" style={{ marginTop: '0px' }}>
                                              <hr />
                                            </div>
                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      Recent change in ability to walk
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="change_ability_walk" checked={forthformInfo.change_ability_walk == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="change_ability_walk" checked={forthformInfo.change_ability_walk == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />
                                                      <div className='fied-miss'>

                                                        {forthformInfo.change_ability_walk_error == true ? 'Field missing ' : ''}
                                                      </div>

                                                    </RadioGroup>


                                                  </div>
                                                </div>


                                                {forthformInfo.change_ability_walk == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_change_ability_walk} onChange={handleChangeForth}
                                                          name="explain_change_ability_walk" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_change_ability_walk_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}

                                              </FormControl>
                                            </div>

                                            <div class="" style={{ marginTop: '0px' }}>
                                              <hr />
                                            </div>
                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      Spina bifida
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="spina_bifida" checked={forthformInfo.spina_bifida == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="spina_bifida" checked={forthformInfo.spina_bifida == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />

                                                      <div className='fied-miss'>

                                                        {forthformInfo.spina_bifida_error == true ? 'Field missing ' : ''}
                                                      </div>

                                                    </RadioGroup>


                                                  </div>
                                                </div>


                                                {forthformInfo.spina_bifida == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_spina_bifida} onChange={handleChangeForth}
                                                          name="explain_spina_bifida" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_spina_bifida_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}

                                              </FormControl>
                                            </div>
                                            <div class="" style={{ marginTop: '0px' }}>
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-6'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      Latex allergy
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-6">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"



                                                        name="latex_allergy" checked={forthformInfo.latex_allergy == 'Yes'}
                                                        onChange={handleChangeForth} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="latex_allergy" checked={forthformInfo.latex_allergy == 'No'}
                                                        onChange={handleChangeForth} control={<Radio />} label="No" />

                                                      <div className='fied-miss'>

                                                        {forthformInfo.latex_allergy_error == true ? 'Field missing' : ''}
                                                      </div>


                                                    </RadioGroup>



                                                  </div>
                                                </div>


                                                {forthformInfo.latex_allergy == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-6'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Explain

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="textarea-input"
                                                          value={forthformInfo.explain_latex_allergy} onChange={handleChangeForth}
                                                          name="explain_latex_allergy" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top error-new-his'>
                                                          <span>
                                                            {forthformInfo.explain_latex_allergy_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  : ''}

                                              </FormControl>
                                            </div>



                                          </div>


                                          {/* family only section end */}

                                          {/* acknowledge section start */}
                                          <div class="medician-sec general-ques family-sec">
                                            <div className='row'>
                                              <div className='medi-details-sec gener-ques'>
                                                <div className='col-md-12'>
                                                  <h2>I hereby state that, to the best of my knowledge, my answers to the above questions are complete and correct.</h2>

                                                </div>

                                              </div>
                                            </div>
                                            <div className='sign-sec-main'>
                                              <div class="row">
                                                <div class="col-md-9">
                                                  <div class="sign-sec">
                                                    <p>Signature of Athlete  </p>
                                                    <p class="colon-sec">:</p>
                                                    <input class="text-input-sign cusrive-font-sec"
                                                      value={forthformInfo.athlete_signature} onChange={handleChangeForth}
                                                      name="athlete_signature" type="text" id="fname" placeholder="" />
                                                    <p class="error-msg-frm"><span>
                                                      {forthformInfo.athlete_signature_error == true ? 'Please enter  the signature of athlete ' : ''}
                                                    </span></p>


                                                  </div>
                                                </div>

                                              </div>

                                              <div class="row">
                                                <div class="col-md-9">
                                                  <div class="sign-sec">
                                                    <p>Signature of Parent/Guardian  </p>
                                                    <p class="colon-sec">:</p>
                                                    <input class="text-input-sign cusrive-font-sec" type="text" id="fname" placeholder=""
                                                      value={forthformInfo.parent_signature} onChange={handleChangeForth}
                                                      name="parent_signature" />
                                                    <p class="error-msg-frm"><span>
                                                      {forthformInfo.parent_signature_error == true ? 'Please enter  the signature of parent/guardian ' : ''}
                                                    </span></p>

                                                  </div>
                                                </div>
                                                <div class="col-md-3">

                                                  <div className='form-date-sec form-date-nbw'>
                                                    <label >Date </label>

                                                    <div className='sign-sec'>

                                                      <p className='colon-sec'>:</p>
                                                      <p style={{ fontWeight: '400', marginLeft: '9px', paddingTop: '7px' }}>{formDate}</p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className='declare-sec'>
                                                <div className='row'>
                                                  <div className='col-md-12'>
                                                    <p>©2010 American Academy of Family Physicians. American Academy of Pediatrics, American College of Sports Medicine, American Medical
                                                      Society for Sports Medicine, American Orthopaedic Society for Sports Medicine, and American Osteopathic Academy of Sports Medicine.
                                                      Permission is granted to reprint for noncommercial, educational purposes with acknowledgment.</p>

                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>


                                          {/* acknowledge section end */}

                                        </>}


                                      <div className='row'>
                                        <div className='col-md-12'>
                                          <div class="login-submit login-submitss login-toltip">
                                            {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 4) == true) ?

                                              <>

                                                {(pdfExists(allstudentlisdata, userData.stuid + '_1_supplemental_history_form.pdf') == true)

                                                  ?


                                                  <>

                                                    <button class="btn btn-login btn-submit bt-forms bt-fill-newfrms btn-edits"
                                                      onClick={(e) => handleOpenLogacc(4)}
                                                    >EDIT</button>
                                                    {/*<a title="Download" 
                  
                        onClick={(e) => handleDownloadFile(userData.stuid,4,userData.stuid + '_1_supplemental_history_form.pdf')}

                        
                target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>*/}
                                                    <Timer
                                                      startDateTime={getFormData(4).created_at}
                                                      downloadFile={(userData.stuid + "_1_supplemental_history_form.pdf")}
                                                      stuid={userData.stuid}
                                                      formId={4}
                                                      handleDownloadFile={handleDownloadFile}
                                                      handleTimerComplete={handleTimerComplete}
                                                      handleReqFormDownload={handleReqFormDownload}
                                                    />


                                                  </>

                                                  :
                                                  <>
                                                    {/*<a title="Download" 
                    
                        onClick={(e) => handleDownloadFile(userData.stuid,4,userData.stuid + '_2_supplemental_history_form.pdf')}

              target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>*/}
                                                    <Timer
                                                      startDateTime={getFormData(4).created_at}
                                                      downloadFile={(userData.stuid + "_2_supplemental_history_form.pdf")}
                                                      stuid={userData.stuid}
                                                      formId={4}
                                                      handleDownloadFile={handleDownloadFile}
                                                      handleTimerComplete={handleTimerComplete}
                                                      handleReqFormDownload={handleReqFormDownload}
                                                    />

                                                  </>

                                                }

                                              </>

                                              : <button class="btn btn-login btn-submit bt-forms" onClick={handleSubmitForth}>Submit
                                                {
                                                  parentLoaderForth != '' ?
                                                    <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                                                    : ''

                                                }
                                              </button>
                                            }
                                          </div>
                                          {
                                            successMsgForth != '' ? <div className="success-msg success-login form-success">
                                              <p className="success-msg success-login">{successMsgForth}</p>
                                            </div> : ''
                                          }


                                          {
                                            errorMsgForth != '' ? <div className="error-msg error-login form-error" >
                                              <p className="error-msg error-login">{errorMsgForth}</p>
                                            </div> : <div className="error-msg error-login form-error" style={{ visibility: 'hidden' }} >
                                              <p className="error-msg error-login">Wrong credentials!</p>
                                            </div>
                                          }

                                        </div>
                                      </div>

                                    </div>




                                  </div>

                                </Typography>
                              </AccordionDetails>
                            </Accordion>

                          </div> : null}



                        {/* <div className='form-accor-sec'>
            <Accordion>
                    <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3-content"
                    id="panel3-header"
                    >
                    <Typography>PREPARTICIPATION PHYSICAL EVALUATION PHYSICAL EXAMINATION FORM</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                    <Typography>
                        
                    </Typography>
                    </AccordionDetails>
                </Accordion>
             
            </div> */}


                        <div className='form-accor-sec color-form-occur'>
                          <Accordion expanded={expandednew === 'panel6f'} onChange={handleChangenew('panel6f')}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel3-content"
                              id="panel3-header"
                            >
                              <Typography sx={{ width: '80%', flexShrink: 0 }}>SPORTS-RELATED CONCUSSION AND HEAD INJURY FACT SHEET AND PARENT/GUARDIAN ACKNOWLEDGEMENT FORM</Typography>
                              <Typography className="green-dwn break-dm" sx={{ flexShrink: 0, color: 'text.secondary', float: 'right', width: '20%', textAlign: 'right', color: '#008430', fontWeight: '600' }} >
                                {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 6) == true) ?

                                  'Completed' : <span className='pebdingarmh'>Pending</span>}
                              </Typography>

                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <div className='form-main-sec'>
                                  <div className='date-form acknw-cont-sec'>
                                    {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 6) == true) ?

                                      ''
                                      : <>
                                        <div className='row'>
                                          <div className='col-md-2'>
                                            <div className='heading-logo'>
                                              <img src={newlogos} />
                                            </div>
                                          </div>
                                          <div className='col-md-8'>
                                            <div className='heading-form-para'>
                                              <h1>JERSEY CITY PUBLIC SCHOOLS</h1>
                                              <h1>Sports-Related Concussion and Head Injury Fact Sheet and </h1>
                                              <h2 style={{ marginTop: '7px' }}>Parent/Guardian Acknowledgement Form</h2>


                                            </div>
                                          </div>

                                        </div>
                                      </>
                                    }
                                    <div className='col-md-12'>



                                      {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 6) == true) ?

                                        ''
                                        : <>
                                          <p>A concussion is a brain injury that can be caused by a blow to the head or body that disrupts normal functioning of the brain. Concussions are a type of Traumatic Brain Injury (TBI), which can range from mild to severe and can disrupt the way the brain normally functions.
                                            Concussions can cause significant and sustained neuropsychological impairment affecting problem solving, planning, memory, attention, concentration, and behavior.</p>
                                          <p>The Centers for Disease Control and Prevention estimates that 300,000 concussions are sustained during sports related activities nationwide, and more than 62,000 concussions are sustained each year in high school contact sports. Second­ impact syndrome occurs when a person sustains a second concussion while still experiencing symptoms of a previous concussion. It can lead to severe impairment and even death of the victim.</p>

                                          <p>Legislation (P.L. 2010, Chapter 94) signed on December 7, 2010, mandated measures to be taken in order to ensure the safety ofK-12 student-athletes involved in interscholastic sports in New Jersey. It is imperative that athletes, coaches, and parent/guardians are educated about the nature and treatment of sports related concussions and other head injuries. The legislation states that:</p>

                                          <div className='content-sec-ul'>
                                            <ul>
                                              <li>All Coaches, Athletic Trainers, School Nurses, and School/Team Physicians shall complete an Interscholastic Head Injury Safety Training Program by the 2011-2012 school year.</li>
                                              <li>All school districts, charter, and non-public schools that participate in interscholastic sports will distribute
                                                annually this educational fact to all student athletes and obtain a signed acknowledgement from each parent/guardian and student-athlete
                                              </li>
                                              <li>Each school district, charter, and non-public school shall develop a written policy describing the prevention and treatment of sports-related concussion and other head injuries sustained by interscholastic student-athletes.</li>
                                              <li>Any student-athlete who participates in an interscholastic sports program and is suspected of sustaining a concussion will be immediately removed from competition or practice. The student-athlete will not be allowed
                                                to return to competition or practice until he/she has written clearance from a physician trained in concussion treatment and has completed his/her district's graduated return-to-play protocol.
                                              </li>
                                            </ul>
                                          </div>
                                          <h3>Quick Facts</h3>
                                          <div className='content-sec-ul'>
                                            <ul>
                                              <li>Most concussions do not involve loss of consciousness</li>
                                              <li>You can sustain a concussion even if you do not hit your head </li>
                                              <li>A blow elsewhere on the body can transmit an "impulsive" force to the brain and cause a concussion</li>

                                            </ul>
                                          </div>
                                          <h3>Signs of Concussions (Observed by Coach, Athletic Trainer, Parent/Guardian)</h3>
                                          <div className='content-sec-ul'>
                                            <ul>
                                              <li>Appears dazed or stunned</li>
                                              <li>Forgets plays or demonstrates short term memory difficulties (e.g. unsure of game, opponent)</li>
                                              <li>Exhibits difficulties with balance, coordination, concentration, and attention</li>
                                              <li>Answers questions slowly or inaccurately</li>
                                              <li>Demonstrates behavior or personality changes</li>
                                              <li> Is unable to recall events prior to or after the hit or fall</li>

                                            </ul>
                                          </div>
                                          <h3>Symptoms of Concussion (Reported by Student-Athlete)</h3>
                                          <div className='content-sec-ul'>
                                            <ul>
                                              <li>Headache</li>
                                              <li>Nausea/vomiting</li>
                                              <li>Balance problems or dizziness</li>
                                              <li>Double vision or changes in vision</li>
                                              <li>Sensitivity to light/sound</li>
                                              <li>Feeling of sluggishness or fogginess</li>
                                              <li>Difficulty with concentration, short term memory, and/or confusion</li>

                                            </ul>
                                          </div>
                                          <h3>What Should a Student-Athlete do if they think they have a concussion?</h3>
                                          <div className='content-sec-ul'>
                                            <ul>
                                              <li>Don't hide it. Tell your Athletic Trainer, Coach, School Nurse, or Parent/Guardian.</li>
                                              <li>Report it. Don't return to competition or practice with symptoms of a concussion or head injury. The sooner you report it, the sooner you may return-to-play.</li>
                                              <li>Take time to recover. If you have a concussion your brain needs time to heal. While your brain is healing you are much more likely to sustain a second concussion. Repeat concussions can cause permanent brain injury</li>
                                            </ul>
                                          </div>

                                          <h3>What can happen if a student-athlete continues to play with a concussion or returns to play to soon?</h3>
                                          <div className='content-sec-ul'>
                                            <ul>
                                              <li>Continuing to play with the signs and symptoms of a concussion leaves the student-athlete vulnerable to second impact syndrome</li>
                                              <li>Second impact syndrome is when a student-athlete sustains a second concussion while still having symptoms from a previous concussion or head injury.</li>
                                              <li>Second impact syndrome can lead to severe impairment and even death in extreme cases.</li>
                                            </ul>
                                          </div>


                                          <h3>Should there be any temporary academic accommodations made for Student-Athletes who have suffered a concussion?</h3>
                                          <div className='content-sec-ul'>
                                            <ul>
                                              <li>To recover cognitive rest is just as important as physical rest. Reading, texting, testing-even watching movies can slow down a student-athletes recovery</li>
                                              <li>Stay home from school with minimal mental and social stimulation until all symptoms have resolved.</li>
                                              <li>Students may need to take rest breaks, spend fewer hours at school, be given extra time to complete assignments, as well as being offered other instructional strategies and classroom accommodations.</li>
                                            </ul>
                                          </div>

                                          <h3 style={{ textDecoration: 'underline' }}>Student-Athletes who have sustained a concussion should complete a graduated return-to-play before they may resume competition or practice, according to the following protocol:</h3>
                                          <div className='content-sec-ul'>

                                            <ul>
                                              <li>Step 1 : Completion of a full day of normal cognitive activities (school day, studying for tests, watching practice, interacting with peers) without reemergence of any signs or symptoms. If no return of symptoms, next day advance.</li>
                                              <li>Step 2 : Light Aerobic exercise, which includes walking, swimming, and stationary cycling, keeping the intensity below 70% maximum heart rate. No resistance training. The objective of this step is increased heart rate.</li>
                                              <li>Step 3 : Sport-specific exercise including skating, and/or running: no head impact activities. The objective of this step is to add movement.</li>
                                              <li>Step 4 : Non contact training drills (e.g. passing drills). Student-athlete may initiate resistance training</li>
                                              <li>Step 5 : Following medical clearance (consultation between school health care personnel and student athlete's physician), participation in normal training activities. The objective of this step is to restore confidence and assess functional skills by coaching and medical staff.</li>
                                              <li>Step 6 : Return to play involving normal exertion or game activity.</li>

                                            </ul>
                                            <p className='fur-sec'>For further information on Sports-Related Concussions and other Head Injuries, Please visit: </p>
                                            <p className='link-sec'><a href="https://www.cdc.gov/concussion/sports/index.html" target="_blank" >www.cdc.gov/concussion/sports/index.html</a></p>
                                            <p className='link-sec'><a href="https://www.nfhs.com/" target="_blank" >www.nfhs.com</a></p>
                                            <p className='link-sec'><a href="https://www.ncaa.org/sports/health-safety" target="_blank" >www.ncaa.org/health-safety</a></p>
                                            <p className='link-sec'><a href="https://www.bianj.org/" target="_blank" >www.bianj.org </a></p>
                                            <p className='link-sec'><a href="https://atsnj.org/" target="_blank" >www.atsnj.org</a></p>

                                          </div>
                                          <div className='row sign-top-mrn'>
                                            <div className='col-md-4'>
                                              <div class="sign-secs">


                                                <input class="text-input-sign cusrive-font-sec" type="text" id="fname" placeholder="" value={sixformInfo.athlete_signature} onChange={handleChangeSix}
                                                  name="athlete_signature" />
                                                <p>Signature of Student-Athlete  </p>
                                                <p className='error-msg-frm error-msg-frm-top'>
                                                  <span>
                                                    {sixformInfo.athlete_signature_error == true ? 'Please enter signature of student-athlete!' : ''}
                                                  </span>
                                                </p>

                                              </div>
                                            </div>
                                            <div className='col-md-4'>
                                              <div class="sign-secs new-nocur-spac">


                                                <input class="text-input-sign " type="text" id="fname" placeholder="" value={sixformInfo.athlete_name} onChange={handleChangeSix}
                                                  name="athlete_name"  />
                                                <p>Print Student-Athlete's Name   </p>
                                                <p className='error-msg-frm error-msg-frm-top'>
                                                  <span>
                                                  {sixformInfo.athlete_name_error == true ? 'Please enter print student-athlete name!' : ''}
                                                  </span>
                                                </p>

                                              </div>
                                            </div>

                                            {/* <div className='col-md-4'>
                                              <div class="sign-secs">


                                                <input class="text-input-sign" type="text" value={sixformInfo.athlete_name} onChange={handleChangeSix}
                                                  name="athlete_name" id="fname" placeholder="" />
                                                <p>Print Student-Athlete's Name  </p>
                                                <p className='error-msg-frm error-msg-frm-top'>
                                                  <span>
                                                    {sixformInfo.athlete_name_error == true ? 'Please enter print student-athlete name!' : ''}
                                                  </span>
                                                </p>
                                              </div>
                                            </div> */}
                                            <div className='col-md-3'>
                                              <div className='form-date-sec form-date-nbw'>
                                                <label >Date </label>

                                                <div className='sign-sec'>

                                                  <p className='colon-sec'>:</p>
                                                  <p style={{ fontWeight: '400', marginLeft: '9px', paddingTop: '7px' }}>{formDate}</p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>








                                          <div className='row'>
                                            <div className='col-md-4'>
                                              <div class="sign-secs">


                                                <input class="text-input-sign cusrive-font-sec" type="text" id="fname" placeholder=""
                                                  value={sixformInfo.parent_signature} onChange={handleChangeSix}
                                                  name="parent_signature" />
                                                <p>Signature of Parent/Guardian  </p>
                                                <p className='error-msg-frm error-msg-frm-top'>
                                                  <span>
                                                    {sixformInfo.parent_signature_error == true ? 'Please enter signature of parent/guardian!' : ''}
                                                  </span>
                                                </p>
                                              </div>
                                            </div>

                                            <div className='col-md-4'>
                                              <div class="sign-secs new-nocur-spac">


                                                <input class="text-input-sign " type="text" id="fname" placeholder=""
                                                  
                                                  value={sixformInfo.parent_name} onChange={handleChangeSix}
                                                  name="parent_name" />
                                                <p>Print Parent/Guardian's Name </p>
                                                <p className='error-msg-frm error-msg-frm-top'>
                                                  <span>
                                                  {sixformInfo.parent_name_error == true ? 'Please enter print parent/guardian name!' : ''}
                                                  </span>
                                                </p>
                                              </div>
                                            </div>

                                            {/* <div className='col-md-4'>
                                              <div class="sign-secs">


                                                <input class="text-input-sign" type="text"
                                                  value={sixformInfo.parent_name} onChange={handleChangeSix}
                                                  name="parent_name" id="fname" placeholder="" />
                                                <p>Print Parent/Guardian's Name  </p>
                                                <p className='error-msg-frm error-msg-frm-top'>
                                                  <span>
                                                    {sixformInfo.parent_name_error == true ? 'Please enter print parent/guardian name!' : ''}
                                                  </span>
                                                </p>
                                              </div>
                                            </div> */}

                                            <div className='col-md-3'>
                                              <div className='form-date-sec form-date-nbw'>
                                                <label >Date </label>

                                                <div className='sign-sec'>

                                                  <p className='colon-sec'>:</p>
                                                  <p style={{ fontWeight: '400', marginLeft: '9px', paddingTop: '7px' }}>{formDate}</p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      }

                                      <div className='row'>
                                        <div className='col-md-12'>
                                          <div class="login-submit login-submitss login-toltip">
                                            {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 6) == true) ?

                                              <>

                                                {(pdfExists(allstudentlisdata, userData.stuid + '_1_acknowledgement_form.pdf') == true)

                                                  ?

                                                  <>

                                                    <button class="btn btn-login btn-submit bt-forms bt-fill-newfrms btn-edits"
                                                      onClick={(e) => handleOpenLogacc(6)}
                                                    >EDIT</button>
                                                    {/*<a title="Download"
                                                    
                                                  
                                                   
                                                    onClick={(e) => handleDownloadFile(userData.stuid,6,userData.stuid + '_1_acknowledgement_form.pdf')}

                                                    
                                            target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>*/}
                                                    <Timer
                                                      startDateTime={getFormData(6).created_at}
                                                      downloadFile={(userData.stuid + "_1_acknowledgement_form.pdf")}
                                                      stuid={userData.stuid}
                                                      formId={6}
                                                      handleDownloadFile={handleDownloadFile}
                                                      handleTimerComplete={handleTimerComplete}
                                                      handleReqFormDownload={handleReqFormDownload}
                                                    />


                                                  </>

                                                  :
                                                  <>
                                                    {/*<a title="Download"
                                                    
                                                     onClick={(e) => handleDownloadFile(userData.stuid,6,userData.stuid + '_2_acknowledgement_form.pdf')}

                                          target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>*/}
                                                    <Timer
                                                      startDateTime={getFormData(6).created_at}
                                                      downloadFile={(userData.stuid + "_2_acknowledgement_form.pdf")}
                                                      stuid={userData.stuid}
                                                      formId={6}
                                                      handleDownloadFile={handleDownloadFile}
                                                      handleTimerComplete={handleTimerComplete}
                                                      handleReqFormDownload={handleReqFormDownload}
                                                    />

                                                  </>

                                                }

                                              </>

                                              : <button class="btn btn-login btn-submit bt-forms" onClick={handleSubmitSix}>Submit
                                                {
                                                  parentLoaderSix != '' ?
                                                    <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                                                    : ''

                                                }
                                              </button>
                                            }

                                          </div>

                                          {
                                            successMsgSix != '' ? <div className="success-msg success-login form-success">
                                              <p className="success-msg success-login">{successMsgSix}</p>
                                            </div> : ''
                                          }


                                          {
                                            errorMsgSix != '' ? <div className="error-msg error-login form-error" >
                                              <p className="error-msg error-login">{errorMsgSix}</p>
                                            </div> : <div className="error-msg error-login" style={{ visibility: 'hidden' }} >
                                              <p className="error-msg error-login">Wrong credentials!</p>
                                            </div>
                                          }


                                        </div>
                                      </div>

                                    </div>

                                  </div>
                                </div>

                              </Typography>
                            </AccordionDetails>
                          </Accordion>

                        </div>


                        <div className='form-accor-sec color-form-occur'>
                          <Accordion expanded={expandednew === 'panel7f'} onChange={handleChangenew('panel7f')}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel3-content"
                              id="panel3-header"
                            >
                              <Typography sx={{ width: '80%', flexShrink: 0 }}>SUDDEN CARDIAC DEATH PAMPHLET SIGN-OFF SHEET</Typography>
                              <Typography className="green-dwn" sx={{ flexShrink: 0, color: 'text.secondary', float: 'right', width: '20%', textAlign: 'right', color: '#008430', fontWeight: '600' }} >
                                {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 7) == true) ?

                                  'Completed' : <span className='pebdingarmh'>Pending</span>}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>

                                <div className='form-main-sec cardic-sec'>
                                  <div className='date-form acknw-cont-sec'>
                                    {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 7) == true) ?

                                      '' : <>
                                        <div className='row'>
                                          <div className='col-md-2'>
                                            <div className='heading-logo'>
                                              <img src={newlogos} />
                                            </div>
                                          </div>
                                          <div className='col-md-8'>
                                            <div className='heading-form-para'>
                                              <h1>State of New Jersey</h1>
                                              <h1 style={{ marginTop: '10px', marginBottom: '20px' }}> DEPARTMENT OF EDUCATION </h1>
                                              <h2>SUDDEN CARDIAC DEATH PAMPHLET
                                                SIGN-OFF SHEET
                                              </h2>


                                            </div>
                                          </div>

                                        </div>

                                        <div className='row'>
                                          <div className='col-md-5'>
                                            <div class="std-form-inner">
                                              <label>Name of School District</label>
                                              <input class="new-border" type="text" id="fname"
                                                value={sevenformInfo.school_district} onChange={handleChangeSeven}
                                                name="school_district" placeholder="" />
                                              <p className='error-msg-frm '>
                                                <span>
                                                  {sevenformInfo.school_district_error == true ? 'Please enter Name of school district!' : ''}
                                                </span>
                                              </p>
                                            </div>
                                          </div>

                                          <div className='col-md-5'>
                                            <div class="std-form-inner">
                                              <label>Name of Local School</label>
                                              <input class="new-border" type="text" id="fname" value={userData.school_name} placeholder="" /></div>
                                          </div>


                                        </div>

                                        <div className="row">
                                          <div className='col-md-12'>
                                            <p className='acknow-sec'> I/We acknowledge that we received and reviewed the Sudden Cardiac Death in Young Athletes pamphlet.</p>
                                          </div>
                                        </div>



                                        <div className='row'>
                                          <div className='col-md-4'>
                                            <div class="sign-secs">


                                              <input class="text-input-sign cusrive-font-sec" type="text"
                                                value={sevenformInfo.athlete_signature} onChange={handleChangeSeven}
                                                name="athlete_signature" id="fname" placeholder="" />
                                              <p>Student Signature  </p>
                                              <p className='error-msg-frm error-msg-frm-top'>
                                                <span>
                                                  {sevenformInfo.athlete_signature_error == true ? 'Please enter student signature!' : ''}
                                                </span>
                                              </p>
                                            </div>
                                          </div>

                                          <div className='col-md-4'>
                                            <div class="sign-secs">


                                              <input class="text-input-sign cusrive-font-sec" type="text" id="fname"
                                                value={sevenformInfo.parent_signature} onChange={handleChangeSeven}
                                                name="parent_signature" placeholder="" />
                                              <p>Parent or Guardian's Signature  </p>
                                              <p className='error-msg-frm error-msg-frm-top'>
                                                <span>
                                                  {sevenformInfo.parent_signature_error == true ? 'Please enter parent/guardian signature!' : ''}
                                                </span>
                                              </p>

                                            </div>
                                          </div>

                                          <div className='col-md-2'>
                                            <div className='form-date-sec form-date-nbw'>
                                              <label >Date </label>

                                              <div className='sign-sec'>

                                                <p className='colon-sec'>:</p>
                                                <p style={{ fontWeight: '400', marginLeft: '9px', paddingTop: '7px' }}>{formDate}</p>
                                              </div>

                                            </div>
                                          </div>
                                        </div>
                                      </>}
                                    <div className='row'>
                                      <div className='col-md-12'>
                                        <div class="login-submit login-submitss login-toltip">
                                          {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 7) == true) ?

                                            <>

                                              {(pdfExists(allstudentlisdata, userData.stuid + '_1_sudden_cardiac_death_pamphlet_sign_off_sheet.pdf') == true)

                                                ?

                                                <>

                                                  <button class="btn btn-login btn-submit bt-forms bt-fill-newfrms btn-edits"
                                                    onClick={(e) => handleOpenLogacc(7)}
                                                  >EDIT</button>
                                                  {/*<a title="Download"
                                                
                                                   
                                                   onClick={(e) => handleDownloadFile(userData.stuid,7,userData.stuid + '_1_sudden_cardiac_death_pamphlet_sign_off_sheet.pdf')}

                                          target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>*/}
                                                  <Timer
                                                    startDateTime={getFormData(7).created_at}
                                                    downloadFile={(userData.stuid + "_1_sudden_cardiac_death_pamphlet_sign_off_sheet.pdf")}
                                                    stuid={userData.stuid}
                                                    formId={7}
                                                    handleDownloadFile={handleDownloadFile}
                                                    handleTimerComplete={handleTimerComplete}
                                                    handleReqFormDownload={handleReqFormDownload}
                                                  />


                                                </>

                                                :
                                                <>
                                                  {/*<a title="Download"
                                                   
                                                   
                                                                              
                                                   onClick={(e) => handleDownloadFile(userData.stuid,7,userData.stuid + '_2_sudden_cardiac_death_pamphlet_sign_off_sheet.pdf')}

                                        target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>*/}
                                                  <Timer
                                                    startDateTime={getFormData(7).created_at}
                                                    downloadFile={(userData.stuid + "_2_sudden_cardiac_death_pamphlet_sign_off_sheet.pdf")}
                                                    stuid={userData.stuid}
                                                    formId={7}
                                                    handleDownloadFile={handleDownloadFile}
                                                    handleTimerComplete={handleTimerComplete}
                                                    handleReqFormDownload={handleReqFormDownload}
                                                  />


                                                </>

                                              }

                                            </>

                                            : <button class="btn btn-login btn-submit bt-forms" onClick={handleSubmitSeven}>Submit
                                              {
                                                parentLoaderSeven != '' ?
                                                  <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                                                  : ''

                                              }
                                            </button>
                                          }
                                          <a class="btn btn-cancel btn-login btn-down btn-fact" title="Download" href='../../Sudden_Cardiac_Death_Pamphlet_Sign_off_Factsheet.pdf' download><PictureAsPdfIcon /> Fact Sheet Download</a>
                                        </div>

                                        {
                                          successMsgSeven != '' ? <div className="success-msg success-login form-success">
                                            <p className="success-msg success-login">{successMsgSeven}</p>
                                          </div> : ''
                                        }


                                        {
                                          errorMsgSeven != '' ? <div className="error-msg error-login form-error" >
                                            <p className="error-msg error-login">{errorMsgSeven}</p>
                                          </div> : <div className="error-msg error-login" style={{ visibility: 'hidden' }} >
                                            <p className="error-msg error-login">Wrong credentials!</p>
                                          </div>
                                        }
                                      </div>
                                    </div>

                                  </div>
                                </div>

                              </Typography>
                            </AccordionDetails>
                          </Accordion>

                        </div>

                        <div className='form-accor-sec color-form-occur'>
                          <Accordion expanded={expandednew === 'panel8f'} onChange={handleChangenew('panel8f')}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel3-content"
                              id="panel3-header"
                            >
                              <Typography sx={{ width: '80%', flexShrink: 0 }}>USE AND MISUSE OF OPIOID DRUGS FACT SHEET</Typography>
                              <Typography className="green-dwn" sx={{ flexShrink: 0, color: 'text.secondary', float: 'right', width: '20%', textAlign: 'right', color: '#008430', fontWeight: '600' }} >
                                {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 8) == true) ?

                                  'Completed' : <span className='pebdingarmh'>Pending</span>}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <div className='form-main-sec cardic-sec'>
                                  <div className='date-form acknw-cont-sec'>
                                    {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 8) == true) ?

                                      '' : <>
                                        <div className='row'>
                                          <div className='col-md-3'>
                                            <div className='heading-logo'>
                                              <img src={newlogos} />
                                            </div>
                                          </div>
                                          <div className='col-md-6'>
                                            <div className='heading-form-para'>
                                              <h1>THE JERSEY CITY PUBLIC SCHOOLS </h1>
                                              <img src={athleimg} />
                                              <h2>ATHLETICS</h2>


                                            </div>
                                          </div>
                                          <div className='col-md-3'>
                                            <div className='right-head'>

                                              <p style={{ marginBottom: '6px' }}>346 CLAREMONT AVENUE </p>
                                              <p className='right-head-top'>JERSEY CITY, NEW JERSEY 07305</p>
                                              <p className='right-head-top'>(201) 915-6279</p>
                                              <p className='right-head-top'> (201) 938-1142 - Fax</p>

                                            </div>
                                          </div>
                                        </div>
                                        <div className='row'>
                                          <div className='col-md-12'>
                                            <div className='drug-head-sec'>
                                              <h2 style={{ textAlign: 'left', marginBottom: '12px' }}>USE AND MISUSE OF OPIOID DRUGS FACT SHEET</h2>
                                              <p style={{ textAlign: 'left' }}>Student-Athlete and Parent/Guardian Sign-Off</p>
                                            </div>
                                          </div>
                                        </div>
                                        <div className='row'>
                                          <div className='col-md-12'>
                                            <div className='drug-head-inner-sec'>
                                              <p>In accordance with N.J.S.A. 18A:40-41.10, public school districts, approved private schools for students with disabilities, and
                                                nonpublic schools participating in an interscholastic sports program must distribute <span style={{ textDecoration: 'underline' }}>this_Opioid Use and Misuse Educational Fact
                                                  Sheet</span> to all student-athletes and cheerleaders. In addition, schools and districts must obtain a signed acknowledgement of receipt
                                                of the fact sheet from each student-athlete and cheerleader, and for students under age 18, the parent or guardian must also sign.</p>
                                              <p className='drug-para-btm'>This sign-off sheet is due to the appropriate school personnel as determined by your district prior to the first official practice session of the spring 2018 athletic season
                                                (March 2, 2018, as determined by the New Jersey State Interscholastic Athletic Association)
                                                and annually thereafter prior to the student-athlete's or cheerleader's first official practice of the school year.</p>

                                            </div>
                                          </div>
                                        </div>



                                        <div className='row'>
                                          <div className='col-md-5'>
                                            <div class="std-form-inner">
                                              <label>Name of School</label>
                                              <input class="new-border" type="text" id="fname"
                                                value={userData.school_name} placeholder="" /></div>
                                          </div>

                                          <div className='col-md-5'>
                                            <div class="std-form-inner">
                                              <label>Name of School District (if applicable)</label>
                                              <input class="new-border" type="text" id="fname"
                                                value={eightformInfo.school_district} onChange={handleChangeEight}
                                                name="school_district" placeholder="" />
                                              <p className='error-msg-frm'>
                                                <span>
                                                  {eightformInfo.school_district_error == true ? 'Please enter name of school district !' : ''}
                                                </span>
                                              </p>
                                            </div>
                                          </div>


                                        </div>

                                        <div className="row">
                                          <div className='col-md-12'>
                                            <p className='acknow-sec'> I/We acknowledge that we received and reviewed the Educational Fact Sheet on the Use and Misuse of Opioid Drugs.</p>
                                          </div>
                                        </div>




                                        <div className='row'>
                                          <div className='col-md-4'>
                                            <div class="sign-secs">


                                              <input class="text-input-sign cusrive-font-sec" type="text"
                                                value={eightformInfo.athlete_signature} onChange={handleChangeEight}
                                                name="athlete_signature" id="fname" placeholder="" />
                                              <p>Student Signature  </p>
                                              <p className='error-msg-frm error-msg-frm-top'>
                                                <span>
                                                  {eightformInfo.athlete_signature_error == true ? 'Please enter student signature!' : ''}
                                                </span>
                                              </p>
                                            </div>

                                          </div>

                                          <div className='col-md-4'>
                                            <div class="sign-secs">


                                              <input class="text-input-sign cusrive-font-sec" type="text" id="fname"
                                                value={eightformInfo.parent_signature} onChange={handleChangeEight}
                                                name="parent_signature" placeholder="" />
                                              <p>Parent/Guardian Signature <br></br>(also needed if student is under age 18)  </p>
                                              <p className='error-msg-frm error-msg-frm-top'>
                                                <span>
                                                  {eightformInfo.parent_signature_error == true ? 'Please enter parent/guardian signature!' : ''}
                                                </span>
                                              </p>
                                            </div>
                                          </div>

                                          <div className='col-md-2'>
                                            <div className='form-date-sec form-date-nbw'>
                                              <label >Date </label>

                                              <div className='sign-sec'>

                                                <p className='colon-sec'>:</p>
                                                <p style={{ fontWeight: '400', marginLeft: '9px', paddingTop: '7px' }}>{formDate}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                      </>}


                                    <div className='row'>
                                      <div className='col-md-12'>
                                        <div class="login-submit login-submitss login-toltip">
                                          {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 8) == true) ?

                                            <>

                                              {(pdfExists(allstudentlisdata, userData.stuid + '_1_use_and_misuse_of_opioid_drugs_fact_sheet.pdf') == true)

                                                ?

                                                <>

                                                  <button class="btn btn-login btn-submit bt-forms bt-fill-newfrms btn-edits"
                                                    onClick={(e) => handleOpenLogacc(8)}
                                                  >EDIT</button>
                                                  {/*<a title="Download" 
                                                  
                                                  onClick={(e) => handleDownloadFile(userData.stuid,8,userData.stuid + '_1_use_and_misuse_of_opioid_drugs_fact_sheet.pdf')}

                                                  
                                          target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>*/}
                                                  <Timer
                                                    startDateTime={getFormData(8).created_at}
                                                    downloadFile={(userData.stuid + "_1_use_and_misuse_of_opioid_drugs_fact_sheet.pdf")}
                                                    stuid={userData.stuid}
                                                    formId={8}
                                                    handleDownloadFile={handleDownloadFile}
                                                    handleTimerComplete={handleTimerComplete}
                                                    handleReqFormDownload={handleReqFormDownload}
                                                  />


                                                </>

                                                :
                                                <>
                                                  {/*<a title="Download" 
                                                 
                                                  onClick={(e) => handleDownloadFile(userData.stuid,8,userData.stuid + '_2_use_and_misuse_of_opioid_drugs_fact_sheet.pdf')}

                                                  
                                                  
                                        target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>*/}
                                                  <Timer
                                                    startDateTime={getFormData(8).created_at}
                                                    downloadFile={(userData.stuid + "_2_use_and_misuse_of_opioid_drugs_fact_sheet.pdf")}
                                                    stuid={userData.stuid}
                                                    formId={8}
                                                    handleDownloadFile={handleDownloadFile}
                                                    handleTimerComplete={handleTimerComplete}
                                                    handleReqFormDownload={handleReqFormDownload}
                                                  />

                                                </>

                                              }

                                            </>

                                            : <button class="btn btn-login btn-submit bt-forms" onClick={handleSubmitEight}>Submit
                                              {
                                                parentLoaderEight != '' ?
                                                  <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                                                  : ''

                                              }
                                            </button>
                                          }
                                          <a title="Download" href='../../Opiod_Use_Misuse_Factsheet.pdf' download class="btn btn-cancel btn-login btn-down btn-fact"><PictureAsPdfIcon /> Fact Sheet Download</a>
                                        </div>
                                        {
                                          successMsgEight != '' ? <div className="success-msg success-login form-success">
                                            <p className="success-msg success-login">{successMsgEight}</p>
                                          </div> : ''
                                        }


                                        {
                                          errorMsgEight != '' ? <div className="error-msg error-login form-error" >
                                            <p className="error-msg error-login">{errorMsgEight}</p>
                                          </div> : <div className="error-msg error-login form-error" style={{ visibility: 'hidden' }} >
                                            <p className="error-msg error-login">Wrong credentials!</p>
                                          </div>
                                        }

                                      </div>
                                    </div>





                                  </div>
                                </div>

                              </Typography>
                            </AccordionDetails>
                          </Accordion>

                        </div>

                        <div className='form-accor-sec color-form-occur'>
                          <Accordion expanded={expandednew === 'panel9f'} onChange={handleChangenew('panel9f')}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel3-content"
                              id="panel3-header"
                            >
                              <Typography sx={{ width: '80%', flexShrink: 0 }}>NJSIAA OPIOID POLICY ACKNOWLEDGEMENT</Typography>
                              <Typography className="green-dwn" sx={{ flexShrink: 0, color: 'text.secondary', float: 'right', width: '20%', textAlign: 'right', color: '#008430', fontWeight: '600' }} >

                                {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 9) == true) ?

                                  'Completed' : <span className='pebdingarmh'>Pending</span>}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <div className='form-main-sec cardic-sec'>
                                  <div className='date-form acknw-cont-sec'>


                                    {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 9) == true) ?

                                      '' : <>



                                        <div className='row'>
                                          <div className='col-md-2'>
                                            <div className='heading-logo'>
                                              <img src={newlogos} />
                                            </div>
                                          </div>
                                          <div className='col-md-8'>
                                            <div className='heading-form-para'>
                                              <h1>NEW JERSEY STATE INTERSCHOLASTIC ATHLETIC ASSOCIATION </h1>
                                              <h2 style={{ marginBottom: '0px', fontWeight: '500', fontSize: '18px' }}>1161 Route 130 North, Robbinsville, NJ 08691</h2>
                                              <h2 style={{ marginTop: '9px', fontWeight: '500', fontSize: '18px' }}>Phone 609-259-2776 ~ Fax 609-259-3047</h2>


                                            </div>
                                          </div>
                                          {/* <div className='col-md-3'>
                                    <div className='right-head'>
                                        
                                    <p></p>     
                                    </div>
                                </div> */}
                                        </div>

                                        <div className='row'>
                                          <div className='col-md-12'>
                                            <div className='njsiaa-head-sec'>
                                              <h2>Memorandum</h2>
                                            </div>
                                          </div>
                                        </div>

                                        <div className='row'>
                                          <div className='col-md-12'>
                                            <div className='njsiaa-head-secss'>
                                              <div className='njsia-main-sec'>
                                                <div className='njsia-left'>
                                                  <p>To:</p>
                                                </div>
                                                <div className='njsia-right'>
                                                  <p>All Athletic Directors of Member Schools</p>
                                                </div>
                                              </div>
                                            </div>

                                            <div className='njsiaa-head-secss'>
                                              <div className='njsia-main-sec'>
                                                <div className='njsia-left'>
                                                  <p>From:</p>
                                                </div>
                                                <div className='njsia-right'>
                                                  <p>Tony Maselli, Assistant Director</p>
                                                </div>
                                              </div>
                                            </div>

                                            <div className='njsiaa-head-secss'>
                                              <div className='njsia-main-sec'>
                                                <div className='njsia-left'>
                                                  <p>Date:</p>
                                                </div>
                                                <div className='njsia-right'>
                                                  <p>June 2019</p>
                                                </div>
                                              </div>
                                            </div>

                                            <div className='njsiaa-head-secss'>
                                              <div className='njsia-main-sec'>
                                                <div className='njsia-left'>
                                                  <p>Re:</p>
                                                </div>
                                                <div className='njsia-right'>
                                                  <p>Opioid Education Video Procedure</p>
                                                </div>
                                              </div>
                                            </div>



                                          </div>
                                        </div>


                                        <div className='row'>
                                          <div className='col-md-12'>
                                            <div className='njsiaa-content-sec'>
                                              <p>To All Athletic Directors:</p>
                                              <p>Acting to address the increased risk of opioid abuse among high school athletes, the Office of the New Jersey Coordinator for Addiction Responses
                                                and Enforcement Strategies (NJCARES) and the New Jersey State Interscholastic Athletic Association (NJSIAA) announced on February 19, 2019,
                                                a new partnership to educate student athletes and their parents/guardians on addiction risks associated with sports injuries and opioid use.
                                              </p>
                                              <p>This educational initiative, spearheaded by Attorney General Gurbir Grewal and approved by the Executive Committee of the NJSIAA,
                                                is a collaborative effort to use video programming to raise awareness among high school athletes that they face a higher risk
                                                of becoming addicted to prescription pain medication than their fellow students who do not play sports
                                              </p>
                                              <p>
                                                Beginning with the 2019 fall season, we are making available to all student athletes and their parents/guardians,
                                                an educational video about the risks of opioid use as it relates to student athletes. The video will be available on August 1,
                                                2019 and can be found on the NJSIAA website under "Athlete Wellness" which is located under the "Health & Safety tab. We are
                                                strongly encouraging student athletes and parents/guardians to watch the video as soon as it becomes available. An acknowledgement
                                                that students and their parents/guardians have watched the video will be required starting with the 2019-2020 winter season.
                                              </p>

                                              <p>
                                                All member schools are asked to add to their current athletic consent forms the sign-off listed below. The sign-off acknowledgment
                                                is an NJSIAA mandate; student athletes are required to view the video only once per school year prior to the first official practice
                                                of the season in their respective sport, but the signed acknowledgment is required for each sport a student participates in. Athletes
                                                that are 18 years or older do not need the parents/guardians to watch the video.
                                              </p>

                                              <p>Opioid Video is located at: <a href="https://youtu.be/3Rz6rkwpAx8" target="_blank">https://youtu.be/3Rz6rkwpAx8</a></p>
                                            </div>
                                          </div>
                                        </div>
                                        <div className='row'>
                                          <div className='col-md-12'>
                                            <div className='njsiaa-acknow-sec'>
                                              <h2>NJSIAA OPIOID POLICY ACKNOWLEDGEMENT</h2>
                                              <p>We have viewed the NJ CARES educational video on the risks of opioid use for high school athletes. We understand the NJSIAA policy that requires students,
                                                and their parents(s)/guardian(s) if a student is under the age of 18, to view this video and sign this acknowledgement.
                                              </p>
                                            </div>
                                          </div>
                                        </div>



                                        <div className='row'>
                                          <div className='col-md-4'>
                                            <div class="sign-secs">


                                              <input class="text-input-sign cusrive-font-sec" type="text" id="fname"
                                                value={nineformInfo.athlete_signature} onChange={handleChangeNine}
                                                name="athlete_signature" placeholder="" />
                                              <p>Student's Signature  </p>
                                              <p className='error-msg-frm error-msg-frm-top'>
                                                <span>
                                                  {nineformInfo.athlete_signature_error == true ? 'Please enter signature of student!' : ''}
                                                </span>
                                              </p>
                                            </div>
                                          </div>



                                          <div className='col-md-2'>
                                            <div className='form-date-sec form-date-nbw'>
                                              <label >Date</label>

                                              <div className='sign-sec'>

                                                <p className='colon-sec'>:</p>
                                                <p style={{ fontWeight: '400', marginLeft: '9px', paddingTop: '7px' }}>{formDate}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className='row'>
                                          <div className='col-md-4'>
                                            <div class="sign-secs">


                                              <input class="text-input-sign cusrive-font-sec" type="text" id="fname"
                                                value={nineformInfo.parent_signature} onChange={handleChangeNine}
                                                name="parent_signature" placeholder="" />
                                              <p>Parent/Guardian Signature  </p>
                                              <p className='error-msg-frm error-msg-frm-top'>
                                                <span>
                                                  {nineformInfo.parent_signature_error == true ? 'Please enter signature of parent/guardian!' : ''}
                                                </span>
                                              </p>
                                            </div>
                                          </div>



                                          <div className='col-md-2'>
                                            <div className='form-date-sec form-date-nbw'>

                                              <label >Date</label>

                                              <div className='sign-sec'>

                                                <p className='colon-sec'>:</p>
                                                <p style={{ fontWeight: '400', marginLeft: '9px', paddingTop: '7px' }}>{formDate}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    }
                                    <div className='row'>
                                      <div className='col-md-12'>
                                        <div class="login-submit login-submitss login-toltip">
                                          {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 9) == true) ?
                                            <>

                                              {(pdfExists(allstudentlisdata, userData.stuid + '_1_njsiaa_opioid_policy_acknowledgement.pdf') == true)

                                                ?

                                                <>

                                                  <button class="btn btn-login btn-submit bt-forms bt-fill-newfrms btn-edits"
                                                    onClick={(e) => handleOpenLogacc(9)}
                                                  >EDIT</button>
                                                  {/*<a title="Download"
                                                   
                                                   onClick={(e) => handleDownloadFile(userData.stuid,9,userData.stuid + '_1_njsiaa_opioid_policy_acknowledgement.pdf')}

                                                   
                                          target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>*/}
                                                  <Timer
                                                    startDateTime={getFormData(9).created_at}
                                                    downloadFile={(userData.stuid + "_1_njsiaa_opioid_policy_acknowledgement.pdf")}
                                                    stuid={userData.stuid}
                                                    formId={9}
                                                    handleDownloadFile={handleDownloadFile}
                                                    handleTimerComplete={handleTimerComplete}
                                                    handleReqFormDownload={handleReqFormDownload}
                                                  />


                                                </>

                                                :
                                                <>
                                                  {/*<a title="Download"
                                               
                                                   onClick={(e) => handleDownloadFile(userData.stuid,9,userData.stuid + '_2_njsiaa_opioid_policy_acknowledgement.pdf')}

                                        target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>*/}
                                                  <Timer
                                                    startDateTime={getFormData(9).created_at}
                                                    downloadFile={(userData.stuid + "_2_njsiaa_opioid_policy_acknowledgement.pdf")}
                                                    stuid={userData.stuid}
                                                    formId={9}
                                                    handleDownloadFile={handleDownloadFile}
                                                    handleTimerComplete={handleTimerComplete}
                                                    handleReqFormDownload={handleReqFormDownload}
                                                  />

                                                </>

                                              }

                                            </>

                                            : <button class="btn btn-login btn-submit bt-forms" onClick={handleSubmitNine}>Submit
                                              {
                                                parentLoaderNine != '' ?
                                                  <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                                                  : ''

                                              }
                                            </button>
                                          }
                                        </div>

                                        {
                                          successMsgNine != '' ? <div className="success-msg success-login form-success">
                                            <p className="success-msg success-login">{successMsgNine}</p>
                                          </div> : ''
                                        }


                                        {
                                          errorMsgNine != '' ? <div className="error-msg error-login form-error" >
                                            <p className="error-msg error-login">{errorMsgNine}</p>
                                          </div> : <div className="error-msg error-login form-error" style={{ visibility: 'hidden' }} >
                                            <p className="error-msg error-login">Wrong credentials!</p>
                                          </div>
                                        }


                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </Typography>
                            </AccordionDetails>
                          </Accordion>

                        </div>

                        <div className='form-accor-sec color-form-occur'>
                          <Accordion expanded={expandednew === 'panel10f'} onChange={handleChangenew('panel10f')}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel3-content"
                              id="panel3-header"
                            >
                              <Typography sx={{ width: '70%', flexShrink: 0 }}>NJSIAA STEROID TESTING POLICY CONSENT TO RANDOM TESTING</Typography>
                              <Typography sx={{ width: '30%', flexShrink: 0 }} className="green-dwn" sx={{ color: 'text.secondary', float: 'right', width: '100%', textAlign: 'right', color: '#008430', fontWeight: '600' }} >
                                {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 10) == true) ?

                                  'Completed' : <span className='pebdingarmh'>Pending</span>}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <div className='form-main-sec cardic-sec'>
                                  <div className='date-form acknw-cont-sec'>


                                    {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 10) == true) ?

                                      '' : <>
                                        <div className='row'>
                                          <div className='col-md-2'>
                                            <div className='heading-logo'>
                                              <img src={newlogos} />
                                            </div>
                                          </div>
                                          <div className='col-md-8'>
                                            <div className='heading-form-para'>
                                              <h1>NJSIAA STEROID TESTING POLICY CONSENT TO RANDOM TESTING</h1>



                                            </div>
                                          </div>

                                        </div>

                                        <div className='row'>
                                          <div className='col-md-12'>
                                            <div className='random-test'>
                                              <p>In Executive Order 72, issued December 20, 2005, Governor Richard Codey
                                                directed the New Jersey Department of Education to work in conjunction with the New Jersey State Interscholastic
                                                Athletic Association (NJSIAA) to develop and implement a program of random testing for steroids, of teams and
                                                individuals qualifying for championship games.
                                              </p>
                                              <p>
                                                Beginning in the Fall, 2006 sports season, any student-athlete who possesses, distributes, ingests or otherwise
                                                uses any of the banned substances on the attached page, without written prescription by a fully-licensed physician,
                                                as recognized by the American Medical Association, to treat a medical condition, violates the NJSIAA's sportsmanship rule,
                                                and is subject to NJSIAA penalties, including ineligibility from competition. The NJSIAA will test certain randomly selected
                                                individuals and teams that qualify for a state championship tournament or state championship competition for banned substances.
                                                The results of all tests shall be considered confidential and shall only be disclosed to the student, his or her parents and his or her school.
                                                No student may participate in NJSIAA competition unless the student and the student's parent/guardian consent to random testing.
                                              </p>
                                              <p>
                                                By signing below, we consent to random testing in accordance with the NJSIAA steroid testing policy.
                                                We understand that, if the student or the student's team qualifies for a state championship tournament
                                                or state championship competition, the student may be subject to testing for banned substances.
                                              </p>
                                            </div>
                                          </div>
                                        </div>



                                        <div className='row'>
                                          <div className='col-md-4'>
                                            <div class="sign-secs">


                                              <input class="text-input-sign cusrive-font-sec" type="text" id="fname"
                                                value={tenformInfo.athlete_signature} onChange={handleChangeTen}
                                                name="athlete_signature" placeholder="" />
                                              <p>Signature of Student-Athlete  </p>
                                              <p className='error-msg-frm error-msg-frm-top'>
                                                <span>
                                                  {tenformInfo.athlete_signature_error == true ? 'Please enter signature of student-athlete!' : ''}
                                                </span>
                                              </p>
                                            </div>
                                          </div>

                                          <div className='col-md-4'>
                                            <div class="sign-secs new-nocur-spac">


                                              <input class="text-input-sign " type="text" id="fname"
                                              value={tenformInfo.athlete_name} onChange={handleChangeTen}
                                              name="athlete_name" placeholder="" />
                                              <p>Print Student-Athlete's Name   </p>
                                              <p className='error-msg-frm error-msg-frm-top'>
                                                <span>
                                                {tenformInfo.athlete_name_error == true ? 'Please enter print student-athlete name!' : ''}
                                                </span>
                                              </p>
                                            </div>
                                          </div>


                                          {/* <div className='col-md-4'>
                                            <div class="sign-secs">


                                              <input class="text-input-sign"
                                                value={tenformInfo.athlete_name} onChange={handleChangeTen}
                                                name="athlete_name" type="text" id="fname" placeholder="" />
                                              <p>Print Student-Athlete's Name  </p>
                                              <p className='error-msg-frm error-msg-frm-top'>
                                                <span>
                                                  {tenformInfo.athlete_name_error == true ? 'Please enter print student-athlete name!' : ''}
                                                </span>
                                              </p>
                                            </div>
                                          </div> */}

                                          <div className='col-md-2'>
                                            <div className='form-date-sec form-date-nbw'>
                                              <label >Date </label>

                                              <div className='sign-sec'>

                                                <p className='colon-sec'>:</p>
                                                <p style={{ fontWeight: '400', marginLeft: '9px', paddingTop: '7px' }}>{formDate}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>


                                        <div className='row'>
                                          <div className='col-md-4'>
                                            <div class="sign-secs">


                                              <input class="text-input-sign cusrive-font-sec" type="text" id="fname"
                                                value={tenformInfo.parent_signature} onChange={handleChangeTen}
                                                name="parent_signature"  placeholder=""  />
                                              <p>Signature of Parent/Guardian  </p>
                                              <p className='error-msg-frm error-msg-frm-top'>
                                                <span>
                                                  {tenformInfo.parent_signature_error == true ? 'Please enter signature of parent/guardian!' : ''}
                                                </span>
                                              </p>
                                            </div>
                                          </div>

                                          <div className='col-md-4'>
                                            <div class="sign-secs new-nocur-spac">


                                              <input class="text-input-sign " type="text" id="fname"
                                                  value={tenformInfo.parent_name} onChange={handleChangeTen}
                                                  name="parent_name" placeholder="" />
                                              <p>Print Parent/Guardian's Name   </p>
                                              <p className='error-msg-frm error-msg-frm-top'>
                                                <span>
                                                {tenformInfo.parent_name_error == true ? 'Please enter print parent/guardian name!' : ''}
                                                </span>
                                              </p>
                                            </div>
                                          </div>

                                          {/* <div className='col-md-4'>
                                            <div class="sign-secs">


                                              <input class="text-input-sign" type="text" id="fname"
                                                value={tenformInfo.parent_name} onChange={handleChangeTen}
                                                name="parent_name" placeholder="" />
                                              <p>Print Parent/Guardian's Name  </p>
                                              <p className='error-msg-frm error-msg-frm-top'>
                                                <span>
                                                  {tenformInfo.parent_name_error == true ? 'Please enter print parent/guardian name!' : ''}
                                                </span>
                                              </p>
                                            </div>
                                          </div> */}

                                          <div className='col-md-2'>
                                            <div className='form-date-sec form-date-nbw'>
                                              <label >Date</label>

                                              <div className='sign-sec'>

                                                <p className='colon-sec'>:</p>
                                                <p style={{ fontWeight: '400', marginLeft: '9px', paddingTop: '7px' }}>{formDate}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>


                                      </>}

                                    <div className='row'>
                                      <div className='col-md-12'>
                                        <div class="login-submit login-submitss login-toltip">
                                          {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 10) == true) ?
                                            <>

                                              {(pdfExists(allstudentlisdata, userData.stuid + '_1_njsiaa_steroid_testing_policy_consent_to_random_testing.pdf') == true)

                                                ?

                                                <>

                                                  <button class="btn btn-login btn-submit bt-forms bt-fill-newfrms btn-edits"
                                                    onClick={(e) => handleOpenLogacc(10)}
                                                  >EDIT</button>
                                                  {/*<a title="Download" 
                                               
                                                  onClick={(e) => handleDownloadFile(userData.stuid,10,userData.stuid + '_1_njsiaa_steroid_testing_policy_consent_to_random_testing.pdf')}

                                                  
                                          target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>*/}
                                                  <Timer
                                                    startDateTime={getFormData(10).created_at}
                                                    downloadFile={(userData.stuid + "_1_njsiaa_steroid_testing_policy_consent_to_random_testing.pdf")}
                                                    stuid={userData.stuid}
                                                    formId={10}
                                                    handleDownloadFile={handleDownloadFile}
                                                    handleTimerComplete={handleTimerComplete}
                                                    handleReqFormDownload={handleReqFormDownload}
                                                  />


                                                </>

                                                :
                                                <>
                                                  {/*<a title="Download" 
                                                    
                                                  onClick={(e) => handleDownloadFile(userData.stuid,10,userData.stuid + '_2_njsiaa_steroid_testing_policy_consent_to_random_testing.pdf')}

                                        target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>*/}
                                                  <Timer
                                                    startDateTime={getFormData(10).created_at}
                                                    downloadFile={(userData.stuid + "_2_njsiaa_steroid_testing_policy_consent_to_random_testing.pdf")}
                                                    stuid={userData.stuid}
                                                    formId={10}
                                                    handleDownloadFile={handleDownloadFile}
                                                    handleTimerComplete={handleTimerComplete}
                                                    handleReqFormDownload={handleReqFormDownload}
                                                  />

                                                </>

                                              }

                                            </>
                                            : <>

                                              <button class="btn btn-login btn-submit bt-forms" onClick={handleSubmitTen}>Submit
                                                {
                                                  parentLoaderTen != '' ?
                                                    <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                                                    : ''

                                                }
                                              </button>

                                            </>}
                                        </div>

                                        {
                                          successMsgTen != '' ? <div className="success-msg success-login form-success">
                                            <p className="success-msg success-login">{successMsgTen}</p>
                                          </div> : ''
                                        }


                                        {
                                          errorMsgTen != '' ? <div className="error-msg error-login form-error" >
                                            <p className="error-msg error-login">{errorMsgTen}</p>
                                          </div> : <div className="error-msg error-login form-error" style={{ visibility: 'hidden' }} >
                                            <p className="error-msg error-login">Wrong credentials!</p>
                                          </div>
                                        }
                                      </div>
                                    </div>

                                  </div>
                                </div>

                              </Typography>
                            </AccordionDetails>
                          </Accordion>

                        </div>

                        <div className='form-accor-sec  form-accor-secs color-form-occur'>
                          <Accordion expanded={expandednew === 'panel20f'} onChange={handleChangenew('panel20f')}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel3-content"
                              id="panel3-header" className='accor-expand-hide'
                            >
                              {/* <Typography>BANNED SUBSTANCES 2022-2023 FACT SHEET</Typography> */}
                              <Typography sx={{ width: '80%', flexShrink: 0 }}>BANNED SUBSTANCES 2022-2023 FACT SHEET</Typography>
                              <Typography className="green-dwn dnnnn" sx={{ flexShrink: 0, float: 'right', width: '20%', textAlign: 'right', color: '#008430', fontWeight: '600' }} >
                                <a title="Download" href='../../Banned_Substances_2022-2023_Fact_Sheet.pdf' download>Download <GetAppIcon /></a>
                              </Typography>
                            </AccordionSummary>

                          </Accordion>

                        </div>




                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2bh-content"
                      id="panel2bh-header"
                    >
                      <Typography sx={{ width: '33%', flexShrink: 0 }}>PHYSICIAN FORM</Typography>
                      {/* <Typography sx={{ color: 'text.secondary' }}>
                You are currently not an owner
            </Typography> */}
                      <Typography className="green-dwn" sx={{ fontSize: '15px', marginRight: '14px', color: 'text.secondary', float: 'left', width: '100%', textAlign: 'center', color: '#e98d05', fontWeight: '600', width: '33%', flexShrink: 0 }} >
                        3 Forms
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        {/* <div className='form-accor-sec color-form-occur'>
            <Accordion expanded={expandednew === 'panel18f'} onChange={handleChangenew('panel18f')}>
                    <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3-content"
                    id="panel3-header" className='accor-expand-hide'
                    >
                    <Typography sx={{ width: '33%', flexShrink: 0 }}>PHYSICAL EXAMINATION FORM</Typography>
          <Typography className="green-dwn" sx={{ color: 'text.secondary',float:'right',width:'100%',textAlign:'right',color:'#008430',fontWeight:'600' }} >
             <a href={Evaluation} download className='downsec-new'>Download <GetAppIcon /></a> 
          </Typography>
                    </AccordionSummary>
                    
                </Accordion>
             
          </div> */}

                        {/* <div className='form-accor-sec color-form-occur'>
            <Accordion expanded={expandednew === 'panel19f'} onChange={handleChangenew('panel19f')}>
                    <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3-content"
                    id="panel3-header"  className='accor-expand-hide'
                    >
                    <Typography sx={{ width: '33%', flexShrink: 0 }}>CLEARANCE FORM</Typography>
          <Typography className="green-dwn" sx={{ color: 'text.secondary',float:'right',width:'100%',textAlign:'right',color:'#008430',fontWeight:'600' }} >
 <a href={Physician} download className='downsec-new'>Download <GetAppIcon /></a> 
          </Typography>
                    </AccordionSummary>
                   
                </Accordion>
             
        </div> */}
                        <div className='form-accor-sec color-form-occur'>
                          <Accordion expanded={expandednew === 'panel19f'} onChange={handleChangenew('panel19f')}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel3-content"
                              id="panel3-header" className='accor-expand-hide'
                            >
                              <Typography sx={{ width: '70%', flexShrink: 0 }}>PEPARTICIPATION PHYSICAL EVALUATION MEDICAL ELIGIBILITY FORM (To be filled up by Physician Only)
                              </Typography>
                              <Typography className="green-dwn" sx={{ color: 'text.secondary', float: 'right', width: '30%', textAlign: 'right', color: '#008430', fontWeight: '600' }} >
                                <a title="Download" href='../../Peparticipation_Physical_Evaluation_Medical_Eligibility_Form.pdf' download className='downsec-new'>Download <GetAppIcon /></a>
                              </Typography>
                            </AccordionSummary>

                          </Accordion>

                        </div>
                        <div className='form-accor-sec  form-accor-secs color-form-occur'>
                          <Accordion expanded={expandednew === 'panel25f'} onChange={handleChangenew('panel25f')}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel3-content"
                              id="panel3-header" className='accor-expand-hide'
                            >
                              {/* <Typography>BANNED SUBSTANCES 2022-2023 FACT SHEET</Typography> */}
                              <Typography sx={{ width: '80%', flexShrink: 0 }}>PHYSICAL EXAMINATION FORM (To be filled up by Physician Only)</Typography>
                              <Typography className="green-dwn dnnnn" sx={{ flexShrink: 0, float: 'right', width: '20%', textAlign: 'right', color: '#008430', fontWeight: '600' }} >
                                <a title="Download" target="_blank" href='../../PHYSICAL_EXAMINATION_FORM.pdf' download>Download <GetAppIcon /></a>
                              </Typography>
                            </AccordionSummary>

                          </Accordion>

                        </div>

                        <div className='form-accor-sec color-form-occur'>
                          <Accordion expanded={expandednew === 'panel3f'} onChange={handleChangenew('panel3f')}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel2-content"
                              id="panel2-header"
                            >
                              <Typography sx={{ width: '80%', flexShrink: 0 }}>PREPARTICIPATION PHYSICAL EVALUATION <span className='line-sec'>|</span> HISTORY FORM</Typography>
                              <Typography className="green-dwn" sx={{ width: '20%', flexShrink: 0, color: 'text.secondary', float: 'right', textAlign: 'right', color: '#008430', fontWeight: '600' }} >
                                {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 3) == true) ?

                                  'Completed' : <span className='pebdingarmh'>Pending</span>}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>

                                <div className='form-main-sec'>


                                  {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 3) == true) ?

                                    '' : <>

                                      <div className='row'>
                                        <div className='col-md-2'>
                                          <div className='heading-logo'>
                                            <img src={newlogos} />
                                          </div>
                                        </div>
                                        <div className='col-md-8'>
                                          <div className='heading-form-para'>
                                            <h1>PREPARTICIPATION PHYSICAL EVALUATION <span className='line-sec'>|</span> HISTORY FORM

                                            </h1>


                                          </div>
                                        </div>

                                      </div>

                                      <div className='row'>
                                        <div className='col-md-12'>
                                          <div className='note-sec'>
                                            <p>(Note :- This form is to be filled out by the patient and parent prior to seeing the physician. The physician should keep a copy of this form in the chart)</p>
                                          </div>
                                        </div>
                                      </div>



                                      <div className='date-form'>
                                        <div className='row'>
                                          <div className='col-md-12'>
                                            <div className='form-date-sec form-date-nbw'>
                                              <label>Date of Exam:</label>
                                              {/* <input type="date" className='text-date text-datess' placeholder='dd-mm-yyyy'/> */}
                                              <div className='date-sec date-text-nwd'>
                                                <div className='date-slash'>
                                                  <input type="text" className="textmntg" id="datefir"
                                                    onKeyPress={(e) => handleKeyAccountPress(e)} placeholder='m' value={thirdformInfo.datefir} onChange={handleChangeThird}
                                                    name="datefir" />
                                                  <input type="text" className="textmntg" placeholder='m'
                                                    value={thirdformInfo.datesec} onKeyPress={(e) => handleKeyAccountPress(e)} id="datesec" onChange={handleChangeThird}
                                                    name="datesec" />
                                                </div>
                                                <div className='date-slash'>
                                                  <p>-</p>
                                                </div>
                                                <div className='date-slash'>
                                                  <input type="text" className="textdate textmonthstg" placeholder='d'
                                                    value={thirdformInfo.dateth} onKeyPress={(e) => handleKeyAccountPress(e)} id="dateth" onChange={handleChangeThird}
                                                    name="dateth" />
                                                  <input type="text" id="datefor" className="textdate textmonthstg" placeholder='d'
                                                    value={thirdformInfo.datefor} onKeyPress={(e) => handleKeyAccountPress(e)} onChange={handleChangeThird}
                                                    name="datefor" />
                                                </div>
                                                <div className='date-slash'>
                                                  <p>-</p>
                                                </div>
                                                <div className='date-slash'>
                                                  <input type="text" id="datefif" className="textdate textyeartg" placeholder='y'
                                                    value={thirdformInfo.datefif} onKeyPress={(e) => handleKeyAccountPress(e)} onChange={handleChangeThird}
                                                    name="datefif" />
                                                  <input type="text" id="datesix" className="textdate textyeartg" placeholder='y'
                                                    value={thirdformInfo.datesix} onKeyPress={(e) => handleKeyAccountPress(e)} onChange={handleChangeThird}
                                                    name="datesix" />
                                                  <input type="text" id="dateseven" className="textdate textyeartg"
                                                    value={thirdformInfo.dateseven} onKeyPress={(e) => handleKeyAccountPress(e)} onChange={handleChangeThird}
                                                    name="dateseven" placeholder='y' />
                                                  <input type="text" id="dateeight" className="textdate textyeartg"
                                                    value={thirdformInfo.dateeight} onKeyPress={(e) => handleKeyAccountPress(e)} onChange={handleChangeThird}
                                                    name="dateeight" placeholder='y' />
                                                </div>
                                              </div>
                                              {/* <p className='error-msg-frm'>
                                          {thirdformInfo.datefir_error == true ? 'Please enter Date of exam!' : ''}
                                          </p> */}





                                            </div>

                                            <p className='error-msg-frm ' style={{ textAlign: 'center' }}>
                                              <span className='dat-vall'>
                                                {thirdformInfo.datefir_error == true ? 'Please enter date of exam!' : ''}
                                              </span>
                                            </p>

                                          </div>

                                        </div>
                                      </div>



                                      <div class="row margin-data">
                                        <div class="col-md-3">
                                          {/* <div class="form-inner new-form-inner ony-wid-main">
                                            <h2 className='ony-wid-name'>Name <span className='spn-mar-le'>:</span></h2>
                                         
                                            <p class="id-sec width-extra ony-wid-exta width-extra-new-sp">{userData.student_name} {userData.last_name}</p>
                                          </div> */}
                                          <div className='new-phy-sec'>
                                            <p className='phy-new-head'>Name <span className='spn-mar-le'>:</span></p>
                                            <p  className='phy-new-head-data'>{userData.student_name} {userData.last_name}</p>
                                          </div>
                                        </div>
                                        <div class="col-md-3">
                                          {/* <div class="form-inner new-form-inner">
                                            <h2>DOB <span className='spn-mar-le'>:</span></h2>
                                           
                                            <p class="form-data width-extra width-extra-new-sp">{(userData.dob != null && userData.dob != '') && formatDate(userData.dob)}</p>
                                          </div> */}
                                           <div  className='new-phy-sec'>
                                            <p className='phy-new-head'>DOB <span className='spn-mar-le'>:</span></p>
                                            <p  className='phy-new-head-data'>{(userData.dob != null && userData.dob != '') && formatDate(userData.dob)}</p>
                                          </div>
                                        </div>
                                        <div class="col-md-2">
                                          {/* <div class="form-inner new-form-inner extranew-inn">
                                            <h2>Sex <span className='spn-mar-le'>:</span></h2>
                                           
                                            <p class="form-data width-extra width-extra-new-sp">{userData.gender}</p>
                                          </div> */}
                                          <div  className='new-phy-sec'>
                                            <p className='phy-new-head'>Sex <span className='spn-mar-le'>:</span></p>
                                            <p  className='phy-new-head-data'>{userData.gender}</p>
                                          </div>
                                        </div>
                                        <div class="col-md-2">
                                          {/* <div class="form-inner new-form-inner extranew-inn">
                                            <h2>Age <span className='spn-mar-le'>:</span></h2>
                                           
                                            <p class="form-data width-extra width-extra-new-sp"> {(userData.dob != null && userData.dob != '') && ageCalculator(userData.dob)}</p>
                                          </div> */}
                                           <div  className='new-phy-sec'>
                                            <p className='phy-new-head'>Age <span className='spn-mar-le'>:</span></p>
                                            <p  className='phy-new-head-data'>{(userData.dob != null && userData.dob != '') && ageCalculator(userData.dob)}</p>
                                          </div>
                                        </div>
                                        <div class="col-md-2">
                                          {/* <div class="form-inner new-form-inner extranew-inns">
                                            <h2>Grade <span className='spn-mar-le'>:</span></h2>
                                          
                                            <p class="id-sec width-extra width-extra-news-sp"> {userData.stu_grade}</p>
                                          </div> */}
                                          <div  className='new-phy-sec'>
                                            <p className='phy-new-head'>Grade <span className='spn-mar-le'>:</span></p>
                                            <p  className='phy-new-head-data'> {userData.stu_grade}</p>
                                          </div>
                                        </div>
                                      </div>


                                      <div class="row margin-data  row-cls-th">

                                        <div class="cls-wid-scl-th">
                                          {/* <div class="form-inner new-form-inner ony-wid-main">
                                            <h2 className='ony-wid-name'>School <span className='spn-mar-le'>:</span></h2>
                                          
                                            <p class="form-data width-extra width-extra-new-sp ony-wid-exta">{userData.school_name}</p>
                                          </div> */}
                                           <div  className='new-phy-sec new-phy-fl'>
                                            <p className='phy-new-head new-head-sc'>School <span className='spn-mar-le'>:</span></p>
                                            <p  className='phy-new-head-data new-head-sc-data'> {userData.school_name}</p>
                                          </div>
                                        </div>

                                        <div class="cls-wid-sport-th">
                                          {/* <div class="form-inner form-date-sec form-sportss form-new-sportsss new-sp-ch-sport">
                                            <h2>Sport(s) <span className='spn-mar-le'>:</span></h2>
                                         
                                            <input type="text" class="text-datess new-border width-extra input-sport-th "
                                              value={thirdformInfo.sports} onChange={handleChangeThird}
                                              name="sports" />
                                            <p className='error-msg-frm' style={{ left: '15%' }}>
                                              {thirdformInfo.sports_error == true ? 'Please enter the sports!' : ''}
                                            </p>
                                          </div> */}
                                           <div  className='new-phy-sec'>
                                            <p className='phy-new-head'>Sport(s)  <span className='spn-mar-le'>:</span></p>
                                            <input type="text" class="text-datess new-border width-extra input-sport-th "
                                              value={thirdformInfo.sports} onChange={handleChangeThird}
                                              name="sports" />
                                            <p className='error-msg-frm' style={{ left: '15%' }}>
                                              {thirdformInfo.sports_error == true ? 'Please enter the sports!' : ''}
                                            </p>
                                          </div>


                                        </div>




                                      </div>

                                      <div class="medician-sec">

                                        <div class="row">
                                          <div class="col-md-12">
                                            <div class="physici-sec-head">
                                              <h2>Medicines and Allergies:</h2>
                                            </div>
                                          </div>

                                        </div>

                                        <div className='row'>
                                          <div className='col-md-12'>
                                            <div className='std-form-inner address-sec medi-sec emdi-alrs-sec' >
                                              <label>Please list all of the prescription and over-the-counter medicines and supplements (herbal and nutritional) that you are currently taking</label>
                                              <p className='float-left'>:</p>
                                              <textarea className='new-textara-inpt' type="text" id="fname" placeholder='' rows="4" cols="50"
                                                value={thirdformInfo.supplemnets} onChange={handleChangeThird}
                                                name="supplemnets" />
                                              <p className='error-msg-frm'>
                                                {thirdformInfo.supplemnets_error == true ? 'List all of the prescription and over-the-counter medicines !' : ''}
                                              </p>
                                            </div>
                                          </div>
                                        </div>

                                        <div className='row'>
                                          <div className='medi-details-sec'>


                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-5'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>Do you have any allergies?
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-7">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >

                                                      <FormControlLabel value="Yes"


                                                        name="allergies" checked={thirdformInfo.allergies == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="allergies" checked={thirdformInfo.allergies == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <div className='fied-miss'>

                                                        {thirdformInfo.allergies_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-5'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label " className='radio-label'>If yes, Please identify specific allergy below
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-7 radio-forms">

                                                    <FormGroup className={`radio-sec ${thirdformInfo.allergies != 'Yes' && 'enavblesg'}`}>
                                                      <FormControlLabel label="Medicines"
                                                        value="Medicines"
                                                        name="allergies_data" checked={thirdformInfo.allergies_data.includes(" Medicines")}
                                                        onChange={handleChangeThirddata}

                                                        control={<Checkbox />} />
                                                      <FormControlLabel label="Pollens" control={<Checkbox />}
                                                        value="Pollens" name="allergies_data" checked={thirdformInfo.allergies_data.includes(" Pollens")}
                                                        onChange={handleChangeThirddata} />
                                                      <FormControlLabel label="Food" control={<Checkbox />}
                                                        value="Food" name="allergies_data" checked={thirdformInfo.allergies_data.includes(" Food")}
                                                        onChange={handleChangeThirddata} />
                                                      <FormControlLabel label="Stinging Insects" control={<Checkbox />}
                                                        value="Stinging Insects" name="allergies_data" checked={thirdformInfo.allergies_data.includes(" Stinging Insects")}
                                                        onChange={handleChangeThirddata} />

                                                    </FormGroup>

                                                    <div className='fied-miss'>

                                                      {thirdformInfo.allergies_data_error == true ? 'Field missing' : ''}
                                                    </div>
                                                  </div>
                                                </div>

                                              </FormControl>


                                            </div>
                                          </div>
                                        </div>


                                      </div>






                                      <div class="medician-sec general-ques">

                                        <div class="row">
                                          <div class="col-md-12">
                                            <div class="physici-sec-head">
                                              <h2>GENERAL QUESTIONS (For yes Please fill up the EXPLAIN text box)</h2>
                                            </div>
                                          </div>

                                        </div>

                                        <div className='row'>
                                          <div className='medi-details-sec gener-ques'>


                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>1.</p><p class="num-data-sec"> Has a doctor ever denied or restricted your participation in sports for
                                                        any reason?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="restricted" checked={thirdformInfo.restricted == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="restricted" checked={thirdformInfo.restricted == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="restricted" checked={thirdformInfo.restricted == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.restricted_error == true ? 'Field missing' : ''}
                                                      </div>


                                                    </RadioGroup>

                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>
                                            {thirdformInfo.restricted == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_restricted} onChange={handleChangeThird}
                                                      name="explain_restricted" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_restricted_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}

                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label' >
                                                      <p className='num-sec'>2.</p><p class="num-data-sec">  Do you have any ongoing medical conditions? If so, Please identify below:</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5 radio-forms ">

                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="medical" checked={thirdformInfo.medical == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="medical" checked={thirdformInfo.medical == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="medical" checked={thirdformInfo.medical == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.medical_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>

                                                  </div>
                                                </div>

                                              </FormControl>

                                              <div className='row'>
                                                <div className="col-md-12 radio-forms radio-left">

                                                  <FormGroup className={`radio-sec ${thirdformInfo.medical != 'Yes' && 'enavblesg'}`}>
                                                    <FormControlLabel label="Asthma"
                                                      value="Asthma"
                                                      name="medical_data" checked={thirdformInfo.medical_data.includes(" Asthma")}
                                                      onChange={handleChangeThirddata}

                                                      control={<Checkbox />} />
                                                    <FormControlLabel label="Anemia" control={<Checkbox />}
                                                      value="Anemia" name="medical_data"
                                                      checked={thirdformInfo.medical_data.includes(" Anemia")}
                                                      onChange={handleChangeThirddata} />
                                                    <FormControlLabel label="Diabetes" control={<Checkbox />}
                                                      value="Diabetes" name="medical_data"
                                                      checked={thirdformInfo.medical_data.includes(" Diabetes")}
                                                      onChange={handleChangeThirddata} />
                                                    <FormControlLabel label="Infections" control={<Checkbox />}
                                                      value="Infections" name="medical_data"
                                                      checked={thirdformInfo.medical_data.includes(" Infections")}
                                                      onChange={handleChangeThirddata} />

                                                  </FormGroup>
                                                  <div className='fied-miss'>

                                                    {thirdformInfo.medical_data_error == true ? 'Field missing' : ''}
                                                  </div>



                                                </div>
                                              </div>

                                              <div className='row margin-top radio-other'>
                                                <div className='col-md-3'>
                                                  <div class="std-form-inner other-sec"><label>Other</label><p class="float-left">:</p>
                                                    <textarea class="new-textara-inpt" type="text"
                                                      value={thirdformInfo.other} onChange={handleChangeThird}
                                                      name="other"
                                                      id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                  </div>
                                                </div>
                                              </div>

                                              {thirdformInfo.medical == 'Yes' ?
                                                <div className='row margin-top'>
                                                  <div className='col-md-6'>
                                                    <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                      <textarea class="textarea-input" type="text" id="fname"
                                                        value={thirdformInfo.explain} onChange={handleChangeThird}
                                                        name="explain" placeholder="" rows="4" cols="50"></textarea>
                                                      <p className='error-msg-frm '>
                                                        <span>

                                                          {thirdformInfo.explain_error == true ? 'Please enter the explanation' : ''}
                                                        </span>
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div> : ''}                                <div class="">
                                                <hr />
                                              </div>

                                              <div className='row'>
                                                <div className='col-md-12'>
                                                  <FormControl>
                                                    <div className='row'>
                                                      <div className='col-md-7'>
                                                        <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                          <p className='num-sec'>3.</p><p class="num-data-sec"> Have you ever spent the night in the hospital?</p>
                                                        </FormLabel>
                                                      </div>

                                                      <div className="col-md-5 radio-forms">

                                                        <RadioGroup
                                                          row
                                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                                          name="row-radio-buttons-group" className='radio-secss'
                                                        >
                                                          <FormControlLabel value="Yes"


                                                            name="hospital" checked={thirdformInfo.hospital == 'Yes'}
                                                            onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                          <FormControlLabel value="No"


                                                            name="hospital" checked={thirdformInfo.hospital == 'No'}
                                                            onChange={handleChangeThird} control={<Radio />} label="No" />
                                                          <FormControlLabel value="Don't Know"


                                                            name="hospital" checked={thirdformInfo.hospital == "Don't Know"}
                                                            onChange={handleChangeThird}

                                                            control={<Radio />} label="Don't Know" />
                                                          <div className='fied-miss'>

                                                            {thirdformInfo.hospital_error == true ? 'Field missing' : ''}
                                                          </div>


                                                        </RadioGroup>

                                                      </div>
                                                    </div>

                                                  </FormControl>
                                                </div>

                                              </div>
                                              {thirdformInfo.hospital == 'Yes' ?
                                                <div className='row margin-top'>
                                                  <div className='col-md-6'>
                                                    <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                      <textarea class="textarea-input" type="text" id="fname"
                                                        value={thirdformInfo.explain_hospital} onChange={handleChangeThird}
                                                        name="explain_hospital" placeholder="" rows="4" cols="50"></textarea>
                                                      <p className='error-msg-frm'>
                                                        <span>
                                                          {thirdformInfo.explain_hospital_error == true ? 'Please enter the explanation' : ''}
                                                        </span>
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div> : ''}

                                              <div class="">
                                                <hr />
                                              </div>

                                              <div className='row'>
                                                <div className='col-md-12'>
                                                  <FormControl>
                                                    <div className='row'>
                                                      <div className='col-md-7'>
                                                        <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                          <p className='num-sec'> 4.</p><p class="num-data-sec">  Have you ever had surgery? </p>
                                                        </FormLabel>
                                                      </div>

                                                      <div className="col-md-5 radio-forms">

                                                        <RadioGroup
                                                          row
                                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                                          name="row-radio-buttons-group" className='radio-secss'
                                                        >
                                                          <FormControlLabel value="Yes"


                                                            name="surgery" checked={thirdformInfo.surgery == 'Yes'}
                                                            onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                          <FormControlLabel value="No"


                                                            name="surgery" checked={thirdformInfo.surgery == 'No'}
                                                            onChange={handleChangeThird} control={<Radio />} label="No" />
                                                          <FormControlLabel value="Don't Know"


                                                            name="surgery" checked={thirdformInfo.surgery == "Don't Know"}
                                                            onChange={handleChangeThird}

                                                            control={<Radio />} label="Don't Know" />

                                                          <div className='fied-miss'>

                                                            {thirdformInfo.surgery_error == true ? 'Field missing' : ''}
                                                          </div>


                                                        </RadioGroup>

                                                      </div>
                                                    </div>

                                                  </FormControl>
                                                </div>

                                              </div>
                                              {thirdformInfo.surgery == 'Yes' ?
                                                <div className='row margin-top'>
                                                  <div className='col-md-6'>
                                                    <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                      <textarea class="textarea-input" type="text" id="fname"
                                                        value={thirdformInfo.explain_surgery} onChange={handleChangeThird}
                                                        name="explain_surgery" placeholder="" rows="4" cols="50"></textarea>
                                                      <p className='error-msg-frm'>
                                                        <span>
                                                          {thirdformInfo.explain_surgery_error == true ? 'Please enter the explanation' : ''}
                                                        </span>
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div> : ''}

                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      {/* heart heath questions about you start*/}
                                      <div class="medician-sec general-ques">

                                        <div class="row">
                                          <div class="col-md-12">
                                            <div class="physici-sec-head">
                                              <h2>HEART HEALTH QUESTIONS ABOUT YOU</h2>
                                            </div>
                                          </div>

                                        </div>

                                        <div className='row'>
                                          <div className='medi-details-sec gener-ques'>


                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>5.</p><p class="num-data-sec"> Have you ever passed out or nearly passed out DURING or AFTER exercise?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="exercise" checked={thirdformInfo.exercise == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="exercise" checked={thirdformInfo.exercise == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="exercise" checked={thirdformInfo.exercise == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.exercise_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>

                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>
                                            {thirdformInfo.exercise == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_exercise} onChange={handleChangeThird}
                                                      name="explain_exercise" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_exercise_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>6.</p><p class="num-data-sec"> Have you ever had discomfort, pain, lightness, or pressure in your chest
                                                        during exercise?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="chest" checked={thirdformInfo.chest == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="chest" checked={thirdformInfo.chest == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="chest" checked={thirdformInfo.chest == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />
                                                      <div className='fied-miss'>

                                                        {thirdformInfo.chest_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>

                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.chest == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_chest} onChange={handleChangeThird}
                                                      name="explain_chest" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_chest_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>7.</p><p class="num-data-sec"> Does your heart ever race or skip beats (irregular beats) during exercise?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="irregular" checked={thirdformInfo.irregular == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="irregular" checked={thirdformInfo.irregular == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="irregular" checked={thirdformInfo.irregular == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />
                                                      <div className='fied-miss'>

                                                        {thirdformInfo.irregular_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>

                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>
                                            {thirdformInfo.irregular == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_irregular} onChange={handleChangeThird}
                                                      name="explain_irregular" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_irregular_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>8.</p><p class="num-data-sec"> Has a doctor ever told you that you have any heart problems? If so, check
                                                        all that apply:</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="heart_problem" checked={thirdformInfo.heart_problem == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="heart_problem" checked={thirdformInfo.heart_problem == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="heart_problem" checked={thirdformInfo.heart_problem == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.heart_problem_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                              <div className='row'>
                                                <div className="col-md-12 radio-forms radio-left">

                                                  <FormGroup className={`radio-sec ${thirdformInfo.heart_problem != 'Yes' && 'enavblesg'}`}>
                                                    <div className='row'>
                                                      <div className='col-md-12'>
                                                        <FormControlLabel label="High blood pressure"
                                                          value="High blood pressure"
                                                          name="heart_problem_data"
                                                          checked={thirdformInfo.heart_problem_data.includes(" High blood pressure")}
                                                          onChange={handleChangeThirddata}

                                                          control={<Checkbox />} />
                                                        <FormControlLabel label="A heart murmur" control={<Checkbox />}
                                                          value="A heart murmur" name="heart_problem_data"
                                                          checked={thirdformInfo.heart_problem_data.includes(" A heart murmur")}
                                                          onChange={handleChangeThirddata} />
                                                        <FormControlLabel label="High Cholesterol" control={<Checkbox />}
                                                          value="High Cholesterol" name="heart_problem_data"
                                                          checked={thirdformInfo.heart_problem_data.includes(" High Cholesterol")}
                                                          onChange={handleChangeThirddata} />
                                                      </div>
                                                      <div className='col-md-12'>
                                                        <FormControlLabel label="A heart infection"
                                                          value="A heart infection"
                                                          name="heart_problem_data"
                                                          checked={thirdformInfo.heart_problem_data.includes(" A heart infection")}
                                                          onChange={handleChangeThirddata}

                                                          control={<Checkbox />} />
                                                        <FormControlLabel label="Kawasaki disease" control={<Checkbox />}
                                                          value="Kawasaki disease" name="heart_problem_data"
                                                          checked={thirdformInfo.heart_problem_data.includes(" Kawasaki disease")}
                                                          onChange={handleChangeThirddata} />
                                                      </div>

                                                    </div>
                                                  </FormGroup>


                                                </div>
                                              </div>

                                            </div>

                                            {thirdformInfo.heart_problem == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_heart_problem} onChange={handleChangeThird}
                                                      name="explain_heart_problem" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_heart_problem_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div className='row margin-top'>
                                              <div className='col-md-3'>
                                                <div class="std-form-inner other-sec"><label>Other</label><p class="float-left">:</p>
                                                  <textarea class="new-textara-inpt"
                                                    value={thirdformInfo.heart_problem_data_other} onChange={handleChangeThird}
                                                    name="heart_problem_data_other" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>9.</p><p class="num-data-sec">  Has a doctor ever ordered a test for your heart? (For example, ECG/EKG,
                                                        echocardiogram)</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="heart_doctor" checked={thirdformInfo.heart_doctor == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="heart_doctor" checked={thirdformInfo.heart_doctor == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="heart_doctor" checked={thirdformInfo.heart_doctor == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.heart_doctor_error == true ? 'Field missing' : ''}
                                                      </div>



                                                    </RadioGroup>




                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.heart_doctor == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_heart_doctor} onChange={handleChangeThird}
                                                      name="explain_heart_doctor" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_heart_doctor_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>10.</p><p class="num-data-sec">  Do you get lightheaded or feel more short of breath than expected during
                                                        exercise?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="lightheaded" checked={thirdformInfo.lightheaded == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="lightheaded" checked={thirdformInfo.lightheaded == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="lightheaded" checked={thirdformInfo.lightheaded == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />
                                                      <div className='fied-miss'>

                                                        {thirdformInfo.lightheaded_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.lightheaded == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_lightheaded} onChange={handleChangeThird}
                                                      name="explain_lightheaded" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm'>
                                                      <span>
                                                        {thirdformInfo.explain_lightheaded_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>
                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>11.</p><p class="num-data-sec"> Have you ever had an unexplained seizure?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="seizure" checked={thirdformInfo.seizure == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="seizure" checked={thirdformInfo.seizure == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="seizure" checked={thirdformInfo.seizure == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />
                                                      <div className='fied-miss'>

                                                        {thirdformInfo.seizure_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.seizure == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_seizure} onChange={handleChangeThird}
                                                      name="explain_seizure" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_seizure_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>12.</p><p class="num-data-sec"> Do you get more tired or short of breath more quickly than your friends during
                                                        exercise?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="breath" checked={thirdformInfo.breath == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="breath" checked={thirdformInfo.breath == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="breath" checked={thirdformInfo.breath == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.breath_error == true ? 'Field missing' : ''}
                                                      </div>


                                                    </RadioGroup>



                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                          </div>
                                        </div>

                                        {thirdformInfo.breath == 'Yes' ?
                                          <div className='row margin-top'>
                                            <div className='col-md-6'>
                                              <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                <textarea class="textarea-input" type="text" id="fname"
                                                  value={thirdformInfo.explain_breath} onChange={handleChangeThird}
                                                  name="explain_breath" placeholder="" rows="4" cols="50"></textarea>
                                                <p className='error-msg-frm'>
                                                  <span>

                                                    {thirdformInfo.explain_breath_error == true ? 'Please enter the explanation' : ''}
                                                  </span>
                                                </p>
                                              </div>
                                            </div>
                                          </div> : ''}
                                      </div>

                                      {/* heart heath questions about you end */}


                                      {/* heart heath questions about your family start*/}
                                      <div class="medician-sec general-ques">

                                        <div class="row">
                                          <div class="col-md-12">
                                            <div class="physici-sec-head">
                                              <h2>HEART HEALTH QUESTIONS ABOUT YOUR FAMILY</h2>
                                            </div>
                                          </div>

                                        </div>

                                        <div className='row'>
                                          <div className='medi-details-sec gener-ques'>


                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>13.</p><p class="num-data-sec"> Has any family member or relative died of heart problems or had an unexpected
                                                        or unexplained sudden death before age 50 (including drowning, unexplained
                                                        car accident, or sudden infant death syndrome)?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    ><FormControlLabel value="Yes"


                                                      name="death_syndrome" checked={thirdformInfo.death_syndrome == 'Yes'}
                                                      onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="death_syndrome" checked={thirdformInfo.death_syndrome == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="death_syndrome" checked={thirdformInfo.death_syndrome == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />


                                                      <div className='fied-miss'>

                                                        {thirdformInfo.death_syndrome_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.death_syndrome == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_death_syndrome} onChange={handleChangeThird}
                                                      name="explain_death_syndrome" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>

                                                        {thirdformInfo.explain_death_syndrome_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr style={{ margin: '30px 0px' }} />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above fam-about'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>14.</p> <p className='num-data-sec'>Does anyone in your family have hypertrophic cardiomyopathy, Marfan
                                                        syndrome, arrhythmogenic right ventricular cardiomyopathy, long QT syndrome,
                                                        short QT syndrome, Brugada syndrome, or catecholaminergic polymorphic
                                                        ventricular tachycardia?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="hypertrophic" checked={thirdformInfo.hypertrophic == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="hypertrophic" checked={thirdformInfo.hypertrophic == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="hypertrophic" checked={thirdformInfo.hypertrophic == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />


                                                      <div className='fied-miss'>

                                                        {thirdformInfo.hypertrophic_error == true ? 'Field missing' : ''}
                                                      </div>


                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.hypertrophic == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_hypertrophic} onChange={handleChangeThird}
                                                      name="explain_hypertrophic" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_hypertrophic_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr style={{ margin: '20px 0px' }} />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above fam-about'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>15.</p> <p className='num-data-sec'> Does anyone in your family have a heart problem, pacemaker, or implanted
                                                        defibrillator?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="pacemaker" checked={thirdformInfo.pacemaker == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="pacemaker" checked={thirdformInfo.pacemaker == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="pacemaker" checked={thirdformInfo.pacemaker == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.pacemaker_error == true ? 'Field missing' : ''}
                                                      </div>


                                                    </RadioGroup>



                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.pacemaker == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_pacemaker} onChange={handleChangeThird}
                                                      name="explain_pacemaker" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm'>
                                                      <span>
                                                        {thirdformInfo.explain_pacemaker_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr style={{ margin: '20px 0px' }} />
                                            </div>
                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>16.</p> <p className='num-data-sec'> Has anyone in your family had unexplained fainting, unexplained seizures, or
                                                        near drowning?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="unexplained_seizures" checked={thirdformInfo.unexplained_seizures == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="unexplained_seizures" checked={thirdformInfo.unexplained_seizures == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="unexplained_seizures" checked={thirdformInfo.unexplained_seizures == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />


                                                      <div className='fied-miss'>

                                                        {thirdformInfo.unexplained_seizures_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>



                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.unexplained_seizures == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_unexplained_seizures} onChange={handleChangeThird}
                                                      name="explain_unexplained_seizures" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_unexplained_seizures_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}

                                          </div>
                                        </div>
                                      </div>
                                      {/* heart heath questions about your family end*/}


                                      {/* bones and joint section code start */}

                                      <div class="medician-sec general-ques">

                                        <div class="row">
                                          <div class="col-md-12">
                                            <div class="physici-sec-head">
                                              <h2>BONE AND JOINT QUESTIONS</h2>
                                            </div>
                                          </div>

                                        </div>

                                        <div className='row'>
                                          <div className='medi-details-sec gener-ques'>


                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>17.</p><p className='num-data-sec'> Have you ever had an injury to a bone, muscle, ligament, or tendon that caused
                                                        you to miss a practice or a game?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="practice" checked={thirdformInfo.practice == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="practice" checked={thirdformInfo.practice == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="practice" checked={thirdformInfo.practice == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.practice_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>



                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.practice == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_practice} onChange={handleChangeThird}
                                                      name="explain_practice" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm'>
                                                      <span>
                                                        {thirdformInfo.explain_practice_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above fam-about'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>18.</p><p className='num-data-sec'> Have you ever had any broken or fractured bones or dislocated joints?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="dislocated" checked={thirdformInfo.dislocated == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="dislocated" checked={thirdformInfo.dislocated == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="dislocated" checked={thirdformInfo.dislocated == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.dislocated_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>



                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>


                                            {thirdformInfo.dislocated == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_dislocated} onChange={handleChangeThird}
                                                      name="explain_dislocated" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_dislocated_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above fam-about'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>19.</p><p className='num-data-sec'> Have you ever had an injury that required x-rays, MRI, CT scan, injections,
                                                        therapy, a brace, a cast, or crutches?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    ><FormControlLabel value="Yes"


                                                      name="injections" checked={thirdformInfo.injections == 'Yes'}
                                                      onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="injections" checked={thirdformInfo.injections == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="injections" checked={thirdformInfo.injections == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />


                                                      <div className='fied-miss'>

                                                        {thirdformInfo.injections_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>



                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.injections == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_injections} onChange={handleChangeThird}
                                                      name="explain_injections" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm'>
                                                      <span>
                                                        {thirdformInfo.explain_injections_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>
                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>20.</p><p className='num-data-sec'> Have you ever had a stress fracture?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="stress" checked={thirdformInfo.stress == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="stress" checked={thirdformInfo.stress == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="stress" checked={thirdformInfo.stress == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.stress_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>




                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.stress == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_stress} onChange={handleChangeThird}
                                                      name="explain_stress" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_stress_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>21.</p><p className='num-data-sec'> Have you ever been told that you have or have you had an x-ray for neck
                                                        instability or atlantoaxial instability? (Down syndrome or dwarfism)</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="instability" checked={thirdformInfo.instability == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="instability" checked={thirdformInfo.instability == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="instability" checked={thirdformInfo.instability == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />
                                                      <div className='fied-miss'>

                                                        {thirdformInfo.instability_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>



                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.instability == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_instability} onChange={handleChangeThird}
                                                      name="explain_instability" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_instability_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>22.</p><p className='num-data-sec'> Do you regularly use a brace, orthotics, or other assistive device ?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="orthotics" checked={thirdformInfo.orthotics == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="orthotics" checked={thirdformInfo.orthotics == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="orthotics" checked={thirdformInfo.orthotics == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />


                                                      <div className='fied-miss'>

                                                        {thirdformInfo.orthotics_error == true ? 'Field missing' : ''}
                                                      </div>


                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.orthotics == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_orthotics} onChange={handleChangeThird}
                                                      name="explain_orthotics" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm'>
                                                      <span>
                                                        {thirdformInfo.explain_orthotics_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>


                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>23.</p><p className='num-data-sec'>Do you have a bone, muscle, or joint injury that bothers you?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="joint_injury" checked={thirdformInfo.joint_injury == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="joint_injury" checked={thirdformInfo.joint_injury == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="joint_injury" checked={thirdformInfo.joint_injury == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />


                                                      <div className='fied-miss'>

                                                        {thirdformInfo.joint_injury_error == true ? 'Field missing' : ''}
                                                      </div>


                                                    </RadioGroup>



                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.joint_injury == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_joint_injury} onChange={handleChangeThird}
                                                      name="explain_joint_injury" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_joint_injury_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>


                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>24.</p><p className='num-data-sec'> Do any of your joints become painful, swollen, feel warm, or look red ?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"
                                                        name="swollen" checked={thirdformInfo.swollen == 'Yes'} onChange={handleChangeThird}
                                                        control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="swollen" checked={thirdformInfo.swollen == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="swollen" checked={thirdformInfo.swollen == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />


                                                      <div className='fied-miss'>

                                                        {thirdformInfo.swollen_error == true ? 'Field missing' : ''}
                                                      </div>


                                                    </RadioGroup>



                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.swollen == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_swollen} onChange={handleChangeThird}
                                                      name="explain_swollen" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_swollen_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>


                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>25.</p><p className='num-data-sec'> Do you have any history of juvenile arthritis or connective tissue disease ?
                                                      </p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="arthritis" checked={thirdformInfo.arthritis == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="arthritis" checked={thirdformInfo.arthritis == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="arthritis" checked={thirdformInfo.arthritis == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.arthritis_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>



                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.arthritis == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_arthritis} onChange={handleChangeThird}
                                                      name="explain_arthritis" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_arthritis_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}

                                          </div>
                                        </div>
                                      </div>

                                      {/* bones and joint section end */}


                                      {/* medical question start section */}

                                      <div class="medician-sec general-ques">

                                        <div class="row">
                                          <div class="col-md-12">
                                            <div class="physici-sec-head">
                                              <h2>MEDICAL QUESTIONS   </h2>
                                            </div>
                                          </div>

                                        </div>

                                        <div className='row'>
                                          <div className='medi-details-sec gener-ques'>


                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>26.</p><p className='num-data-sec'>
                                                        Do you cough, wheeze, or have difficulty breathing during or after exercise?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="breathing_exercise" checked={thirdformInfo.breathing_exercise == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="breathing_exercise" checked={thirdformInfo.breathing_exercise == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="breathing_exercise" checked={thirdformInfo.breathing_exercise == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.breathing_exercise_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.breathing_exercise == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_breathing_exercise} onChange={handleChangeThird}
                                                      name="explain_breathing_exercise" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_breathing_exercise_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above fam-about'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>27.</p><p className='num-data-sec'> Have you ever used an inhaler or taken asthma medicine?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="asthma_medicine" checked={thirdformInfo.asthma_medicine == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="asthma_medicine" checked={thirdformInfo.asthma_medicine == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="asthma_medicine" checked={thirdformInfo.asthma_medicine == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.asthma_medicine_error == true ? 'Field missing' : ''}
                                                      </div>



                                                    </RadioGroup>



                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.asthma_medicine == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_asthma_medicine} onChange={handleChangeThird}
                                                      name="explain_asthma_medicine" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_asthma_medicine_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above fam-about'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>28.</p><p className='num-data-sec'> Is there anyone in your family who has asthma?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="asthma_family" checked={thirdformInfo.asthma_family == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="asthma_family" checked={thirdformInfo.asthma_family == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="asthma_family" checked={thirdformInfo.asthma_family == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.asthma_family_error == true ? 'Field missing' : ''}
                                                      </div>


                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.asthma_family == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_asthma_family} onChange={handleChangeThird}
                                                      name="explain_asthma_family" placeholder="" rows="4" cols="50"></textarea>

                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_asthma_family_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>29.</p><p className='num-data-sec'> Were you born without or are you missing a kidney, an eye, a testicle (males),
                                                        your spleen, or any other organ?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="kidney" checked={thirdformInfo.kidney == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="kidney" checked={thirdformInfo.kidney == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="kidney" checked={thirdformInfo.kidney == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>


                                                        {thirdformInfo.kidney_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.kidney == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_kidney} onChange={handleChangeThird}
                                                      name="explain_kidney" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_kidney_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>30.</p><p className='num-data-sec'> Do you have groin pain or a painful bulge or hernia in the groin area?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="hernia" checked={thirdformInfo.hernia == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="hernia" checked={thirdformInfo.hernia == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="hernia" checked={thirdformInfo.hernia == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.hernia_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>



                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.hernia == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_hernia} onChange={handleChangeThird}
                                                      name="explain_hernia" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_hernia_error == true ? 'Please enter the explanation' : ''}
                                                      </span>

                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>


                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>31.</p><p className='num-data-sec'> Have you had infectious mononucleosis (mono) within the last month?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="mononucleosis" checked={thirdformInfo.mononucleosis == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="mononucleosis" checked={thirdformInfo.mononucleosis == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="mononucleosis" checked={thirdformInfo.mononucleosis == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.mononucleosis_error == true ? 'Field missing' : ''}
                                                      </div>



                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.mononucleosis == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_mononucleosis} onChange={handleChangeThird}
                                                      name="explain_mononucleosis" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm'>
                                                      <span>
                                                        {thirdformInfo.explain_mononucleosis_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>
                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>32.</p><p className='num-data-sec'> Do you have any rashes, pressure sores, or other skin problems?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="pressure_sores" checked={thirdformInfo.pressure_sores == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="pressure_sores" checked={thirdformInfo.pressure_sores == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="pressure_sores" checked={thirdformInfo.pressure_sores == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />


                                                      <div className='fied-miss'>

                                                        {thirdformInfo.pressure_sores_error == true ? 'Field missing' : ''}
                                                      </div>



                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>


                                            {thirdformInfo.pressure_sores == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_pressure_sores} onChange={handleChangeThird}
                                                      name="explain_pressure_sores" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm'>
                                                      <span>

                                                        {thirdformInfo.explain_pressure_sores_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>


                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>33.</p><p className='num-data-sec'> Have you had a herpes or MRSA skin infection?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    ><FormControlLabel value="Yes"


                                                      name="mrsa" checked={thirdformInfo.mrsa == 'Yes'}
                                                      onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="mrsa" checked={thirdformInfo.mrsa == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="mrsa" checked={thirdformInfo.mrsa == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />


                                                      <div className='fied-miss'>

                                                        {thirdformInfo.mrsa_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.mrsa == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_mrsa} onChange={handleChangeThird}
                                                      name="explain_mrsa" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm'>
                                                      <span>
                                                        {thirdformInfo.explain_mrsa_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>34.</p><p className='num-data-sec'> Have you ever had a head injury or concussion?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="head_injury" checked={thirdformInfo.head_injury == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="head_injury" checked={thirdformInfo.head_injury == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="head_injury" checked={thirdformInfo.head_injury == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.head_injury_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>



                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.head_injury == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_head_injury} onChange={handleChangeThird}
                                                      name="explain_head_injury" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_head_injury_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>35.</p><p className='num-data-sec'> Have you ever had a hit or blow to the head that caused confusion, prolonged
                                                        headache, or memory problems?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="memory_problems" checked={thirdformInfo.memory_problems == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="memory_problems" checked={thirdformInfo.memory_problems == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="memory_problems" checked={thirdformInfo.memory_problems == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />
                                                      <div className='fied-miss'>

                                                        {thirdformInfo.memory_problems_error == true ? 'Field missing' : ''}
                                                      </div>


                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.memory_problems == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_memory_problems} onChange={handleChangeThird}
                                                      name="explain_memory_problems" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm'>
                                                      <span>

                                                        {thirdformInfo.explain_memory_problems_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>36.</p><p className='num-data-sec'> Do you have a history of seizure disorder?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="seizure_disorder" checked={thirdformInfo.seizure_disorder == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="seizure_disorder" checked={thirdformInfo.seizure_disorder == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="seizure_disorder" checked={thirdformInfo.seizure_disorder == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>


                                                        {thirdformInfo.seizure_disorder_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.seizure_disorder == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_seizure_disorder} onChange={handleChangeThird}
                                                      name="explain_seizure_disorder" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm'>
                                                      <span>
                                                        {thirdformInfo.explain_seizure_disorder_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>
                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>37.</p><p className='num-data-sec'> Do you have headaches with exercise?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="headaches_exercise" checked={thirdformInfo.headaches_exercise == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="headaches_exercise" checked={thirdformInfo.headaches_exercise == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="headaches_exercise" checked={thirdformInfo.headaches_exercise == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />


                                                      <div className='fied-miss'>

                                                        {thirdformInfo.headaches_exercise_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.headaches_exercise == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_headaches_exercise} onChange={handleChangeThird}
                                                      name="explain_headaches_exercise" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>

                                                        {thirdformInfo.explain_headaches_exercise_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>38.</p><p className='num-data-sec'> Have you ever had numbness, tingling, or weakness in your arms or legs after
                                                        being hit or falling?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="numbness" checked={thirdformInfo.numbness == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="numbness" checked={thirdformInfo.numbness == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="numbness" checked={thirdformInfo.numbness == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.numbness_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>




                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>


                                            {thirdformInfo.numbness == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_numbness} onChange={handleChangeThird}
                                                      name="explain_numbness" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm'>
                                                      <span>
                                                        {thirdformInfo.explain_numbness_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>39.</p><p className='num-data-sec'>
                                                        Have you ever been unable to move your arms or legs after being hit or falling? </p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="arms" checked={thirdformInfo.arms == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="arms" checked={thirdformInfo.arms == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="arms" checked={thirdformInfo.arms == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />
                                                      <div className='fied-miss'>

                                                        {thirdformInfo.arms_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.arms == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_arms} onChange={handleChangeThird}
                                                      name="explain_arms" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm'>
                                                      <span>
                                                        {thirdformInfo.explain_arms_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>40.</p><p className='num-data-sec'> Have you ever become ill while exercising in the heal?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="heal" checked={thirdformInfo.heal == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="heal" checked={thirdformInfo.heal == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="heal" checked={thirdformInfo.heal == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />
                                                      <div className='fied-miss'>

                                                        {thirdformInfo.heal_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>




                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.heal == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_heal} onChange={handleChangeThird}
                                                      name="explain_heal" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm'>
                                                      <span>
                                                        {thirdformInfo.explain_heal_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>
                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>41.</p><p className='num-data-sec'> Do you get frequent muscle cramps when exercising?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="cramps" checked={thirdformInfo.cramps == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="cramps" checked={thirdformInfo.cramps == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="cramps" checked={thirdformInfo.cramps == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />
                                                      <div className='fied-miss'>

                                                        {thirdformInfo.cramps_error == true ? 'Field missing' : ''}
                                                      </div>


                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.cramps == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_cramps} onChange={handleChangeThird}
                                                      name="explain_cramps" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm'>
                                                      <span>
                                                        {thirdformInfo.explain_cramps_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>
                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>42.</p><p className='num-data-sec'> Do you or someone in your family have sickle cell trait or disease?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >


                                                      <FormControlLabel value="Yes"


                                                        name="sickle" checked={thirdformInfo.sickle == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="sickle" checked={thirdformInfo.sickle == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="sickle" checked={thirdformInfo.sickle == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.sickle_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>


                                            {thirdformInfo.sickle == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_sickle} onChange={handleChangeThird}
                                                      name="explain_sickle" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm'>
                                                      <span>
                                                        {thirdformInfo.explain_sickle_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>43.</p><p className='num-data-sec'> Have you had any problems with your eyes or vision?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    ><FormControlLabel value="Yes"


                                                      name="vision" checked={thirdformInfo.vision == 'Yes'}
                                                      onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="vision" checked={thirdformInfo.vision == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="vision" checked={thirdformInfo.vision == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />
                                                      <div className='fied-miss'>

                                                        {thirdformInfo.vision_error == true ? 'Field missing' : ''}
                                                      </div>


                                                    </RadioGroup>



                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.vision == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_vision} onChange={handleChangeThird}
                                                      name="explain_vision" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm'>
                                                      <span>
                                                        {thirdformInfo.explain_vision_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>44.</p><p className='num-data-sec'> Have you had any eye injuries?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="eye_injuries" checked={thirdformInfo.eye_injuries == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="eye_injuries" checked={thirdformInfo.eye_injuries == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="eye_injuries" checked={thirdformInfo.eye_injuries == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.eye_injuries_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>


                                            {thirdformInfo.eye_injuries == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_eye_injuries} onChange={handleChangeThird}
                                                      name="explain_eye_injuries" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_eye_injuries_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>45.</p><p className='num-data-sec'> Do you wear glasses or contact lenses?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="contact_lenses" checked={thirdformInfo.contact_lenses == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="contact_lenses" checked={thirdformInfo.contact_lenses == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="contact_lenses" checked={thirdformInfo.contact_lenses == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.contact_lenses_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.contact_lenses == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_contact_lenses} onChange={handleChangeThird}
                                                      name="explain_contact_lenses" placeholder="" rows="4" cols="50"></textarea>

                                                    <p className='error-msg-frm'>
                                                      <span>
                                                        {thirdformInfo.explain_contact_lenses_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>
                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>46.</p><p className='num-data-sec'> Do you wear protective eyewear, such as goggles or a face shield?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="face_shield" checked={thirdformInfo.face_shield == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="face_shield" checked={thirdformInfo.face_shield == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="face_shield" checked={thirdformInfo.face_shield == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.face_shield_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>



                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.face_shield == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_face_shield} onChange={handleChangeThird}
                                                      name="explain_face_shield" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_face_shield_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>47.</p><p className='num-data-sec'> Do you worry about your weight?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="weight" checked={thirdformInfo.weight == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="weight" checked={thirdformInfo.weight == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="weight" checked={thirdformInfo.weight == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.weight_error == true ? 'Field missing' : ''}
                                                      </div>
                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.weight == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_weight} onChange={handleChangeThird}
                                                      name="explain_weight" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>

                                                        {thirdformInfo.explain_weight_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>48.</p><p className='num-data-sec'> Are you trying to or has anyone recommended that you gain or lose weight?
                                                      </p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="lose_weight" checked={thirdformInfo.lose_weight == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="lose_weight" checked={thirdformInfo.lose_weight == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="lose_weight" checked={thirdformInfo.lose_weight == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.lose_weight_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>


                                            {thirdformInfo.lose_weight == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_lose_weight} onChange={handleChangeThird}
                                                      name="explain_lose_weight" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_lose_weight_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>49.</p><p className='num-data-sec'> Are you on a special diet or do you avoid certain types of foods?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="foods" checked={thirdformInfo.foods == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="foods" checked={thirdformInfo.foods == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="foods" checked={thirdformInfo.foods == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />
                                                      <div className='fied-miss'>

                                                        {thirdformInfo.foods_error == true ? 'Field missing' : ''}
                                                      </div>


                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.foods == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_foods} onChange={handleChangeThird}
                                                      name="explain_foods" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_foods_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>50.</p><p className='num-data-sec'> Have you ever had an eating disorder?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="eating_disorder" checked={thirdformInfo.eating_disorder == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="eating_disorder" checked={thirdformInfo.eating_disorder == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="eating_disorder" checked={thirdformInfo.eating_disorder == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />
                                                      <div className='fied-miss'>

                                                        {thirdformInfo.eating_disorder_error == true ? 'Field missing' : ''}
                                                      </div>



                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                            {thirdformInfo.eating_disorder == 'Yes' ?
                                              <div className='row margin-top'>
                                                <div className='col-md-6'>
                                                  <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                    <textarea class="textarea-input" type="text" id="fname"
                                                      value={thirdformInfo.explain_eating_disorder} onChange={handleChangeThird}
                                                      name="explain_eating_disorder" placeholder="" rows="4" cols="50"></textarea>
                                                    <p className='error-msg-frm '>
                                                      <span>
                                                        {thirdformInfo.explain_eating_disorder_error == true ? 'Please enter the explanation' : ''}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div> : ''}
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above '>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>51.</p><p className='num-data-sec'> Do you have any concerns that you would like to discuss with a doctor?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="doctor" checked={thirdformInfo.doctor == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="doctor" checked={thirdformInfo.doctor == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="doctor" checked={thirdformInfo.doctor == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.doctor_error == true ? 'Field missing' : ''}

                                                      </div>

                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>

                                          </div>

                                          {thirdformInfo.doctor == 'Yes' ?
                                            <div className='row margin-top'>
                                              <div className='col-md-6'>
                                                <div class="std-form-inner other-sec"><label>Explain</label><p class="float-left">:</p>
                                                  <textarea class="textarea-input" type="text" id="fname"
                                                    value={thirdformInfo.explain_doctor} onChange={handleChangeThird}
                                                    name="explain_doctor" placeholder="" rows="4" cols="50"></textarea>
                                                  <p className='error-msg-frm '>
                                                    <span>
                                                      {thirdformInfo.explain_doctor_error == true ? 'Please enter the explanation' : ''}
                                                    </span>
                                                  </p>
                                                </div>
                                              </div>
                                            </div> : ''}
                                        </div>
                                      </div>

                                      {/* medical questions end section */}

                                      {/* family only section start */}

                                      <div class="medician-sec general-ques">

                                        <div class="row">
                                          <div class="col-md-12">
                                            <div class="physici-sec-head">
                                              <h2>FEMALES ONLY</h2>
                                            </div>
                                          </div>

                                        </div>

                                        <div className='row'>
                                          <div className='medi-details-sec gener-ques'>


                                            <div className='radio-sec-medi-details radio-above'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>52.</p><p className='num-data-sec'> Have you ever had a menstrual period?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group" className='radio-secss'
                                                    >
                                                      <FormControlLabel value="Yes"


                                                        name="menstrual" checked={thirdformInfo.menstrual == 'Yes'}
                                                        onChange={handleChangeThird} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value="No"


                                                        name="menstrual" checked={thirdformInfo.menstrual == 'No'}
                                                        onChange={handleChangeThird} control={<Radio />} label="No" />
                                                      <FormControlLabel value="Don't Know"


                                                        name="menstrual" checked={thirdformInfo.menstrual == "Don't Know"}
                                                        onChange={handleChangeThird}

                                                        control={<Radio />} label="Don't Know" />

                                                      <div className='fied-miss'>

                                                        {thirdformInfo.menstrual_error == true ? 'Field missing' : ''}
                                                      </div>

                                                    </RadioGroup>


                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above fam-about'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>53.</p><p className='num-data-sec'> How old were you when you had your first menstrual period?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <div class="form-inner form-date-sec form-sportss form-new-sportsss">
                                                      <input type="text"
                                                        value={thirdformInfo.menstrual_period} onChange={handleChangeThird}
                                                        name="menstrual_period" class="text-date text-datess" style={{ width: '100%', maxWidth: '90px' }} /></div>
                                                    <p className='error-msg-frm'>
                                                      <span>{thirdformInfo.menstrual_period_error == true ? 'Please enter the value' : ''}</span></p>

                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>
                                            <div class="">
                                              <hr />
                                            </div>

                                            <div className='radio-sec-medi-details radio-above fam-about'>
                                              <FormControl>
                                                <div className='row'>
                                                  <div className='col-md-7'>
                                                    <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                      <p className='num-sec'>54.</p><p className='num-data-sec'> How many periods have you had in the last 12 months?</p>
                                                    </FormLabel>
                                                  </div>

                                                  <div className="col-md-5">
                                                    <div class="form-inner form-date-sec form-sportss form-new-sportsss">
                                                      <input type="text"
                                                        value={thirdformInfo.periods} onChange={handleChangeThird}
                                                        name="periods" class="text-date text-datess" style={{ width: '100%', maxWidth: '90px' }} /></div>
                                                    <p className='error-msg-frm'>
                                                      {thirdformInfo.periods_error == true ? 'Please enter the value' : ''}</p>
                                                  </div>
                                                </div>

                                              </FormControl>
                                            </div>



                                          </div>
                                        </div>
                                      </div>


                                      {/* family only section end */}




                                      {/* acknowledge section start */}
                                      <div class="medician-sec general-ques family-sec">
                                        <div className='row'>
                                          <div className='medi-details-sec gener-ques'>
                                            <div className='col-md-12'>
                                              <h2>I hereby state that, to the best of my knowledge, my answers to the above questions are complete and correct.</h2>

                                            </div>

                                          </div>
                                        </div>
                                        <div className='sign-sec-main'>
                                          <div class="row">
                                            <div class="col-md-9">
                                              <div class="sign-sec">
                                                <p>Signature of Athlete  </p>
                                                <p class="colon-sec">:</p>
                                                <input class="text-input-sign cusrive-font-sec"
                                                  value={thirdformInfo.athlete_signature} onChange={handleChangeThird}
                                                  name="athlete_signature" type="text" id="fname" placeholder="" />

                                                <p class="error-msg-frm"><span>  {thirdformInfo.athlete_signature_error == true ? 'Please enter the signature of athlete' : ''}
                                                </span></p>


                                              </div>
                                            </div>

                                          </div>

                                          <div class="row">
                                            <div class="col-md-9">
                                              <div class="sign-sec">
                                                <p>Signature of Parent/Guardian  </p>
                                                <p class="colon-sec">:</p>
                                                <input class="text-input-sign cusrive-font-sec" type="text"
                                                  value={thirdformInfo.parent_signature} onChange={handleChangeThird}
                                                  name="parent_signature" id="fname" placeholder="" />
                                                <p class="error-msg-frm"><span>
                                                  {thirdformInfo.parent_signature_error == true ? 'Please enter the signature of parent/guardian' : ''}
                                                </span>
                                                </p>
                                              </div>
                                            </div>
                                            <div class="col-md-3">


                                              <div className='form-date-sec form-date-nbw'>
                                                <label >Date </label>

                                                <div className='sign-sec'>

                                                  <p className='colon-sec'>:</p>
                                                  <p style={{ fontWeight: '400', marginLeft: '9px', paddingTop: '7px' }}>{formDate}</p>
                                                </div>
                                              </div>

                                            </div>
                                          </div>
                                          <div className='declare-sec'>
                                            <div className='row'>
                                              <div className='col-md-12'>

                                                <p>©2010 American Academy of Family Physicians. American Academy of Pediatrics, American College of Sports Medicine, American Medical
                                                  Society for Sports Medicine, American Orthopaedic Society for Sports Medicine, and American Osteopathic Academy of Sports Medicine.
                                                  Permission is granted to reprint for noncommercial, educational purposes with acknowledgment.</p>

                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>


                                      {/* acknowledge section end */}
                                    </>}






                                  <div className='row'>
                                    <div className='col-md-12'>
                                      <div class="login-submit login-submitss login-toltip">
                                        {(allstudentlisdata.length > 0 && userExists(allstudentlisdata, 3) == true) ?
                                          <>
                                            {(pdfExists(allstudentlisdata, userData.stuid + '_1_preparticipation_physical_evaluation_history_form.pdf') == true)

                                              ?

                                              <>

                                                <button class="btn btn-login btn-submit bt-forms bt-fill-newfrms btn-edits"
                                                  onClick={(e) => handleOpenLogacc(3)}
                                                >EDIT</button>
                                                {/*<a
                                                  title="Download" 
                                                
                                                 onClick={(e) => handleDownloadFile(userData.stuid,3,userData.stuid + '_1_preparticipation_physical_evaluation_history_form.pdf')}

                                        target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>*/}

                                                <Timer
                                                  startDateTime={getFormData(3).created_at}
                                                  downloadFile={(userData.stuid + "_1_preparticipation_physical_evaluation_history_form.pdf")}
                                                  stuid={userData.stuid}
                                                  formId={3}
                                                  handleDownloadFile={handleDownloadFile}
                                                  handleTimerComplete={handleTimerComplete}
                                                  handleReqFormDownload={handleReqFormDownload}
                                                />


                                              </>

                                              :
                                              <>
                                                {/*<a
                                                  title="Download" 
                                                  
                                          
                                              onClick={(e) => handleDownloadFile(userData.stuid,3,userData.stuid + '_2_preparticipation_physical_evaluation_history_form.pdf')}

                                      target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>*/}
                                                <Timer
                                                  startDateTime={getFormData(3).created_at}
                                                  downloadFile={(userData.stuid + "_2_preparticipation_physical_evaluation_history_form.pdf")}
                                                  stuid={userData.stuid}
                                                  formId={3}
                                                  handleDownloadFile={handleDownloadFile}
                                                  handleTimerComplete={handleTimerComplete}
                                                  handleReqFormDownload={handleReqFormDownload}
                                                />
                                              </>

                                            }

                                          </>
                                          : <button class="btn btn-login btn-submit bt-forms" onClick={handleSubmitThird}>Submit
                                            {
                                              parentLoaderThird != '' ?
                                                <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                                                : ''

                                            }
                                          </button>
                                        }
                                      </div>

                                      {
                                        successMsgThird != '' ? <div className="success-msg success-login form-success ">
                                          <p className="success-msg success-login">{successMsgThird}</p>
                                        </div> : <div className="success-msg success-login form-success " style={{ visibility: 'hidden' }} >
                                          <p className="success-msg success-login">Form Submitted Successfully</p>
                                        </div>
                                      }


                                      {
                                        errorMsgThird != '' ? <div className="error-msg error-login form-error " >
                                          <p className="error-msg error-login">{errorMsgThird}</p>
                                        </div> : <div className="error-msg error-login form-error " style={{ visibility: 'hidden' }} >
                                          <p className="error-msg error-login">Wrong credentials!</p>
                                        </div>
                                      }

                                    </div>
                                  </div>



                                </div>

                              </Typography>
                            </AccordionDetails>
                          </Accordion>

                        </div>

                      </Typography>
                    </AccordionDetails>
                  </Accordion>




                </div>
              </div>
            </div>
          </div>
        </div>
      </div>















      {/* modal section start */}



      <BootstrapDialog
        onClose={handleCloselog}
        aria-labelledby="customized-dialog-title"
        open={openLog} className="route-view copy-view logout-view  club-modal clear-form">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloselog}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div className='copy-sec-modal logout-sec-modal add-club-sec' style={{ paddingTop: '0px' }}>
              {/* <h2 style={{color:'#57585A',paddingTop:'0px'}}>Logout</h2> */}

              <h2>Please wait, while we check your form</h2>


              <div className='check-sec modal-check-sec'>


                <div className='row'>
                  <div className='col-md-12'>
                    <div className='login-submit login-submitss modal-submit login-clear'>

                    </div>
                  </div>
                </div>
              </div>
            </div>


          </Typography>
        </DialogContent>
      </BootstrapDialog>



      <BootstrapDialog
        onClose={handleCloselogaccb}
        aria-labelledby="customized-dialog-title"
        open={openLogacc} className="route-view copy-view logout-view  club-modal clear-form new-form-modal under-main">
        <BootstrapDialogTitle className="close-routeview fill-cls-rut" id="customized-dialog-title" onClose={handleCloselogaccb}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div className='copy-sec-modal logout-sec-modal add-club-sec fill-sec' style={{ paddingTop: '0px' }}>
              {/* <h2 style={{color:'#57585A',paddingTop:'0px'}}>Logout</h2> */}

              <h2 style={{ paddingTop: '5px' }}>Filling up a new Form</h2>


              <div className='check-sec modal-check-sec'>


                <div className='row'>
                  <div className='col-md-12' style={{ marginTop: '12px', marginBottom: '8px' }}>
                    <p className="para-fill">I understand that I will be filling up a new form and my previous form will be not be available for use. Furthermore I will not be able to make anymore changes to this Form.  </p>

                  </div>
                  <div className='col-md-12'>
                    <div className='login-submit login-submitss modal-submit login-clear understnd-sec' style={{ marginTop: '0px', marginBottom: '10px' }}>
                      {/* <button className='btn btn-cancel btn-login btn-down btn-no btn-cancl' onClick={() => {handleCloselogaccb()}}>CANCEL</button>
                     */}
                      <FormGroup className='radio-sec'>
                        <FormControlLabel label="I understand" control={<Checkbox />}
                          checked={checkprf} onChange={handleChangecheckpr} />

                      </FormGroup>
                      <button className='btn btn-login btn-submit btn-pro btn-prcd btn-procds' style={{ marginBottom: '5px', marginTop: '0px' }}
                        disabled={checkprf == false ? 'disabled' : false} onClick={() => { handleEdit(valueacc) }}>PROCEED </button>

                    </div>
                  </div>
                </div>
              </div>
            </div>


          </Typography>
        </DialogContent>
      </BootstrapDialog>


      <BootstrapDialog
        onClose={handleCloseChecklog}
        aria-labelledby="customized-dialog-title"
        open={opencheckLog} className="route-view copy-view logout-view  club-modal clear-form">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloseChecklog}>

        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div className='copy-sec-modal logout-sec-modal add-club-sec' style={{ paddingTop: '0px' }}>
              {/* <h2 style={{color:'#57585A',paddingTop:'0px'}}>Logout</h2> */}

              <h2>Contact School admin, this feature is under development.</h2>


              <div className='check-sec modal-check-sec'>


                <div className='row'>
                  <div className='col-md-12'>
                    <div className='login-submit login-submitss modal-submit login-clear'>

                    </div>
                  </div>
                </div>
              </div>
            </div>


          </Typography>
        </DialogContent>
      </BootstrapDialog>


      <BootstrapDialog
        onClose={closeAllDownload}
        aria-labelledby="customized-dialog-title"
        open={openAllDownload} className="route-view copy-view logout-view  club-modal clear-form">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={closeAllDownload}>

        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div className='copy-sec-modal logout-sec-modal add-club-sec' style={{ paddingTop: '0px' }}>
              <h5 className="text-center">Completed Forms List</h5>
              <div class="form-text text-center">Receive your completed forms via email.</div>
              <ul className="list-group all_forms_down_list list-group-flush">
                {getCompletedForms().map((item, index) => (
                  <li key={index} className="list-group-item">
                    <FormGroup className='radio-sec'>
                      <FormControlLabel
                        label={item.lable}
                        control={<Checkbox name={`form_${item.id}`} />}
                        checked={downloadFroms[`form_${item.id}`] || false} onChange={handleOnChangeDownloadForm} />
                    </FormGroup>
                  </li>
                ))}
              </ul>
              <div className="text-center" style={{ marginTop: '10px' }}>
                <button className='btn btn-login btn-submit btn-pro btn-prcd btn-procds' style={{ marginBottom: '5px', marginTop: '0px' }}
                  disabled={(allFormDownloadProcess || !checkIsAllFormChecked()) ? 'disabled' : false} onClick={handleDownloadAllFromSubmit}>
                  {
                    allFormDownloadProcess ?
                      <>
                        SUBMIT <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </>
                      :
                      <>
                        SUBMIT
                      </>
                  }


                </button>
              </div>
              <div style={{ marginBottom: '20px' }}>
                {
                  allFromDownloadSuccess ?
                    <div className="success-msg success-login success-new-msg">
                      <p className="success-msg success-login" >{allFromDownloadSuccess}</p>
                    </div>
                    : null
                }
                {
                  allFromDownloadError ?
                    <div className="error-msg error-login" >
                      <p className="error-msg error-login">{allFromDownloadError}</p>
                    </div>
                    : null
                }

              </div>
            </div>
          </Typography>
        </DialogContent>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleCloselogaccbspecial}
        aria-labelledby="customized-dialog-title"
        open={openLogaccspecial} className="route-view copy-view logout-view  club-modal clear-form new-form-modal under-main">
        <BootstrapDialogTitle className="close-routeview fill-cls-rut" id="customized-dialog-title" onClose={handleCloselogaccbspecial}>

        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div className='copy-sec-modal logout-sec-modal add-club-sec fill-sec' style={{ paddingTop: '0px' }}>
              {/* <h2 style={{color:'#57585A',paddingTop:'0px'}}>Logout</h2> */}

              <h2 style={{ paddingTop: '5px' }}>This form is only for Special Need Children</h2>


              <div className='check-sec modal-check-sec'>


                <div className='row'>
                  <div className='col-md-12' style={{ marginTop: '12px', marginBottom: '8px' }}>
                    <p className="para-fill">Kindly fill up this form only if you are a special need child or parent of a special need child.   </p>

                  </div>
                  <div className='col-md-12'>
                    <div className='login-submit login-submitss modal-submit login-clear understnd-sec' style={{ marginTop: '0px', marginBottom: '10px' }}>

                      <FormGroup className='radio-sec'>
                        <FormControlLabel label="I am a special need child " control={<Checkbox />}
                          checked={checkprfspecial} onChange={handleChangecheckprspecial} />

                      </FormGroup>

                      <FormGroup className='radio-sec'>
                        <FormControlLabel label="I am not a special need child " control={<Checkbox />}
                          onClick={() => { handleCloselogaccbspecial() }} />

                      </FormGroup>
                      {/* <button className='btn btn-login btn-submit btn-pro btn-prcd btn-procds' style={{ marginBottom: '5px', marginTop: '0px' }}
                        disabled={checkprfspecial == false ? 'disabled' : false} 
                        
                        onClick={() => { handleEditspecial(valueaccspecial) }}>PROCEED</button>
                         <button className='btn btn-cancel btn-login btn-down btn-no btn-canclchi' style={{marginTop:'-5px'}} onClick={() => {handleCloselogaccbspecial()}}>I am not a special need child</button> */}

                    </div>
                  </div>
                </div>
              </div>
            </div>


          </Typography>
        </DialogContent>
      </BootstrapDialog>


      <BootstrapDialog
        onClose={handleClosedischolllog}
        aria-labelledby="customized-dialog-title"
        open={opendischolllog} className="route-view copy-view logout-view  club-modal clear-form new-form-modal under-main chang-sch-modle">
        <BootstrapDialogTitle className="close-routeview fill-cls-rut" id="customized-dialog-title" onClose={handleClosedischolllog}>

        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div className='copy-sec-modal logout-sec-modal add-club-sec fill-sec' style={{ paddingTop: '0px' }}>




              <div className='check-sec modal-check-sec'>


                <div className='row'>
                  <div className='col-md-12' style={{ marginTop: '12px', marginBottom: '17px' }}>
                    <p className="para-fill chage-para-fill">I  am confirm the student participates in </p>

                    <div className='change-selcts'>
                      <Autocomplete
                        id="tags-standard"
                        openOnFocus
                        // open={openseleauto}
                        //openOnFocus={() => setOpenseleauto(true)}    // Keeps the Autocomplete open
                        // onClose={() => setOpenseleauto(false)}  // Closes the Autocomplete
                        value={searchValue || null}
                        options={locations}
                        getOptionLabel={(option) => option.locationName}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        onChange={(event, newValue) => {
                          handleAutocompleteChange(newValue);
                        }}
                        inputValue={inputValue} // Control input text

                        onInputChange={(event, newInputValue) => {
                          setInputValue(newInputValue);
                          if (newInputValue && inputLoadValue == true) {
                            setOpenseleauto(true); // Open dropdown when typing
                          } else {

                            setOpenseleauto(false); // Close dropdown when input is cleared
                          }
                        }}
                        open={openseleauto}
                        onClose={() => setOpenseleauto(false)} // Open dropdown if there's input
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            placeholder="Select School"
                          />
                        )}
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option.id}>
                              {option.locationName}
                            </li>
                          );
                        }}
                        renderTags={(tagValue, getTagProps) => {
                          return tagValue.map((option, index) => (
                            <Chip {...getTagProps({ index })} key={option.id} label={option.locationName} />
                          ))
                        }}
                      />
                      <a className="change-sec"
                        // onClick={() => setOpenseleauto(true)}
                        onClick={() => handleAutocompleteChangenew()}

                      >Change</a>
                    </div>
                    {/* for sports athletic club. */}
                    <p className='content-modal-chg'> for sports athletic club.</p>
                    {/* </p> */}

                  </div>
                  <div className='col-md-12'>
                    <div className='login-submit login-submitss modal-submit login-clear understnd-sec' style={{ marginTop: '0px', marginBottom: '10px' }}>
                      {submitch == 'first' &&
                        <button className='btn btn-login btn-submit btn-pro btn-prcd btn-procds' style={{ marginBottom: '5px', marginTop: '0px' }}
                          onClick={handleSubmitFirst}
                        >Submit </button>

                      }

                      {submitch == 'second' &&
                        <button className='btn btn-login btn-submit btn-pro btn-prcd btn-procds' style={{ marginBottom: '5px', marginTop: '0px' }}
                          onClick={handleSubmitSecond}
                        >Submit </button>

                      }
                      {submitch == 'ten' &&
                        <button className='btn btn-login btn-submit btn-pro btn-prcd btn-procds' style={{ marginBottom: '5px', marginTop: '0px' }}
                          onClick={handleSubmitTen}
                        >Submit </button>

                      }
                      {submitch == 'nine' &&
                        <button className='btn btn-login btn-submit btn-pro btn-prcd btn-procds' style={{ marginBottom: '5px', marginTop: '0px' }}
                          onClick={handleSubmitNine}
                        >Submit </button>

                      }
                      {submitch == 'eieght' &&
                        <button className='btn btn-login btn-submit btn-pro btn-prcd btn-procds' style={{ marginBottom: '5px', marginTop: '0px' }}
                          onClick={handleSubmitEight}
                        >Submit </button>

                      }
                      {submitch == 'seven' &&
                        <button className='btn btn-login btn-submit btn-pro btn-prcd btn-procds' style={{ marginBottom: '5px', marginTop: '0px' }}
                          onClick={handleSubmitSeven}
                        >Submit </button>

                      }
                      {submitch == 'six' &&
                        <button className='btn btn-login btn-submit btn-pro btn-prcd btn-procds' style={{ marginBottom: '5px', marginTop: '0px' }}
                          onClick={handleSubmitSix}
                        >Submit </button>

                      }
                      {submitch == 'third' &&
                        <button className='btn btn-login btn-submit btn-pro btn-prcd btn-procds' style={{ marginBottom: '5px', marginTop: '0px' }}
                          onClick={handleSubmitThird}
                        >Submit </button>

                      }
                      {submitch == 'five' &&
                        <button className='btn btn-login btn-submit btn-pro btn-prcd btn-procds' style={{ marginBottom: '5px', marginTop: '0px' }}
                          onClick={handleSubmitFifth}
                        >Submit </button>

                      }
                      {submitch == 'four' &&
                        <button className='btn btn-login btn-submit btn-pro btn-prcd btn-procds' style={{ marginBottom: '5px', marginTop: '0px' }}
                          onClick={handleSubmitForth}
                        >Submit </button>

                      }


                    </div>
                  </div>
                </div>
              </div>
            </div>


          </Typography>
        </DialogContent>
      </BootstrapDialog>


      {/* modal section end */}
    </>
  )
}

export default Forms;